/**
 * seoLandingPagesTierH.js — Iter 194 Tier-H JA-primary expansion (10 net-new).
 *
 * Cluster 3 — 割引制度 (ETC discounts) deep dive.
 *
 * Topics #1, #2, #10 from the user's plan were duplicates of existing
 * Tier-D/E/F guides; user-approved substitutions applied:
 *   #1 (深夜割引)   → REPLACED with 「ETC割引の併用可否と優先順位」
 *   #2 (平日朝夕)   → REPLACED with 「ETCマイレージサービスの登録手順と注意点」
 *   #10 (休日割引)  → REPLACED with 「ETC割引をカード別・車両別に確認する方法」
 *
 *   1. etc-warikibi-heiyou-junjo-guide               (replacement)
 *   2. etc-mileage-service-registration-howto       (replacement)
 *   3. etc-mileage-points-check-howto               マイレージポイント確認
 *   4. etc-warikibi-meisai-hannei-timing             割引反映タイミング
 *   5. tsuukin-pass-shakai-jikken-etc-warikibi      通勤パス社会実験
 *   6. etc-2-warikibi-taishou-douro-guide            ETC2.0割引対象道路
 *   7. etc-shuyu-pass-meisai-howto                   周遊パス明細
 *   8. shougaisha-warikibi-etc-meisai-guide          障がい者割引
 *   9. oguchi-tahindo-warikibi-houjin-etc-kanri      大口・多頻度割引
 *  10. etc-warikibi-card-vehicle-betsu-check-howto   (replacement)
 *
 * Editorial guardrails (never bend):
 *  - JTRはETC利用照会サービス・NEXCO・ETCマイレージサービス・首都高・MEISAIの公式ではない
 *  - 割引内容は道路・車種・時間帯・登録状況・区間・将来の制度変更で変動と添える
 *  - 「PDF + CSV」を統一表現とし「Excel」「.xlsx」は使わない
 *  - JTRは「確認を支援」「整理に役立つ」「候補を確認」「利用傾向を確認」「割引適用状況の確認を補助」
 *  - 絶対表現禁止: 完全, 一切, 必ず, 確実に割引される, 自動的に全て判定, 不正検出
 */

const REF_ETC_MILEAGE = { label: 'ETCマイレージサービス（公式）', url: 'https://www.smile-etc.jp/', note: 'マイレージ登録・各種ETC割引制度の窓口' };
const REF_GOETC = { label: 'go-etc.jp — ETCカード総合情報', url: 'https://www.go-etc.jp/', note: 'ETCカード・割引制度・ETC2.0の公式情報' };
const REF_GOETC_DISCOUNT = { label: 'go-etc.jp — ETC割引の概要', url: 'https://www.go-etc.jp/etc/discount.html', note: 'ETC各種割引の公式案内ページ' };
const REF_ETC_MEISAI = { label: 'ETC利用照会サービス（公式）', url: 'https://www.etc-meisai.jp/', note: '通行明細・利用証明書PDF・利用明細CSVの公式出力先' };
const REF_NEXCO_E = { label: 'NEXCO東日本（公式）', url: 'https://www.e-nexco.co.jp/', note: '東日本管内の高速道路情報' };
const REF_NEXCO_C = { label: 'NEXCO中日本（公式）', url: 'https://www.c-nexco.co.jp/', note: '中日本管内の高速道路情報' };
const REF_NEXCO_W = { label: 'NEXCO西日本（公式）', url: 'https://www.w-nexco.co.jp/', note: '西日本管内の高速道路情報' };
const REF_SHUTOKO = { label: '首都高速道路（公式）', url: 'https://www.shutoko.jp/', note: '首都高速の通行料金・割引情報' };
const REF_HANSHIN = { label: '阪神高速道路（公式）', url: 'https://www.hanshin-exp.co.jp/', note: '阪神高速の通行料金・割引情報' };
const REF_JBHC = { label: 'JB本四高速（公式）', url: 'https://www.jb-honshi.co.jp/', note: '本州四国連絡橋（瀬戸大橋・しまなみ海道等）の通行料金・割引' };
const REF_MLIT = { label: '国土交通省（MLIT）', url: 'https://www.mlit.go.jp/', note: '高速道路政策の公式情報源' };
const REF_OGUCHI = { label: 'NEXCO東日本 大口・多頻度割引', url: 'https://www.e-nexco.co.jp/etc/discount/business.html', note: '法人向け大口・多頻度割引制度の公式案内' };

const RELATED_FEATURES_CORE = [
  { title: '無料週次レポート', desc: '週1回のメール配信。無期限・無料・カード登録不要。', path: '/free-weekly' },
  { title: 'プレミアム毎日レポート', desc: '前日のETC通行明細をPDF + CSVで毎朝自動配信。', path: '/personal/features' },
  { title: 'ビジネススイート', desc: '法人向けの車両別・部署別配信・経費按分支援。', path: '/business/features' },
  { title: 'PDF + CSV エクスポート', desc: '会計ソフト・スプレッドシートとの互換性。Excel不要。', path: '/guides/etc-pdf-csv-download-guide' },
];

export const TIER_H_PAGES = [
  // 1) ETC割引の併用可否と優先順位 (replacement for duplicate #1)
  {
    slug: 'etc-warikibi-heiyou-junjo-guide',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETC 割引 重複',
      en: 'ETC discount stacking',
    },
    ja: {
      title: 'ETC割引の重複適用と優先順位 | 確認方法を解説 – JTR',
      metaDesc: 'ETC各種割引（休日割引・深夜割引・平日朝夕割引・ETC2.0・障害者割引）の組み合わせ条件と適用優先順位を整理。複数条件が重なる場合にどの割引が当たるか、ETC利用照会サービスのPDF利用証明書・CSV明細で実際の適用結果を確認する手順、独立サービスJTRで継続記録する運用までカバー。',
      h1: 'ETC割引の重複適用と優先順位',
      primaryKeyword: 'ETC 割引 重複',
      answer: 'ETC割引には時間帯・ルート・カード種別・登録状況など様々な条件があり、単一の重複ルールは存在しません。実際の適用可否は各プランの公式ページと利用明細の請求額で確認することが最も安全です。JTRは記録の整理を支援しますが、割引判定は公式の料金システムと各事業者規約に従います。',
      whyMatters: '長距離ドライバーや物流車両では、休日・深夜・ETC2.0・マイレージ・周遊パス・コーポレートカード割引など複数条件が同時に発生する場合があります。各プログラムは時間帯型・距離型・登録型・後日還元型など性質が異なるため、「どちらが優先されるか」「重複適用されるか」は個別規約次第です。誤った想定で経費申請すると、実際の請求額と乖離し後日修正や説明が必要になります。公式記録と規約を確認する習慣が、正確な経理処理と無用なトラブル防止につながります。',
      officialBackground: 'ETC割引の適用可否と優先順位は、NEXCO各社・首都高速・阪神高速など道路事業者とETCマイレージサービス・ETC利用照会サービスが管理する公式規約により決定されます。例えばNEXCO東日本のドラぷら割引概要ページでは各割引ごとに適用条件と注意事項が記載され、周遊パスFAQでは「マイレージ還元は適用されるが、休日・深夜・平日朝夕などは重複適用されない」旨が明記されています。コーポレートカード大口・多頻度割引のページでは「平日朝夕割引と大口割引の対象部分は重複しない」と記載されています。ETC2.0割引は料金所表示やETC車載器に即時表示されない場合があり、最終請求額はETC利用照会サービスまたはカード明細で確認する必要があります。',
      whoFor: [
        '休日・深夜・ETC2.0など複数条件が重なる可能性がある長距離ドライバー',
        '周遊パス・コーポレートカード・マイレージを併用する物流事業者',
        '予想と異なる請求額が発生した際に原因を確認したい経理担当者',
        '通勤パス・周遊パス導入時に割引処理への影響を判断したい管理者',
      ],
      jtrSolution: {
        intro: 'JTRはNEXCO・MEISAI・ETC利用照会サービス・料金事業者とは独立したサービスとして、ETC利用記録の受信・整理・保管を支援します。割引判定や料金決定は行いませんが、公式記録を定期的に受け取り整理することで、人による確認作業を効率化します。',
        bullets: [
          'ETC利用記録をPDF・CSV形式で定期受信し、月次フォルダに自動整理',
          'カード別・日別の一覧表示により、複数条件が重なった日の記録を素早く特定',
          '公式明細と並べて確認することで、想定割引との差異を早期発見',
          '受信記録はメール配信されるため、経理担当者が月末まで待たずに確認可能',
          '公式サービスへのリンク案内により、規約・照会・マイレージ確認への導線を整備',
        ],
      },
      pdfCsv: 'JTRが提供する記録はPDF形式(証明書様式)とCSV形式(表計算ソフト取込用)です。PDFは社内承認や保管に適し、CSVは日付・金額・区間での並べ替えや集計作業に便利です。どちらも公式の利用記録を整理したもので、割引判定や税務判断を行うものではありません。',
      email: 'JTRはETC利用記録を登録メールアドレスへ定期配信します。紙の明細を待たずに記録が受信ボックスに届くため、ドライバーや経理担当者が早期に内容を確認でき、想定外の割引適用や利用カード間違いなどを月中に発見しやすくなります。配信設定は管理画面で調整可能です。',
      steps: [
        {
          t: '関連する割引制度を洗い出す',
          d: '休日・深夜・マイレージ・ETC2.0・定額周遊パス・コーポレートカード大口など、トリップに該当する可能性のあるプログラムをリストアップします。',
        },
        {
          t: '各プログラムの公式ページを確認',
          d: '一般的なまとめ記事ではなく、NEXCO各社・マイレージサービス・ETC2.0公式サイトで個別プログラムの適用条件と併用ルールを確認します。',
        },
        {
          t: '重複適用・ポイント還元・後付け処理の有無を読む',
          d: 'プログラムごとに即時割引・ポイント還元・後日返還・非併用対象などが記載されているため、該当する項目をチェックします。',
        },
        {
          t: 'ETC利用照会サービスまたはカード明細で実績を確認',
          d: '期待した割引額ではなく、実際に請求・記録された通行料金と内訳を公式記録から確認します。',
        },
        {
          t: '業務利用の場合はPDFとCSVを保管',
          d: '旅行後すぐに公式明細のPDFと利用明細CSVを取得し、推測ではなく実績ベースで経費処理できる状態にします。',
        },
        {
          t: '不明点は道路事業者または経理担当へエスカレーション',
          d: 'ドライバーの記憶や第三者サービスではなく、道路事業者の案内または社内ルールに沿って最終判断を行います。',
        },
      ],
      commonProblems: [
        {
          q: '複数の割引が同時に適用されると思っていたが、明細では一つしか適用されていない',
          a: '多くのプログラムは併用不可ルールを持っています。周遊パス・コーポレートカード大口・平日朝夕などは公式ページで併用条件を明記しているため、該当プログラムのFAQを確認してください。',
        },
        {
          q: '料金所表示やETC車載器画面で割引額が表示されなかった',
          a: 'ETC2.0割引や一部の後日返還型プログラムは料金所通過時に表示されません。最終的な請求額はETC利用照会サービスまたはカード明細で確認する必要があります。',
        },
        {
          q: '休日割引が適用されるはずの土曜日なのに割引されていない',
          a: '一部の休日割引には除外日や対象外区間が設定されています。また、車両区分・道路事業者・対象路線によって条件が異なるため、公式カレンダーと対象区間を確認してください。',
        },
        {
          q: 'JTRのレポートと公式明細で金額が違うように見える',
          a: 'JTRは公式データを整理して配信する独立サービスであり、通行料金や割引を決定する主体ではありません。常にETC利用照会サービスやカード会社明細を最終記録として扱ってください。',
        },
      ],
      examples: [
        {
          who: '周遊パス利用ドライバー',
          use: '定額周遊パスを購入した場合、通常の休日割引や深夜割引が併用されない可能性があるため、プラン公式FAQと最終請求額を確認して精算します。',
        },
        {
          who: 'マイレージサービス登録者',
          use: 'ETCマイレージはポイント還元型のため、即時割引とは表示が異なります。マイレージポータルと明細の両方を確認して実際の還元額を把握します。',
        },
        {
          who: '物流企業の経理担当',
          use: '深夜割引と大口・多頻度割引が同一トリップで併用されるかを、NEXCO公式の大口割引ページで確認してから月次精算を行います。',
        },
        {
          who: '法人カード運用チーム',
          use: 'ETCコーポレートカードの大口割引は通常カードと条件が異なる場合があるため、公式ページで併用・非併用ルールを確認して運用ルールを社内文書化します。',
        },
      ],
      faqs: [
        {
          q: 'JTRは割引の適用可否を判定しますか?',
          a: 'いいえ。JTRは独立した記録配信サービスであり、通行料金や割引の決定主体ではありません。公式記録を整理して配信することで、利用者の確認作業を支援します。',
        },
        {
          q: '料金所の表示金額を最終記録として使えますか?',
          a: '一部の割引や後日調整は料金所表示に反映されません。ETC利用照会サービスやカード明細など公式記録で最終請求額を確認してください。',
        },
        {
          q: '企業はPDFとCSV両方を保管すべきですか?',
          a: '推奨します。PDFは証憑として視認性が高く、CSVは並べ替えや突合作業に適しています。JTRは両形式を定期配信できるため、月次保管フローに組み込めます。',
        },
        {
          q: '割引ルールは変更されることがありますか?',
          a: 'はい。対象期間・除外日・対象区間・プログラム構成は変更される場合があります。常に最新の公式ページを参照してください。',
        },
        {
          q: '期待した割引が適用されない場合、通常はエラーですか?',
          a: 'いいえ。車両区分・除外路線・除外日・登録状態・カード種別・後日還元処理など多数の要因があります。公式記録と条件を照合して原因を特定してください。',
        },
      ],
      relatedFeatures: [
        {
          title: '法人向けプラン',
          desc: '複数ドライバー・複数カードのETC明細を一括受信し、割引適用状況を含む月次記録を整理・保管できます。',
          path: '/business',
        },
        {
          title: '個人向けプラン',
          desc: '長距離ドライバーや個人事業主が、休日・深夜・マイレージなど複数プログラムの実績を定期的に受け取り確認できます。',
          path: '/personal',
        },
        {
          title: 'JTRの仕組み',
          desc: 'JTRが公式ETC記録をどのように取得・整理・配信するか、独立サービスとしての位置付けを詳しく説明します。',
          path: '/how-it-works',
        },
      ],
      references: [
        {
          label: 'NEXCO東日本 ETC割引概要',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: '公式の割引一覧と各プログラムの適用条件・注意事項が記載されています。',
        },
        {
          label: 'NEXCO東日本 周遊パスFAQ例',
          url: 'https://www.driveplaza.com/etc/drawari/tohoku/faq.html',
          note: '定額周遊プランと他割引の併用可否について公式FAQで説明されています。',
        },
        {
          label: 'NEXCO東日本 大口・多頻度割引',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_frequency/',
          note: 'コーポレートカード向け大口割引と他プログラムの非併用ルールが記載されています。',
        },
        {
          label: 'NEXCO東日本 ETC2.0割引',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'ETC2.0専用割引の対象区間と最終請求額確認方法が案内されています。',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: '利用明細・PDF・CSVを確認できる公式サービスです。割引適用の最終確認はこちらで行います。',
        },
      ],
      longBody: 'ETC割引の併用と優先順位は、利用者にとって最も混乱を招きやすいテーマのひとつです。休日割引、深夜割引、ETC2.0割引、ETCマイレージサービスによる還元、各種周遊パス、大口・多頻度割引など複数のプログラムが存在し、それぞれが時間帯・曜日・区間・登録状態・カード種別といった異なる条件で動作するため、単一の併用ルールを一律に説明することは現実的ではありません。まず理解すべき大前提は、割引の適用可否と優先順位は各プログラムの公式ページに記載された規約が決定するという点です。たとえばNEXCO東日本の周遊パスFAQには「ETCマイレージサービスのポイント還元は適用されるが、休日割引や深夜割引、平日朝夕割引は重複適用されない」といった明示があります。また、ETC2.0割引対象区間では、料金所表示や車載器の案内に即座に反映されないケースがあり、最終的な請求額は利用照会サービスやカード明細で確認する必要があります。大口・多頻度割引の場合、ETCコーポレートカード利用時の平日朝夕割引と大口割引の地方部割引は重複しない旨が公式に案内されています。このように、プログラムごとに併用可否の記述が異なるため、ドライバーや経理担当者は期待した割引が適用されていないと感じた際、まず走行日時・車種・カード・区間・登録状態を整理し、該当する公式プログラムページと照合することが不可欠です。よくある誤解として、週末だから通常は休日割引が適用される、深夜に走ったから通常は深夜割引になる、ETC2.0車載器があればすべての道路で割引される、といった思い込みがありますが、実際には対象外区間・除外日・車種制限・登録不備などで適用されないケースが多数存在します。企業利用では、ドライバーの記憶や推測ではなく、ETC利用照会サービスから取得したPDF証明書とCSV明細を月次フォルダに保管し、実際の請求額と公式ルールを突き合わせる運用が推奨されます。Japan Toll Receipts(JTR)は、この照合作業を支援する独立した記録整理サービスです。JTRはNEXCO、MEISAI、ETC利用照会サービス、ETCマイレージサービス、道路会社とは無関係であり、公式な料金データを生成せず、割引適用の判定も行いません。JTRの役割は、利用者が定期的にETC記録をメールで受け取り、PDF・CSV形式で整理・保管できる環境を提供することで、月末まとめ処理の負担を軽減し、走行記録の抜け・誤登録・想定外料金の早期発見を支援する点にあります。割引併用に関する最終的な判断は、通常は公式プログラム規約と利用明細の実額を照らし合わせ、不明点があれば道路会社または社内経理部門へ確認することが安全な手順です。',
    },
    en: {
      title: 'ETC Discount Stacking & Priority Order | Guide – JTR',
      metaDesc: 'How ETC discounts combine and which takes priority. Check holiday, night, ETC2.0 overlaps, read official statements, and verify final charges safely.',
      h1: 'ETC Discount Stacking & Priority Order',
      primaryKeyword: 'ETC discount stacking',
      answer: "ETC discounts vary by time, route, card type, and registration status—no single stacking rule exists. Whether discounts combine or which applies first depends on each program's official terms. The safest way to confirm actual application is to check each plan's official page and your billing statement. JTR organizes your records; discount decisions are governed by official toll systems and operator rules.",
      whyMatters: 'Long-haul drivers and fleet vehicles often trigger multiple conditions at once—holiday, night, ETC2.0, mileage points, tour passes, corporate-card discounts. Because programs differ in nature (time-based, distance-based, registration-based, cashback-based), whether one takes priority or both apply depends on individual terms. Assuming incorrect stacking in expense claims leads to discrepancies against actual charges, requiring later correction and explanation. Checking official records and terms prevents errors and avoids unnecessary disputes.',
      officialBackground: "ETC discount eligibility and priority are governed by official terms from road operators (NEXCO companies, Metropolitan Expressway, Hanshin Expressway) and services like ETC Mileage and ETC Inquiry. For example, NEXCO East's Dra-pla discount overview lists conditions and notes for each plan; tour-pass FAQs state that mileage points accrue but holiday, night, and weekday commuter discounts do not stack. Corporate large-volume discount pages note that weekday commuter and large-volume discounts do not overlap on the same segment. ETC2.0 discounts may not display at the gate or on in-vehicle units; final charges must be verified via ETC Inquiry Service or card statements.",
      whoFor: [
        'Long-haul drivers who may qualify for holiday, night, and ETC2.0 discounts simultaneously',
        'Fleet operators combining tour passes, corporate cards, and mileage programs',
        'Accounting staff investigating charges that differ from expectations',
        'Vehicle managers assessing discount-policy impact before adopting commuter or tour passes',
      ],
      jtrSolution: {
        intro: 'JTR is independent of NEXCO, ETC Usage Inquiry Service (MEISAI), ETC Inquiry Service, and toll operators. We receive, organize, and store your ETC usage records—we do not judge discounts or set tolls. By scheduling regular receipt of official records, we streamline human review.',
        bullets: [
          'Receive ETC records in PDF and CSV, auto-sorted into monthly folders',
          'List trips by card and date to quickly spot days with overlapping conditions',
          'Compare official statements side-by-side to detect discount variances early',
          'Email delivery lets accounting staff review records mid-month, not just at month-end',
          'Links to official services guide you to terms, inquiry portals, and mileage checks',
        ],
      },
      pdfCsv: 'JTR supplies records in PDF format (receipt-style proof) and CSV format (for spreadsheet import). PDFs suit internal approval and archiving; CSVs enable sorting and totaling by date, amount, or route. Both organize official usage data—they do not determine discounts or tax treatment.',
      email: 'JTR delivers ETC records to your registered email address on a schedule. Because records arrive in your inbox without waiting for paper statements, drivers and accounting staff can review content early, spotting unexpected discount application or card mix-ups mid-month. Delivery settings are adjustable in the dashboard.',
      steps: [
        {
          t: 'List all applicable discount programs',
          d: 'Identify all programs that may apply to your trip: holiday, late-night, mileage points, ETC2.0, flat-rate touring passes, corporate card bulk discounts, etc.',
        },
        {
          t: 'Check official pages for each program',
          d: 'Instead of generic summary articles, review the individual program eligibility criteria and stacking rules on NEXCO websites, Mileage Service portals, and ETC2.0 official sites.',
        },
        {
          t: 'Review overlap rules, point accrual, and post-billing adjustments',
          d: 'Each program specifies instant discounts, point redemptions, post-trip refunds, or non-stackable conditions. Check the relevant sections for your programs.',
        },
        {
          t: 'Verify actual charges via ETC Inquiry Service or card statement',
          d: 'Rather than relying on expected amounts, confirm the billed toll and breakdown from official records—the final statement or ETC Inquiry Service.',
        },
        {
          t: 'For business use, archive PDF and CSV after each trip',
          d: 'Download official PDF and CSV files immediately after travel so you can process expenses based on actual usage records, not assumptions.',
        },
        {
          t: 'Escalate unclear cases to road operators or internal accounting',
          d: "Do not rely on driver memory or third-party services. Obtain final guidance from the road operator's helpdesk or follow your company's internal policy.",
        },
      ],
      commonProblems: [
        {
          q: 'I expected multiple discounts to stack, but my statement shows only one applied',
          a: 'Many programs prohibit stacking. Touring passes, corporate bulk discounts, and weekday commuter programs often have explicit non-overlap rules listed in official FAQs. Check the program pages to confirm stacking eligibility.',
        },
        {
          q: 'The tollbooth display or in-vehicle device did not show a discount amount',
          a: 'ETC2.0 discounts and certain post-billing programs do not appear at the time of passage. Check the final billed amount via ETC Inquiry Service or your card statement to see the actual discount applied.',
        },
        {
          q: 'I traveled on Saturday expecting a holiday discount, but it was not applied',
          a: 'Some holiday discounts have blackout dates, excluded sections, or restrictions by vehicle class, operator, or route. Verify the official calendar and eligible segments for your specific program.',
        },
        {
          q: "JTR's report shows a different amount than my official statement",
          a: 'JTR is an independent record delivery service and does not determine toll charges or discounts. typically treat ETC Inquiry Service or card issuer statements as the authoritative record.',
        },
      ],
      examples: [
        {
          who: 'Touring-pass driver',
          use: 'If you purchase a flat-rate touring pass, standard holiday and late-night discounts may not stack. Review the official pass FAQ and final billing to confirm what was charged.',
        },
        {
          who: 'Mileage Service member',
          use: 'ETC Mileage awards points rather than instant discounts, so on-screen displays differ. Check both your mileage portal and card statement to see the actual redemption value.',
        },
        {
          who: 'Logistics company accountant',
          use: 'To determine whether late-night and bulk-frequency discounts stack on the same trip, consult the official NEXCO bulk-discount page before closing monthly books.',
        },
        {
          who: 'Corporate card operations team',
          use: 'ETC corporate card bulk discounts may differ from personal card rules. Review official stacking and non-overlap policies, then document them in internal procedures.',
        },
      ],
      faqs: [
        {
          q: 'Does JTR decide whether a discount applies?',
          a: 'No. JTR is an independent record delivery service and does not determine toll charges or discounts. We organize and deliver official records to help you verify what was billed.',
        },
        {
          q: 'Can I use the tollbooth display amount as the final record?',
          a: 'Some discounts and post-trip adjustments do not appear on tollbooth displays. Confirm the final billed amount via ETC Inquiry Service or your card statement.',
        },
        {
          q: 'Should businesses archive both PDF and CSV?',
          a: 'Yes, we recommend it. PDFs serve as readable receipts; CSVs enable sorting and reconciliation. JTR can deliver both formats on a schedule, so you can integrate them into monthly filing workflows.',
        },
        {
          q: 'Do discount rules ever change?',
          a: 'Yes. Eligibility periods, blackout dates, eligible sections, and program structures may be revised. Refer to the latest official pages whenever you need current rules.',
        },
        {
          q: 'If my expected discount is missing, is it an error?',
          a: 'Not necessarily. Vehicle class, excluded routes, blackout dates, registration status, card type, and post-billing cycles all affect discount application. Cross-check official records against program conditions to identify the cause.',
        },
      ],
      relatedFeatures: [
        {
          title: 'Business Plans',
          desc: 'Receive ETC statements for multiple drivers and cards in one batch, with discount breakdowns included, for organized monthly record-keeping.',
          path: '/business',
        },
        {
          title: 'Personal Plans',
          desc: 'Long-haul drivers and sole proprietors can receive periodic records covering holiday, late-night, mileage, and other program activity.',
          path: '/personal',
        },
        {
          title: 'How JTR Works',
          desc: 'Learn how JTR retrieves, organizes, and delivers official ETC records as an independent service, separate from toll operators.',
          path: '/how-it-works',
        },
      ],
      references: [
        {
          label: 'NEXCO East - ETC Discount Overview',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: 'Official list of discount programs with eligibility criteria and important notes for each.',
        },
        {
          label: 'NEXCO East - Touring Pass FAQ (sample)',
          url: 'https://www.driveplaza.com/etc/drawari/tohoku/faq.html',
          note: 'Official FAQ explaining whether flat-rate touring plans can stack with other discounts.',
        },
        {
          label: 'NEXCO East - Bulk & Frequent-User Discount',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_frequency/',
          note: 'Describes corporate card bulk discounts and non-overlap rules with other programs.',
        },
        {
          label: 'NEXCO East - ETC2.0 Discounts',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'Lists ETC2.0-exclusive discount zones and explains how to confirm final billed amounts.',
        },
        {
          label: 'ETC Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official portal to view usage statements, PDFs, and CSVs. Use this for final discount verification.',
        },
      ],
      longBody: "Combination and priority rules for ETC discounts remain one of the most confusing topics for drivers and fleet administrators. Multiple programs—holiday discounts, late-night discounts, ETC2.0 discounts, ETC Mileage Service point redemptions, touring passes, corporate high-volume discounts—operate under different conditions tied to time of day, day of week, route segment, registration status, and card type, making it impractical to describe a single universal combination rule. The fundamental principle to understand is that applicability and priority are determined by the official terms published on each program's page. For example, NEXCO East's touring pass FAQ explicitly states that ETC Mileage Service point redemption may apply, but holiday, late-night, and weekday commuter discounts do not stack. On ETC2.0 eligible segments, discounts may not appear immediately on the tollgate display or in-vehicle unit, so the final charged amount must be confirmed through the ETC usage inquiry service or card statement. For corporate high-volume discounts, official guidance notes that weekday commuter discounts and regional high-volume discounts do not overlap when using an ETC corporate card. Because combination eligibility varies by program, drivers and accounting staff who notice an expected discount was not applied should first organize the trip date, vehicle class, card used, route, and registration status, then cross-reference the relevant official program page. Common misconceptions include assuming weekend travel typically qualifies for holiday discounts, nighttime driving typically triggers late-night rates, or any ETC2.0 unit guarantees discounts on all roads; in reality, excluded segments, blackout dates, vehicle restrictions, and registration gaps often prevent application. For business use, relying on driver memory or assumptions is discouraged; instead, retrieve PDF certificates and CSV itemizations from the ETC usage inquiry service, store them in monthly folders, and reconcile actual charges against official rules. Japan Toll Receipts (JTR) is an independent record-keeping service that supports this reconciliation workflow. JTR is unaffiliated with NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC usage inquiry service, ETC Mileage Service, or any road operator, and does not generate official toll data or determine discount eligibility. JTR's role is to let users receive ETC records by email on a regular schedule and organize them in PDF and CSV formats, reducing month-end processing burden and helping identify missing trips, registration errors, or unexpected charges early. Final decisions on discount combination must typically compare official program terms with actual statement amounts; when in doubt, contact the road operator or your internal accounting team.",
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: '割引適用の確認フロー',
            intro: '複数条件が重なる場合の確認手順',
            nodes: [
              {
                title: '利用完了',
                desc: '料金所通過・ETC車載器に即時表示',
              },
              {
                title: '公式記録確認',
                desc: 'ETC利用照会サービスで請求額を照会',
              },
              {
                title: '規約参照',
                desc: '各割引プランの公式ページで重複可否を確認',
              },
              {
                title: '明細受信',
                desc: 'カード会社またはJTRから記録を取得',
              },
              {
                title: '差異検証',
                desc: '想定割引と実請求額を比較・記録保管',
              },
            ],
          },
          en: {
            title: 'Discount Verification Flow',
            intro: 'Steps when multiple conditions overlap',
            nodes: [
              {
                title: 'Trip Complete',
                desc: 'Pass toll gate, instant display on ETC unit',
              },
              {
                title: 'Check Official Record',
                desc: 'Query final charge via ETC Usage Inquiry',
              },
              {
                title: 'Review Terms',
                desc: 'Confirm overlap rules on each discount plan page',
              },
              {
                title: 'Receive Statement',
                desc: 'Obtain record from card issuer or JTR',
              },
              {
                title: 'Validate Delta',
                desc: 'Compare expected vs. actual charge, archive',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '割引判定の公式リソース',
            intro: '各プログラムの規約と照会先',
            sources: [
              {
                name: 'NEXCO各社 割引概要',
                role: '時間帯・ルート割引の適用条件',
                url: 'ドラぷら・各社公式サイト',
                scope: '休日・深夜・ETC2.0',
              },
              {
                name: 'ETCマイレージサービス',
                role: 'ポイント還元・周遊パス規約',
                url: 'マイレージ公式ページ',
                scope: 'マイレージ・パス重複可否',
              },
              {
                name: 'ETC利用照会サービス',
                role: '最終請求額の照会',
                url: '利用照会サイト',
                scope: '全車両・全カード',
              },
              {
                name: 'コーポレートカード大口割引',
                role: '事業者向け大口・多頻度割引',
                url: 'NEXCO各社コーポレートページ',
                scope: '平日朝夕との重複処理',
              },
              {
                name: '首都高速・阪神高速',
                role: '都市高速の独自割引',
                url: '各事業者公式サイト',
                scope: '時間帯割引・距離別',
              },
            ],
          },
          en: {
            title: 'Official Discount Resources',
            intro: 'Terms and inquiry endpoints by program',
            sources: [
              {
                name: 'NEXCO Discount Overviews',
                role: 'Time/route discount conditions',
                url: 'Dora-pura, official sites',
                scope: 'Holiday, night, ETC2.0',
              },
              {
                name: 'ETC Mileage Service',
                role: 'Point rebate, tour-pass rules',
                url: 'Mileage official page',
                scope: 'Mileage/pass overlap',
              },
              {
                name: 'ETC Usage Inquiry',
                role: 'Final charge lookup',
                url: 'Inquiry portal',
                scope: 'All vehicles, all cards',
              },
              {
                name: 'Corporate Card Discounts',
                role: 'Large-volume fleet discounts',
                url: 'NEXCO corporate pages',
                scope: 'Overlap with commuter plans',
              },
              {
                name: 'Metro Expressways',
                role: 'Urban toll discounts',
                url: 'City operator sites',
                scope: 'Time/distance tiers',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '割引種別の重複適用パターン',
            intro: '代表的な組み合わせ例（詳細は各公式規約を確認）',
            columns: [
              '休日割引',
              '深夜割引',
            ],
            rows: [
              {
                feature: 'ETC2.0割引',
                a: '重複適用例あり',
                b: '重複適用例あり',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: 'マイレージ還元',
                a: '適用（後日還元）',
                b: '適用（後日還元）',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: '周遊パス',
                a: '多くは重複不可',
                b: '多くは重複不可',
                kindA: 'no',
                kindB: 'no',
              },
              {
                feature: '平日朝夕割引',
                a: '対象外時間帯',
                b: '対象外時間帯',
                kindA: 'neutral',
                kindB: 'neutral',
              },
              {
                feature: '大口・多頻度',
                a: '規約により一部重複',
                b: '規約により一部重複',
                kindA: 'partial',
                kindB: 'partial',
              },
            ],
          },
          en: {
            title: 'Discount Overlap Patterns',
            intro: 'Common combinations (refer to official terms for details)',
            columns: [
              'Holiday Discount',
              'Night Discount',
            ],
            rows: [
              {
                feature: 'ETC2.0 Discounts',
                a: 'Overlap examples exist',
                b: 'Overlap examples exist',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: 'Mileage Rebate',
                a: 'Applies (deferred)',
                b: 'Applies (deferred)',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'Tour Pass',
                a: 'Often non-overlapping',
                b: 'Often non-overlapping',
                kindA: 'no',
                kindB: 'no',
              },
              {
                feature: 'Weekday Commuter',
                a: 'Outside time window',
                b: 'Outside time window',
                kindA: 'neutral',
                kindB: 'neutral',
              },
              {
                feature: 'Fleet/Volume',
                a: 'Partial overlap per terms',
                b: 'Partial overlap per terms',
                kindA: 'partial',
                kindB: 'partial',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '重複割引の確認チェックリスト',
            intro: '想定外の請求額が発生した際の点検項目',
            items: [
              {
                text: 'ETC利用照会サービスで最終請求額を確認したか',
                hint: '車載器表示は即時確定額ではない場合がある',
              },
              {
                text: '各割引プランの公式FAQで重複可否を確認したか',
                hint: '周遊パス・コーポレートカードは個別規約参照',
              },
              {
                text: '利用時間帯が複数割引の対象時間に該当するか',
                hint: '深夜・休日・平日朝夕は時間帯が異なる',
              },
              {
                text: 'ETC2.0車載器登録とカード登録が正しく完了しているか',
                hint: '登録不備は割引適用外になる',
              },
              {
                text: 'マイレージポイント還元は後日反映を前提にしているか',
                hint: '即時割引と還元時期が異なる',
              },
              {
                text: 'カード会社明細とETC利用照会の金額が一致するか',
                hint: '不一致時は事業者へ照会',
              },
            ],
          },
          en: {
            title: 'Overlap Discount Checklist',
            intro: 'Inspection points when charges differ from expectations',
            items: [
              {
                text: 'Confirmed final charge via ETC Usage Inquiry?',
                hint: 'On-board display may not show final amount',
              },
              {
                text: 'Reviewed official FAQ for overlap rules?',
                hint: 'Tour-pass/corporate terms vary by issuer',
              },
              {
                text: 'Trip time falls within multiple discount windows?',
                hint: 'Night, holiday, commuter hours differ',
              },
              {
                text: 'ETC2.0 device and card registrations complete?',
                hint: 'Incomplete registration voids discount',
              },
              {
                text: 'Mileage rebate expected as deferred credit?',
                hint: 'Instant discount vs. later point redemption',
              },
              {
                text: 'Card statement matches ETC inquiry amount?',
                hint: 'Discrepancy requires operator inquiry',
              },
            ],
          },
        },
      },
    ],
  },

  // 2) ETCマイレージサービス登録手順と注意点 (replacement for duplicate #2)
  {
    slug: 'etc-mileage-service-registration-howto',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETCマイレージサービス 登録',
      en: 'ETC mileage service registration',
    },
    ja: {
      title: 'ETCマイレージサービス登録方法 – ポイント・割引の始め方 | JTR',
      metaDesc: 'ETCマイレージサービスへの登録手順、必要情報、ポイント還元と平日朝夕割引の適用条件を実務手順で解説。ETC車載器管理番号・カード番号の入力、ETC利用照会サービスとの併用、ポイント還元状況の確認、PDF・CSV明細での通行記録保管、独立サービスJTRの位置づけと月次運用フローまでまとめました。',
      h1: 'ETCマイレージサービスの登録方法',
      primaryKeyword: 'ETCマイレージサービス 登録',
      answer: 'ETCマイレージサービスは、ETC通行料金に応じてポイントが貯まり、還元額として利用できる公式サービスです。平日朝夕割引の適用にも事前登録が求められます。登録にはETCカード番号・車載器情報が必要で、smile ETCの登録ページから手続きを行い、マイレージIDとパスワードを保管します。登録後は公式マイページでポイント確認、利用証明書・明細はETC利用照会サービスで取得します。',
      whyMatters: '多くのドライバーは割引やポイントが自動適用されると思い込みがちですが、ETCマイレージサービスは事前登録制です。登録を済ませないと平日朝夕割引の対象外となり、ポイントも貯まりません。また、マイレージサービスはポイント管理専用であり、通行明細のPDF・CSVダウンロードはETC利用照会サービスが担当します。この役割分担を理解し、それぞれを正しく使い分けることで、還元と記録管理の両方を効率的に行えます。',
      officialBackground: 'ETCマイレージサービスは道路事業者が運営する公式ポイントプログラムで、登録したETCカードでの通行実績に応じてポイントが付与され、還元額(無料通行分)として交換できます。公式サイト(smile-etc.jp)によれば、新規登録時にはETCカード番号・車両番号・車載器管理番号などを入力し、マイレージIDとパスワードを設定します。NEXCO中日本の案内では、平日朝夕割引の適用にはマイレージサービスへの事前登録が必須とされています。一方、通行明細の照会・利用証明書の発行・PDF/CSVダウンロードはETC利用照会サービス(etc-meisai.jp)が担当し、通常のETCカードは過去15か月分、ETCコーポレートカードは62日分の照会が可能です。ポイント管理と明細管理は別サービスであり、それぞれログイン情報も異なります。',
      whoFor: [
        'ETCカードを取得し、ポイント還元を受けたい新規ドライバー',
        '平日朝夕の通勤でNEXCO割引対象となる可能性がある通勤者',
        '日本語登録画面に不安がある外国人居住者とそのサポート役',
        '個人カードをマイレージ登録しつつ、業務・私用の記録を分けたい個人事業主',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts(JTR)は、公式システムが生成した通行記録を自動受信・整理する独立サービスです。マイレージ登録や割引判定はNEXCO・smile ETCが担当し、JTRは登録後の記録管理を支援します。',
        bullets: [
          '通行後のPDF・CSV明細を指定メールアドレスへ自動配信',
          'カード・車両・月別に記録を整理し、ダウンロード忘れを防止',
          '日英対応のインターフェースで外国人ドライバーも利用しやすい',
          '複数カード・複数車両の記録を一元管理し、経理・精算業務を効率化',
          '公式サイトへの手動ログイン回数を減らし、記録の継続性を保つ',
        ],
      },
      pdfCsv: 'PDF形式は人が読みやすく提出用書類として適し、CSV形式は並べ替え・抽出・月次集計に便利です。業務利用・家計管理・複数カード運用では両形式を保管し、用途に応じて使い分けることで記録の網羅性と検索性を両立できます。',
      email: 'JTRはユーザーが指定したメールアドレスへ通行記録を自動送信します。月次レポートとして受信すれば、記録取得漏れを防ぎ、カード・車両・部署ごとの整理がしやすくなり、経理担当者や家族間での共有も円滑になります。',
      steps: [
        {
          t: 'ETCマイレージサービス対応カードの確認',
          d: 'お持ちのETCカードがマイレージサービスに登録可能か確認します。クレジットカード会社の案内や、カード券面に記載された情報を確認してください。',
        },
        {
          t: '必要情報の準備',
          d: 'ETCカード番号、車両番号、ETC車載器の車載器管理番号(19桁)を手元に用意します。登録時に正確な入力が必要です。',
        },
        {
          t: '公式登録ページへアクセス',
          d: 'ETCマイレージサービス公式サイト(smile-etc.jp)の新規登録ページを開きます。偽サイトに注意し、通常は公式URLを確認してください。',
        },
        {
          t: '登録情報の入力とID作成',
          d: '画面の指示に従い、カード情報・車両情報を正確に入力し、マイレージIDとパスワードを作成します。入力ミスがないよう慎重に進めてください。',
        },
        {
          t: 'マイレージIDとパスワードの保管',
          d: '登録完了後、マイレージIDとパスワードを安全に記録・保管します。ポイント確認やマイページログインに必要です。',
        },
        {
          t: 'ポイント確認と利用記録の管理体制構築',
          d: 'マイページでポイントを確認し、利用証明書やPDF・CSV記録の取得はETC利用照会サービスまたはJTRで行う体制を整えます。',
        },
      ],
      commonProblems: [
        {
          q: 'マイレージ登録すればすべての割引が自動適用されますか?',
          a: 'いいえ。平日朝夕割引などマイレージ登録が要件の割引もありますが、道路・日時・車種・区間により適用条件は異なります。公式情報で最新の適用要件を確認してください。',
        },
        {
          q: 'マイレージサービスで利用証明書を発行できますか?',
          a: 'マイレージサービスはポイント管理が目的です。利用証明書やPDF・CSV記録の発行はETC利用照会サービスで行います。用途に応じて使い分けてください。',
        },
        {
          q: 'JTRはマイレージサービスの公式機能ですか?',
          a: 'いいえ。JTRは独立したサービスです。公式システムが作成した利用データを受け取り、整理・配信する補助ツールであり、NEXCO・ETC利用照会サービス（MEISAI）・政府の関連組織ではありません。',
        },
        {
          q: '登録後すぐにポイントが貯まりますか?',
          a: '登録後の走行分からポイント付与対象になりますが、反映タイミングや対象道路は公式規定によります。ポイント残高は通常はマイページで確認してください。',
        },
      ],
      examples: [
        {
          who: '神奈川県の新規ETCドライバー',
          use: 'ETCカード取得後、通勤開始前にマイレージサービスへ登録し、ポイント付与と平日朝夕割引の要件を満たす準備を行いました。',
        },
        {
          who: '都内からの通勤利用者',
          use: 'NEXCO案内で平日朝夕割引にマイレージ登録が必要と知り、事前登録を完了。利用記録管理はJTRで自動化しています。',
        },
        {
          who: '外国人居住者',
          use: '日本語の登録画面を友人に手伝ってもらい登録完了後、英語対応のJTRで利用記録を受け取る体制を整えました。',
        },
        {
          who: '個人事業主',
          use: '個人カードでマイレージ登録してポイントを貯めつつ、JTRで業務用・私用の走行記録を分類・整理しています。',
        },
      ],
      faqs: [
        {
          q: 'マイレージ登録とETC利用照会サービスのアカウントは同じですか?',
          a: 'いいえ。マイレージサービスとETC利用照会サービスは別システムです。それぞれ異なるID・パスワードで管理され、用途も異なります。',
        },
        {
          q: 'JTRを使えば公式サイトへのアクセスは不要ですか?',
          a: 'いいえ。料金・割引・ポイント・適用ルールの確認は通常は公式サイトで行ってください。JTRは記録の受信・整理を補助するツールです。',
        },
        {
          q: '利用記録はPDFとCSVどちらを保存すべきですか?',
          a: '可能であれば両方保存してください。PDFは人間が読みやすく、CSVは並べ替えや会計処理に適しています。用途に応じて使い分けます。',
        },
        {
          q: '法人カードと個人カードで記録の保存期間は違いますか?',
          a: 'はい。一般的なETCカードは15か月、ETCコーポレートカードは62日間の照会期間が公式案内されています。早めの記録取得をお勧めします。',
        },
        {
          q: 'マイレージ登録後、記録管理で気をつけることは?',
          a: 'マイレージサービスはポイント管理用です。経費精算や税務には利用証明書(PDF・CSV)が必要なため、ETC利用照会サービスやJTRで記録を保管してください。',
        },
      ],
      relatedFeatures: [
        {
          title: 'JTRの仕組み',
          desc: '公式システムが作成した利用記録を自動受信し、PDF・CSV形式でメール配信。手動ダウンロードの手間を省き、記録の見落としを防ぎます。',
          path: '/how-it-works',
        },
        {
          title: 'ビジネス向けプラン',
          desc: '複数カード・車両・部門ごとの利用記録を一元管理。経費精算や月次集計に必要なPDF・CSVを自動で整理・配信します。',
          path: '/business',
        },
        {
          title: '無料トライアル',
          desc: 'JTRの自動記録配信を実際に体験できます。マイレージ登録後の記録管理を効率化したい方におすすめです。',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETCマイレージサービス 新規登録手順',
          url: 'https://www.smile-etc.jp/service/touroku.html',
          note: '公式の登録プロセス説明。マイレージIDとパスワードの役割について詳述されています。',
        },
        {
          label: 'ETCマイレージサービス 登録前のご案内',
          url: 'https://www.smile-etc.jp/mlgtouroku_service.html',
          note: '平日朝夕割引の適用には事前のマイレージ登録が必要である旨が明記されています。',
        },
        {
          label: 'ETCマイレージサービス概要',
          url: 'https://www.smile-etc.jp/service/info.html',
          note: '登録・ポイント・還元額・平日朝夕割引適用要件の公式説明。',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETC利用履歴の確認、利用証明書発行、PDF・CSV記録のダウンロードを行う公式サービス。',
        },
        {
          label: 'ETC総合情報ポータル 利用照会サービス案内',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '一般ETCカード15か月、ETCコーポレートカード62日間の照会期間とPDF・CSV出力機能の公式説明。',
        },
      ],
      longBody: 'ETCマイレージサービスへの登録は、ポイント還元と平日朝夕割引の適用条件を整えるための手続きです。多くのドライバーが「ETCカードを持てば自動的に全ての割引が適用される」と誤解しがちですが、実際にはマイレージサービスへの事前登録が必要な割引制度が存在します。NEXCO中日本の公式案内でも、平日朝夕割引の適用を受けるにはETCマイレージサービスへの登録が必要である旨が明記されています。この登録は無料で、ETCカード番号と車載器管理番号を手元に用意すれば、公式サイト上で完了できます。登録後に発行されるマイレージIDとパスワードは、ポイント照会や還元額申請に使用するため、安全に保管しておく必要があります。ただし、このマイレージサービスはあくまでポイントと割引適用条件を管理する仕組みであり、利用明細の発行や利用証明書の取得はETC利用照会サービスが担当します。この二つのサービスは別々のログイン情報を持ち、役割も異なるため、混同しないよう注意が必要です。登録後の実務では、マイレージサービスのマイページでポイント残高を確認し、利用照会サービスでPDFやCSV形式の利用明細を取得する流れが一般的です。公式ポータルの説明によれば、通常のETCクレジットカードやETCパーソナルカードは15か月間の照会が可能ですが、ETCコーポレートカードは62日間と短いため、企業利用者は早めに記録を保存する必要があります。Japan Toll Receiptsは、この公式記録の取得後に役立つ独立したサービスです。JTRは公式のNEXCOやETCマイレージサービス、MEISAI、政府機関ではなく、利用者が公式システムから取得した記録を自動的に受信・整理・保管する補助ツールとして位置づけられます。具体的には、PDFとCSV形式の利用明細をメールで配信し、複数カードや複数車両、複数月にわたる記録を一元管理できるようサポートします。特に個人事業主や家族利用、複数の部門で車両を共有する企業にとって、毎月手作業でダウンロードする手間を減らし、記録の抜け漏れを防ぐ点で有用です。ただし、割引適用の最終判定や通行料金の確定、公式な利用証明書の発行は、あくまで公式サービスと道路事業者が行うものであり、JTRが代替するものではありません。登録前には自分のETCカードがマイレージ対象かを確認し、登録後は定期的にマイページでポイント状況を確認するとともに、経理処理や精算が必要な場合は公式のPDFおよびCSV記録を保管しておくことが推奨されます。',
    },
    en: {
      title: 'ETC Mileage Service Registration Guide – How to Start | JTR',
      metaDesc: 'Step-by-step guide to registering for ETC Mileage Service. Learn how to qualify for point rebates and weekday discounts, plus how to manage records via PDF & CSV.',
      h1: 'How to Register for ETC Mileage Service',
      primaryKeyword: 'ETC mileage service registration',
      answer: "ETC Mileage Service is the official toll-point program where registered drivers earn points based on toll spending and redeem them as free toll credits. Registration is also required to qualify for weekday morning-evening discounts. You'll need your ETC card number and onboard unit details, register via the smile ETC website, and securely store your mileage ID and password. After registration, check points on the official portal; for itemized toll statements and proof documents, use the ETC Toll Inquiry Service.",
      whyMatters: 'Many drivers assume discounts and points apply automatically, but ETC Mileage Service operates on an opt-in basis. Without prior registration, you remain ineligible for weekday commuter discounts and earn no points. Additionally, the mileage portal handles points only—downloading PDF and CSV toll records is the job of the separate ETC Toll Inquiry Service. Understanding this division of responsibilities lets you claim rebates efficiently while maintaining organized records for accounting and expense reporting.',
      officialBackground: "ETC Mileage Service is an official point program operated by Japan's toll-road authorities. Points accrue based on registered ETC card usage and can be exchanged for toll credits. According to the smile-etc.jp portal, new users enter their ETC card number, vehicle registration, and onboard-unit management number, then create a mileage ID and password. NEXCO Central documentation confirms that weekday morning-evening discounts require advance mileage registration. Meanwhile, toll-statement queries, proof-of-use certificates, and PDF/CSV downloads are handled by the ETC Toll Inquiry Service (etc-meisai.jp), which retains up to 15 months of history for personal cards and 62 days for corporate ETC cards. Point management and statement retrieval are separate systems with distinct login credentials.",
      whoFor: [
        'New ETC cardholders who want to earn point rebates on toll spending',
        'Weekday commuters traveling NEXCO routes during discount-eligible hours',
        'Foreign residents and their support teams navigating Japanese registration forms',
        'Sole proprietors who register personal cards for points yet need separate business and private trip records',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts (JTR) is an independent service that receives and organizes toll records generated by official systems. Mileage registration and discount eligibility remain with NEXCO and smile ETC; JTR supports record management after registration.',
        bullets: [
          'Auto-deliver PDF and CSV toll statements to your chosen email address after each trip',
          'Organize records by card, vehicle, and month to prevent download lapses',
          'Bilingual interface (Japanese and English) for international drivers',
          'Centralize multi-card and multi-vehicle records to streamline accounting and reimbursement',
          'Reduce manual logins to official portals while maintaining continuous record archives',
        ],
      },
      pdfCsv: 'PDF format is human-readable and suited for submission documents; CSV format enables sorting, filtering, and monthly summaries. For business use, household budgeting, or multi-card operations, storing both formats and selecting the right one for each task ensures both coverage and searchability of your toll history.',
      email: 'JTR automatically sends toll records to the email address you specify. Receiving monthly reports prevents missing records, simplifies categorization by card, vehicle, or department, and makes sharing with accountants or family members straightforward.',
      steps: [
        {
          t: 'Confirm ETC Mileage Service Compatibility',
          d: 'Check whether your ETC card is eligible for mileage service registration. Review the guidance from your credit card issuer and the information printed on your card.',
        },
        {
          t: 'Prepare Required Information',
          d: 'Have your ETC card number, vehicle registration number, and the 19-digit on-board unit management number ready. Accurate entry is required during registration.',
        },
        {
          t: 'Access the Official Registration Page',
          d: 'Open the new registration page on the official ETC Mileage Service site (smile-etc.jp). Be cautious of fraudulent sites and typically verify the official URL.',
        },
        {
          t: 'Enter Registration Details and Create ID',
          d: 'Follow the on-screen instructions to accurately enter your card and vehicle information, then create your mileage ID and password. Proceed carefully to avoid input errors.',
        },
        {
          t: 'Store Your Mileage ID and Password',
          d: 'After registration is in-depth, record and store your mileage ID and password securely. You will need them to check points and log into your account page.',
        },
        {
          t: 'Establish Point Tracking and Record Management',
          d: 'Check your points on your account page, and set up a system to obtain usage statements and PDF/CSV records through the ETC Toll Inquiry Service or JTR.',
        },
      ],
      commonProblems: [
        {
          q: 'Will all discounts be applied once I register for mileage?',
          a: 'No. While some discounts such as weekday commute discounts require mileage registration, eligibility varies by road, time, vehicle class, and route. Check the official information for the latest requirements.',
        },
        {
          q: 'Can I get usage statements through the mileage service?',
          a: 'The mileage service is for managing points. Usage statements and PDF/CSV records are issued through the ETC Toll Inquiry Service. Use each service according to your needs.',
        },
        {
          q: 'Is JTR an official mileage service feature?',
          a: 'No. JTR is an independent service. It receives usage data created by official systems and assists with organizing and delivering records. It is not affiliated with NEXCO, ETC Usage Inquiry Service (MEISAI), or government agencies.',
        },
        {
          q: 'Will points start accumulating right after registration?',
          a: 'Trips after registration will be eligible for points, but posting timing and eligible roads depend on official rules. typically check your point balance on your account page.',
        },
      ],
      examples: [
        {
          who: 'New ETC driver in Kanagawa Prefecture',
          use: 'After obtaining an ETC card, registered for mileage service before starting commutes to meet the requirements for point accumulation and weekday commute discounts.',
        },
        {
          who: 'Commuter from central Tokyo',
          use: 'Learned from NEXCO guidance that mileage registration is required for weekday commute discounts, completed pre-registration, and automated record management with JTR.',
        },
        {
          who: 'Foreign resident',
          use: 'Completed registration on the Japanese-language screen with help from a friend, then set up a system to receive usage records in English through JTR.',
        },
        {
          who: 'Sole proprietor',
          use: 'Registered for mileage with a personal card to accumulate points, while using JTR to categorize and organize business and personal travel records.',
        },
      ],
      faqs: [
        {
          q: 'Are the mileage registration and ETC Toll Inquiry Service accounts the same?',
          a: 'No. The mileage service and ETC Toll Inquiry Service are separate systems. Each is managed with different IDs and passwords, and they serve different purposes.',
        },
        {
          q: 'If I use JTR, do I still need to access the official sites?',
          a: 'Yes. typically check tolls, discounts, points, and eligibility rules on the official sites. JTR is a tool that assists with receiving and organizing records.',
        },
        {
          q: 'Should I save usage records as PDF or CSV?',
          a: 'If possible, save both. PDFs are easier for humans to read, while CSVs are suitable for sorting and accounting processes. Use each format according to your needs.',
        },
        {
          q: 'Do corporate and personal cards have different record retention periods?',
          a: 'Yes. General ETC cards have a 15-month inquiry period, while ETC Corporate Cards have a 62-day period according to official guidance. We recommend retrieving records early.',
        },
        {
          q: 'What should I be careful about for record management after mileage registration?',
          a: 'The mileage service is for point management. Expense reimbursement and tax purposes require usage statements (PDF/CSV), so store records through the ETC Toll Inquiry Service or JTR.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How JTR Works',
          desc: 'Receives usage records created by official systems and delivers them by email in PDF and CSV formats. Eliminates manual downloads and prevents missed records.',
          path: '/how-it-works',
        },
        {
          title: 'Business Plans',
          desc: 'Centralized management of usage records across multiple cards, vehicles, and departments. Organizes and delivers PDFs and CSVs needed for expense reimbursement and monthly reporting.',
          path: '/business',
        },
        {
          title: 'Free Trial',
          desc: "Experience JTR's automated record delivery firsthand. Recommended for those who want to streamline record management after mileage registration.",
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC Mileage Service New Registration Procedure',
          url: 'https://www.smile-etc.jp/service/touroku.html',
          note: 'Official explanation of the registration process. Details the role of mileage IDs and passwords.',
        },
        {
          label: 'ETC Mileage Service Pre-Registration Guidance',
          url: 'https://www.smile-etc.jp/mlgtouroku_service.html',
          note: 'States that advance mileage registration is required for weekday commute discount eligibility.',
        },
        {
          label: 'ETC Mileage Service Overview',
          url: 'https://www.smile-etc.jp/service/info.html',
          note: 'Official explanation of registration, points, refund amounts, and weekday commute discount eligibility requirements.',
        },
        {
          label: 'ETC Toll Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service for checking ETC usage history, issuing usage statements, and downloading PDF and CSV records.',
        },
        {
          label: 'ETC General Information Portal - Inquiry Service Guide',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Official explanation of the 15-month inquiry period for general ETC cards, 62-day period for ETC Corporate Cards, and PDF/CSV export features.',
        },
      ],
      longBody: "Registering for the ETC Mileage Service is the procedure that establishes eligibility for point rebates and the weekday morning-evening discount. Many drivers mistakenly assume that simply holding an ETC card automatically grants all available discounts, but in reality certain discount programs require advance registration with the Mileage Service. NEXCO Central Nippon's official guidance clearly states that registration with the ETC Mileage Service is necessary to receive the weekday morning-evening discount. Registration is free and can be completed on the official website once you have your ETC card number and on-board unit management number at hand. The Mileage ID and password issued after registration are used for checking point balances and applying for rebates, so they should be stored securely. It is important to note that the Mileage Service manages points and discount eligibility only; issuing usage statements and obtaining usage certificates is handled by the ETC Toll Inquiry Service. These two services have separate login credentials and distinct roles, so care should be taken not to confuse them. In day-to-day practice after registration, the typical workflow involves checking your point balance on the Mileage Service site and obtaining PDF or CSV usage records from the Inquiry Service. According to the official portal, standard ETC credit cards and ETC Personal Cards allow inquiries for fifteen months, while ETC Corporate Cards are limited to sixty-two days, meaning corporate users must save records promptly. Japan Toll Receipts is an independent service that becomes useful after you have obtained these official records. JTR is not affiliated with NEXCO, the ETC Mileage Service, ETC Usage Inquiry Service (MEISAI), or any government agency; it is positioned as a supplementary tool that automatically receives, organizes, and stores records users have retrieved from the official systems. Specifically, it delivers PDF and CSV usage statements by email and supports centralized management of records across multiple cards, vehicles, and months. This is especially valuable for sole proprietors, family users, and companies sharing vehicles across departments, reducing the manual download burden each month and preventing gaps in record-keeping. However, final determination of discount eligibility, confirmation of toll charges, and issuance of official usage certificates remain the responsibility of the official services and road operators; JTR does not replace them. Before registering, confirm that your ETC card is eligible for the Mileage program, and after registration check your points regularly on the official site while keeping PDF and CSV records on hand for accounting and reimbursement purposes.",
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: 'ETCマイレージ登録の流れ',
            intro: 'カード取得から還元利用まで4ステップで完結',
            nodes: [
              {
                title: 'ETCカード取得',
                desc: 'クレジットカード会社でETCカードを申込',
              },
              {
                title: 'smile-etc.jpで登録',
                desc: 'カード番号・車載器情報を入力しID発行',
              },
              {
                title: '通行でポイント蓄積',
                desc: '走行距離・道路事業者別にポイント付与',
              },
              {
                title: '還元額として交換',
                desc: '貯まったポイントを無料通行分に変換',
              },
            ],
          },
          en: {
            title: 'ETC Mileage Registration Flow',
            intro: '4 steps from card to cashback redemption',
            nodes: [
              {
                title: 'Obtain ETC Card',
                desc: 'Apply via credit card issuer',
              },
              {
                title: 'Register at smile-etc.jp',
                desc: 'Enter card number, OBU info to get ID',
              },
              {
                title: 'Earn Points on Travel',
                desc: 'Points awarded per distance & operator',
              },
              {
                title: 'Redeem for Free Tolls',
                desc: 'Convert points to toll rebate credits',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '公式サービスの役割分担',
            intro: 'ポイント管理と明細取得は別サイトで運営',
            sources: [
              {
                name: 'smile-etc.jp',
                role: 'マイレージ登録・ポイント照会',
                url: 'smile-etc.jp',
                scope: '新規登録、ID管理、還元額交換',
              },
              {
                name: 'etc-meisai.jp',
                role: '利用明細・証明書発行',
                url: 'etc-meisai.jp',
                scope: 'PDF/CSV、過去15か月分照会',
              },
              {
                name: 'NEXCO平日朝夕割引',
                role: '通勤時間帯の最大50%還元',
                url: '各NEXCO公式',
                scope: 'マイレージ登録が適用条件',
              },
              {
                name: 'Japan Toll Receipts',
                role: '記録の自動配信・整理',
                url: 'japantollreceipts.jp',
                scope: 'メール配信、複数カード一元管理',
              },
            ],
          },
          en: {
            title: 'Official Service Roles',
            intro: 'Points and statements managed on separate platforms',
            sources: [
              {
                name: 'smile-etc.jp',
                role: 'Mileage registration & point inquiry',
                url: 'smile-etc.jp',
                scope: 'New signup, ID admin, rebate exchange',
              },
              {
                name: 'etc-meisai.jp',
                role: 'Usage statements & certificates',
                url: 'etc-meisai.jp',
                scope: 'PDF/CSV, 15-month history',
              },
              {
                name: 'NEXCO Weekday Discount',
                role: 'Up to 50% commute rebate',
                url: 'NEXCO official',
                scope: 'Requires mileage registration',
              },
              {
                name: 'Japan Toll Receipts',
                role: 'Automated delivery & organization',
                url: 'japantollreceipts.jp',
                scope: 'Email delivery, multi-card management',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: 'マイレージ vs 利用照会サービス',
            intro: '登録とログイン情報はそれぞれ独立',
            columns: [
              'ETCマイレージ',
              'ETC利用照会',
            ],
            rows: [
              {
                feature: 'ポイント管理',
                a: '還元額への交換可',
                b: '対象外',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: '平日朝夕割引',
                a: '登録必須',
                b: '対象外',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'PDF/CSV明細',
                a: '取得不可',
                b: '過去15か月分',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '利用証明書',
                a: '発行不可',
                b: '発行可',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '登録情報',
                a: 'カード・車載器',
                b: 'カード番号のみ',
                kindA: 'partial',
                kindB: 'partial',
              },
            ],
          },
          en: {
            title: 'Mileage vs Usage Inquiry Service',
            intro: 'Registration and login credentials are separate',
            columns: [
              'ETC Mileage',
              'ETC Usage Inquiry',
            ],
            rows: [
              {
                feature: 'Point Management',
                a: 'Redeem for rebates',
                b: 'Not supported',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'Weekday Discount',
                a: 'Registration required',
                b: 'Not applicable',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'PDF/CSV Statements',
                a: 'Not available',
                b: '15-month history',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Usage Certificates',
                a: 'Not issued',
                b: 'Issued',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Registration Data',
                a: 'Card + OBU info',
                b: 'Card number only',
                kindA: 'partial',
                kindB: 'partial',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '登録前の準備チェックリスト',
            intro: 'スムーズな登録に必要な情報を事前確認',
            items: [
              {
                text: 'ETCカード番号（カード裏面の20桁）',
                hint: '法人・個人、いずれのカードでも登録可能',
              },
              {
                text: '車両番号（ナンバープレート）',
                hint: '後から追加・変更も可能',
              },
              {
                text: '車載器管理番号（ETC本体19桁）',
                hint: 'セットアップ証明書またはダッシュボード裏に記載',
              },
              {
                text: 'メールアドレス（登録通知用）',
                hint: 'ID・パスワード通知が送られる',
              },
              {
                text: 'パスワード設定（8～20文字）',
                hint: 'マイページログインに使用',
              },
              {
                text: '秘密の質問・答え',
                hint: 'パスワード再設定時の本人確認用',
              },
            ],
          },
          en: {
            title: 'Pre-Registration Checklist',
            intro: 'Required information for smooth signup',
            items: [
              {
                text: 'ETC card number (20 digits on back)',
                hint: 'Corporate or personal cards both accepted',
              },
              {
                text: 'Vehicle number (license plate)',
                hint: 'Can be added or changed later',
              },
              {
                text: 'OBU management number (19 digits)',
                hint: 'Found on setup certificate or device label',
              },
              {
                text: 'Email address (for notifications)',
                hint: 'ID and password will be sent here',
              },
              {
                text: 'Password (8–20 characters)',
                hint: 'Used for My Page login',
              },
              {
                text: 'Security question & answer',
                hint: 'For password recovery verification',
              },
            ],
          },
        },
      },
    ],
  },

  // 3) ETCマイレージポイントの確認方法
  {
    slug: 'etc-mileage-points-check-howto',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETCマイレージ ポイント 確認',
      en: 'ETC mileage points check',
    },
    ja: {
      title: 'ETCマイレージポイント確認方法 | Japan Toll Receipts',
      metaDesc: 'ETCマイレージサービスのポイント残高・付与明細・還元額・有効期限を確認する手順を解説。マイページでのポイント照会、平日朝夕割引の還付金額、ETC利用照会サービスのPDF利用証明書・CSV明細との突合、独立サービスJTRの日次配信を併用した記録運用までまとめました。',
      h1: 'ETCマイレージポイントの確認方法',
      primaryKeyword: 'ETCマイレージ ポイント 確認',
      answer: 'ETCマイレージポイントは、公式のETCマイレージサービス「マイページ」にログインして確認します。マイレージIDとインターネットパスワードでログイン後、ポイント残高・ポイント明細・還元額の状況を閲覧できます。ポイント照会はマイレージサービスで行い、走行記録の保管にはJTRなど記録管理サービスを併用すると効率的です。',
      whyMatters: '多くのドライバーがポイント残高の確認、還元額の申請、平日朝夕割引の適用状況、月次ポイント変動の把握といった目的で照会を行います。ポイント情報は公式マイページで管理され、通行記録はETC利用照会サービスやJTRで別途管理する仕組みです。それぞれのサービスの役割を理解し、正しい手順で確認することで、ポイント還元の機会を逃さず、経理処理や家計管理にも役立てられます。',
      officialBackground: 'ETCマイレージサービスは、登録済みETCカードの利用額に応じてポイントを付与し、還元額として通行料金に充当できる公式制度です。ポイント照会・還元申請・登録情報変更は専用マイページで行います。一方、通行明細・利用証明書・PDF/CSV形式の記録取得はETC利用照会サービスが担当し、通常のETCカードで15か月、ETCコーポレートカードで62日間の照会期間が設定されています。ポイント管理と通行記録管理は別システムであり、目的に応じて使い分けが必要です。Japan Toll Receiptsは独立した記録配信サービスで、NEXCO・MEISAI・マイレージサービスとは異なり、通行記録の受信・整理・保管を支援します。',
      whoFor: [
        'ETCマイレージサービスに登録済みのドライバー',
        '平日朝夕割引とポイント付与状況を確認したい通勤者',
        'ポイント反映のタイミングや還元額を把握したい利用者',
        'ポイント照会と通行記録保管を分けて管理したい法人ユーザー',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receiptsは、公式サービスが作成した通行記録を自動受信・整理するサービスです。ポイント照会は公式マイページで行い、走行記録の保管・分類・月次レポート作成をJTRが補完します。',
        bullets: [
          '通行記録PDF・CSVを自動受信しメール配信',
          'カード別・車両別・月別の記録分類と保管',
          '日英対応のレポート画面で外国籍ドライバーも利用可能',
          '経理担当者向けの月次CSV一括ダウンロード',
          'ダウンロード漏れを防ぐ継続的な記録アーカイブ',
        ],
      },
      pdfCsv: '通行記録の保管にはPDFとCSV両方の保存を推奨します。PDFは目視確認や提出用文書として、CSVは月次集計・部門別仕訳・複数カード横断分析に適しています。JTRは両形式を自動配信し、手動ダウンロードの手間を削減します。',
      email: 'JTRは通行記録をメール経由で配信し、受信トレイに自動保管されます。出張精算や月次報告のタイミングで該当メールを検索・転送でき、ダウンロード忘れや記録紛失のリスクを低減します。',
      steps: [
        {
          t: 'ETCマイレージサービスの公式サイトへアクセス',
          d: 'ETCマイレージサービスの公式サイト（https://www.smile-etc.jp/）を開き、マイページログインページへ進みます。',
        },
        {
          t: 'マイレージIDとインターネットパスワードでログイン',
          d: '登録時に設定したマイレージIDとインターネットパスワードを入力してマイページにログインします。ETC利用照会サービスとは別のIDです。',
        },
        {
          t: 'ポイント残高・明細エリアを開く',
          d: 'マイページ内の「ポイント照会」または「ポイント残高・明細」のメニューを選択し、現在のポイント情報を表示します。',
        },
        {
          t: '保有ポイント・還元額・ポイント変動を確認',
          d: '利用可能ポイント数、交換済み還元額、月別・道路事業者別のポイント増減履歴を確認します。過去年度分も閲覧可能です。',
        },
        {
          t: 'ポイント付与タイミングと利用月を照合',
          d: 'ポイントは利用月の翌月20日頃に付与されるため、走行日とポイント反映日にはタイムラグがあることを理解しておきます。',
        },
        {
          t: '走行記録はJTRまたはETC利用照会サービスで管理',
          d: 'ポイント残高確認はマイレージサービス、走行履歴のPDF・CSV取得はETC利用照会サービスまたはJTRで行い、役割を分けて管理します。',
        },
      ],
      commonProblems: [
        {
          q: 'ポイントがすぐに反映されない',
          a: 'ETCマイレージポイントは利用月の翌月20日頃に付与されます。走行直後には表示されないため、付与スケジュールを確認してください。',
        },
        {
          q: 'マイページとETC利用照会サービスを混同',
          a: 'マイレージサービスはポイント管理、ETC利用照会サービスは利用証明書・走行明細の発行が役割です。ログインIDも異なります。',
        },
        {
          q: 'JTRが公式ポイント管理サービスだと誤解',
          a: 'JTRは独立した記録配信サービスであり、ポイント残高や還元額を管理する公式システムではありません。ポイント確認は公式マイページで行います。',
        },
        {
          q: 'ポイント明細だけで経費精算しようとする',
          a: 'ポイント明細は割引・還元情報であり、走行記録そのものではありません。経費精算にはETC利用照会サービスまたはJTRのPDF・CSV記録を使用してください。',
        },
      ],
      examples: [
        {
          who: '登録済み通勤ドライバー',
          use: '平日通勤を1か月続けた後、マイページでポイントと平日朝夕割引の還元額が正しく反映されているか確認します。',
        },
        {
          who: '家族利用ドライバー',
          use: '連休の長距離ドライブ後にポイント付与を確認し、家計管理用にJTRのPDF記録を別途保存して支出を整理します。',
        },
        {
          who: '中小企業の経理担当者',
          use: '公式マイページでポイント残高を確認しつつ、JTRのCSVレポートでカード別・部門別の実際の通行料金を突合します。',
        },
        {
          who: '外国人居住者',
          use: '公式ポイントページはブラウザ翻訳で閲覧し、走行記録の受信・管理はJTRのバイリンガルメール機能を活用します。',
        },
      ],
      faqs: [
        {
          q: 'ETCマイレージポイント確認で最も重要なことは何ですか？',
          a: 'ポイント残高・還元額は公式マイレージサービスが管理する公式データであり、JTRは走行記録の配信・整理を支援する独立サービスであることを理解することです。',
        },
        {
          q: 'JTRは公式のETC・NEXCO・マイレージサービスですか？',
          a: 'いいえ。JTRは独立した記録配信サービスです。通行料金・割引・ポイント付与・適用条件は公式の道路事業者とマイレージサービスが管理します。',
        },
        {
          q: 'PDFとCSV、どちらの記録を保存すべきですか？',
          a: '可能であれば両方保存してください。PDFは人間が読みやすく提出書類向き、CSVは集計・会計処理・月次照合に適しています。',
        },
        {
          q: 'ポイントや割引の適用条件は変わることがありますか？',
          a: 'はい。通行料金・割引適用・ポイント対象は道路・日時・車種・ルート・登録状況・キャンペーン条件により変動します。最新情報は公式サイトで確認してください。',
        },
        {
          q: '企業利用者が個人ドライバーと異なる点は何ですか？',
          a: '企業はETCカードを運転者・車両・部門・精算ルールに紐付け、PDF・CSV記録を共有アーカイブで管理する継続的なワークフローを構築すべきです。',
        },
      ],
      relatedFeatures: [
        {
          title: 'JTRの仕組み',
          desc: 'ETCマイレージポイント確認後、走行記録のPDF・CSV配信を自動化し、カード別・月別の記録管理を効率化します。',
          path: '/how-it-works',
        },
        {
          title: '個人ドライバー向けプラン',
          desc: 'マイレージ登録ドライバーが走行記録をメールで自動受信し、ポイント管理と記録保管を分けて整理できます。',
          path: '/personal',
        },
        {
          title: 'ビジネスプラン',
          desc: '複数カード・複数車両の走行記録をCSV一括取得し、ポイント管理と経費精算記録を部門別に整理します。',
          path: '/business',
        },
      ],
      references: [
        {
          label: 'ETCマイレージサービス マイページログイン',
          url: 'https://www.smile-etc.jp/MlgUserInfChange.html',
          note: 'マイレージIDとインターネットパスワードによる公式ログインページ',
        },
        {
          label: 'ETCマイレージサービス ポイント明細確認',
          url: 'https://www.smile-etc.jp/service/point_meisai_exp.html',
          note: 'ポイント明細確認、保有ポイント残高、過去年度情報、道路事業者別月次変動の公式説明',
        },
        {
          label: 'ETCマイレージサービス ポイント交換',
          url: 'https://www.smile-etc.jp/service/kangengaku.html',
          note: 'ポイントを還元額に交換する公式手続き',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETC利用履歴確認・利用証明書発行・PDF/CSVダウンロードを行う公式照会サービス',
        },
        {
          label: 'ETC総合情報ポータル 利用照会サービス案内',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '通常ETCカード15か月・ETCコーポレートカード62日間の照会期間とPDF/CSV出力の公式説明',
        },
      ],
      longBody: 'ETCマイレージサービスのポイント残高や還元額を確認したい場合、最も確実な方法は公式サイトのマイページにログインすることです。マイレージIDとインターネットパスワードを入力してログイン後、ポイント残高照会や利用明細確認のページから現在の保有ポイント、還元額、過去の増減履歴を確認できます。ETC利用照会サービスが走行記録や利用証明書の発行に対応しているのに対し、ETCマイレージサービスはポイント管理と還元額交換に特化した仕組みであり、この二つは別のIDとパスワードで運用されている点に注意が必要です。多くのドライバーが混同しやすいのは、ポイント確認画面と利用履歴のPDF・CSV記録を同一のシステムだと思い込むケースです。実際にはポイントはマイレージサービス側で付与・管理され、走行記録はETC利用照会サービスまたは独立した記録配信サービスを通じて取得する流れになります。ポイントの反映タイミングも走行日とは異なり、通常は翌月以降に集計されるため、すぐに残高が変わらないからといって記録漏れとは限りません。平日朝夕割引を利用している通勤ドライバーの場合、ポイント付与と還元額の自動充当が組み合わされるため、月ごとにマイページで確認しておくと予想外の割引額を見逃さずに済みます。家計管理や経費精算のために走行記録を保存したい場合は、マイページのポイント画面だけでなく、ETC利用照会サービスのPDFやCSVを取得するか、Japan Toll Receiptsのような独立した記録配信サービスを併用する方法が現実的です。JTRは公式なNEXCOサービスやマイレージ運営組織ではなく、利用者が走行後に受け取る記録を自動配信・整理する補助ツールとして位置づけられます。ポイント残高の確認は公式マイページで行い、走行記録のPDFやCSV保存はJTRや利用照会サービスで対応するという役割分担を理解しておくと、書類提出や月次確認の作業が混乱しません。特に法人や個人事業主が複数枚のETCカードを管理している場合、カードごとのポイント残高と実際の通行料金記録を別々に扱う必要があるため、マイページでのポイント確認とJTRによる記録配信を組み合わせた運用が効率的です。外国人居住者にとっては、マイページの日本語表示をブラウザ翻訳で読み解く一方、JTRのメール配信で英語対応の記録を受け取る使い方も選択肢になります。いずれの場合も、ポイント付与や還元額の最終決定は公式のマイレージサービス側にあり、JTRはあくまで記録整理の利便性を高める独立サービスであることを忘れないでください。',
    },
    en: {
      title: 'How to Check ETC Mileage Points Balance | Japan Toll Receipts',
      metaDesc: 'Learn how to check ETC mileage points balance, transaction history, and redemption amounts. Step-by-step guide to the official My Page portal and JTR record-keeping integration.',
      h1: 'How to Check ETC Mileage Points',
      primaryKeyword: 'ETC mileage points check',
      answer: 'Check your ETC mileage points by logging into the official ETC Mileage Service My Page portal. After entering your Mileage ID and internet password, you can view your points balance, transaction details, and redemption amounts. Use the official portal for points inquiry, and combine it with JTR or similar services for toll record archiving.',
      whyMatters: 'Drivers regularly check their mileage accounts to monitor points balance, submit redemption requests, verify weekday commuter discount application, and track monthly point fluctuations. Points information is managed through the official My Page, while toll transaction records are handled separately via ETC inquiry services or JTR. Understanding the role of each system and following proper verification steps ensures you never miss redemption opportunities and supports both accounting processes and household budget management.',
      officialBackground: 'The ETC Mileage Service is an official program that awards points based on registered ETC card usage and allows redemption against toll charges. Points inquiry, redemption applications, and registration updates are handled through a dedicated My Page portal. Meanwhile, transaction details, usage certificates, and PDF/CSV format records are provided by the ETC Toll Inquiry Service, with retention periods of 15 months for standard ETC cards and 62 days for ETC Corporate cards. Points management and toll record systems operate separately and require purpose-specific use. Japan Toll Receipts is an independent record delivery service—distinct from NEXCO, ETC Usage Inquiry Service (MEISAI), and Mileage Service—that assists with receiving, organizing, and archiving toll transaction records.',
      whoFor: [
        'Drivers already registered with ETC Mileage Service',
        'Commuters wanting to verify weekday discount and points accrual',
        'Users needing to understand points posting timing and redemption amounts',
        'Corporate users managing points inquiry and toll records separately',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts automatically receives and organizes toll records created by official services. Use the official My Page for points inquiry, while JTR handles record archiving, categorization, and monthly reporting.',
        bullets: [
          'Auto-receive toll record PDFs and CSVs via email delivery',
          'Organize and archive by card, vehicle, and month',
          'Bilingual Japanese-English interface for international drivers',
          'Monthly CSV bulk download for accounting teams',
          'Continuous record archiving prevents download gaps',
        ],
      },
      pdfCsv: 'For toll record archiving, save both PDF and CSV formats. PDFs serve visual verification and document submission, while CSVs enable monthly totals, departmental allocation, and multi-card analysis. JTR automatically delivers both formats, reducing manual download effort.',
      email: 'JTR delivers toll records via email, with automatic inbox archiving. Search and forward relevant messages for expense reimbursement or monthly reports, reducing the risk of forgotten downloads or lost records.',
      steps: [
        {
          t: 'Access the ETC Mileage Service official website',
          d: 'Open the ETC Mileage Service official website (https://www.smile-etc.jp/) and navigate to the My Page login screen.',
        },
        {
          t: 'Log in with your Mileage ID and Internet password',
          d: 'Enter the Mileage ID and Internet password you set during registration to access My Page. This is a separate ID from the ETC Inquiry Service.',
        },
        {
          t: 'Open the points balance and details area',
          d: "Select the 'Points Inquiry' or 'Points Balance & Details' menu within My Page to display your current points information.",
        },
        {
          t: 'Check available points, redeemed amounts, and point changes',
          d: 'Review available points, converted rebate amounts, and point increase/decrease history by month and road operator. Past fiscal year data is also viewable.',
        },
        {
          t: 'Cross-check points posting timing with usage month',
          d: 'Understand that points are credited around the 20th of the month following your usage month, so there is a time lag between travel date and points reflection.',
        },
        {
          t: 'Manage travel records via JTR or ETC Inquiry Service',
          d: 'Use Mileage Service for points balance checks, and ETC Inquiry Service or JTR for PDF/CSV travel history retrieval, separating these roles in your workflow.',
        },
      ],
      commonProblems: [
        {
          q: 'Points are not reflected immediately',
          a: 'ETC Mileage points are credited around the 20th of the month following your usage month. They do not appear immediately after travel, so please verify the posting schedule.',
        },
        {
          q: 'Confusing My Page with ETC Inquiry Service',
          a: 'Mileage Service manages points, while ETC Inquiry Service issues usage certificates and travel details. The login IDs for each are different.',
        },
        {
          q: 'Misunderstanding JTR as the official points management service',
          a: 'JTR is an independent record delivery service and is not the official system for managing points balance or rebate amounts. Check points on the official My Page.',
        },
        {
          q: 'Trying to process expense claims using only points details',
          a: 'Points details show discounts and rebates, not travel records themselves. For expense claims, use PDF/CSV records from ETC Inquiry Service or JTR.',
        },
      ],
      examples: [
        {
          who: 'Registered commuter driver',
          use: 'After a month of weekday commuting, check My Page to confirm that points and weekday morning/evening discount rebates are properly reflected.',
        },
        {
          who: 'Family-use driver',
          use: 'After a long-distance holiday drive, confirm points posting and separately save JTR PDF records to organize household expenses.',
        },
        {
          who: 'Accounting staff at small business',
          use: 'Check points balance on the official My Page while reconciling actual toll charges by card and department using JTR CSV reports.',
        },
        {
          who: 'Foreign resident',
          use: "View the official points page with browser translation and leverage JTR's bilingual email feature to receive and manage travel records.",
        },
      ],
      faqs: [
        {
          q: 'What is the most important thing about checking ETC Mileage points?',
          a: 'Understanding that points balance and rebate amounts are official data managed by the official Mileage Service, while JTR is an independent service that supports travel record delivery and organization.',
        },
        {
          q: 'Is JTR an official ETC, NEXCO, or Mileage Service?',
          a: 'No. JTR is an independent record delivery service. Toll charges, discounts, points posting, and eligibility conditions are managed by the official road operators and Mileage Service.',
        },
        {
          q: 'Should I save PDF or CSV records, or both?',
          a: 'Save both if possible. PDFs are human-readable and suitable for submission documents, while CSVs are ideal for aggregation, accounting processing, and monthly reconciliation.',
        },
        {
          q: 'Can points and discount eligibility conditions change?',
          a: 'Yes. Toll charges, discount application, and points eligibility vary by road, date/time, vehicle type, route, registration status, and campaign conditions. Check the official site for current information.',
        },
        {
          q: 'How does corporate use differ from individual drivers?',
          a: 'Companies should link ETC cards to drivers, vehicles, departments, and settlement rules, and build continuous workflows that manage PDF/CSV records in shared archives.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How JTR Works',
          desc: 'After checking ETC Mileage points, automate PDF/CSV delivery of travel records and streamline card-by-card, month-by-month record management.',
          path: '/how-it-works',
        },
        {
          title: 'Personal Driver Plans',
          desc: 'Mileage-registered drivers automatically receive travel records by email, separating points management from record archiving for organized tracking.',
          path: '/personal',
        },
        {
          title: 'Business Plans',
          desc: 'Bulk-retrieve CSV travel records for multiple cards and vehicles, organizing points management and expense records by department.',
          path: '/business',
        },
      ],
      references: [
        {
          label: 'ETC Mileage Service My Page Login',
          url: 'https://www.smile-etc.jp/MlgUserInfChange.html',
          note: 'Official login page using Mileage ID and Internet password',
        },
        {
          label: 'ETC Mileage Service Points Details Inquiry',
          url: 'https://www.smile-etc.jp/service/point_meisai_exp.html',
          note: 'Official guidance for checking points details, available balance, past fiscal years, and monthly changes by road operator',
        },
        {
          label: 'ETC Mileage Service Points Exchange',
          url: 'https://www.smile-etc.jp/service/kangengaku.html',
          note: 'Official procedure for converting points into rebate amounts',
        },
        {
          label: 'ETC Usage Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official inquiry service for checking ETC usage history, issuing usage certificates, and downloading PDF/CSV files',
        },
        {
          label: 'ETC General Information Portal – Inquiry Service Guide',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Official explanation of inquiry periods (15 months for standard ETC cards, 62 days for ETC Corporate cards) and PDF/CSV output',
        },
      ],
      longBody: 'When you need to check your ETC mileage service point balance or available reward credits, the most reliable method is to log into the official my-page portal using your mileage ID and internet password. After logging in, you can view your current points, reward credits, and historical transaction records through the point-balance inquiry and usage-detail pages. It is important to note that while the ETC usage inquiry service handles travel records and certificate issuance, the ETC mileage service is dedicated specifically to point management and reward-credit exchange, and the two operate under separate ID and password systems. A common source of confusion among drivers is the assumption that the point-confirmation screen and travel-history PDF or CSV records come from a single unified system. In reality, points are issued and managed by the mileage service, while travel records are obtained through the ETC usage inquiry service or independent record-distribution platforms. Point accrual timing also differs from the travel date itself, as points are typically aggregated in the following month or later, meaning a delay in balance updates does not necessarily indicate a missing record. For commuters who rely on weekday morning-evening discounts, point issuance and automatic reward-credit allocation work in tandem, so checking the my-page monthly helps avoid overlooking unexpected discount benefits. For those managing household budgets or business expense reimbursement who wish to archive travel records, it is practical to combine the my-page point screen with PDFs and CSVs from the ETC usage inquiry service or to use an independent record-distribution service such as Japan Toll Receipts. JTR is not an official NEXCO service or mileage-administration body; it is positioned as a supplementary tool that automatically distributes and organizes records received after travel. Understanding the division of labor—checking point balances on the official my-page and handling PDF and CSV archiving through JTR or the usage inquiry service—prevents confusion when submitting documentation or performing monthly reviews. Corporate and sole-proprietor users managing multiple ETC cards especially benefit from separating per-card point balances from actual toll-charge records, making combined use of my-page point checks and JTR record distribution an efficient workflow. For foreign residents, one option is to navigate the Japanese-language my-page with browser translation while receiving English-compatible records via JTR email delivery. In every case, remember that final determination of point issuance and reward credits rests with the official mileage service, and JTR remains an independent service designed solely to enhance record-keeping convenience.',
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: 'ETCマイレージポイント確認の流れ',
            intro: '公式マイページでポイント照会を行い、走行記録は別途管理する標準的な手順です。',
            nodes: [
              {
                title: 'マイページログイン',
                desc: 'マイレージIDとパスワードで公式サイトにアクセス',
              },
              {
                title: 'ポイント残高照会',
                desc: '現在のポイント数・還元額の状況を確認',
              },
              {
                title: 'ポイント明細表示',
                desc: '付与履歴・還元申請状況・平日朝夕割引を閲覧',
              },
              {
                title: '通行記録管理',
                desc: 'ETC利用照会またはJTRで走行履歴を保管',
              },
            ],
          },
          en: {
            title: 'ETC Mileage Point Check Flow',
            intro: 'Check points via official MyPage, and manage driving records separately.',
            nodes: [
              {
                title: 'MyPage Login',
                desc: 'Access official site with mileage ID and password',
              },
              {
                title: 'Check Point Balance',
                desc: 'View current points and available rebate amount',
              },
              {
                title: 'View Point Details',
                desc: 'Review earning history, redemption status, commuter discounts',
              },
              {
                title: 'Manage Records',
                desc: 'Store driving history via ETC Usage Query or JTR',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: 'ポイント確認と記録管理の公式サービス',
            intro: 'マイレージポイントと通行記録は別システムで管理されています。',
            sources: [
              {
                name: 'ETCマイレージサービス',
                role: 'ポイント照会・還元申請',
                url: '公式マイページ',
                scope: '残高・明細・登録情報',
              },
              {
                name: 'ETC利用照会サービス',
                role: '通行明細・証明書発行',
                url: 'NEXCO公式',
                scope: '15か月分(コーポは62日)',
              },
              {
                name: 'Japan Toll Receipts',
                role: '記録自動配信・保管',
                url: '独立サービス',
                scope: 'PDF/CSV整理・月次集計',
              },
              {
                name: 'カード会社明細',
                role: '請求額確認',
                url: '各カード会社',
                scope: 'クレジット利用明細',
              },
            ],
          },
          en: {
            title: 'Official Services for Points & Records',
            intro: 'Mileage points and toll records are managed by separate systems.',
            sources: [
              {
                name: 'ETC Mileage Service',
                role: 'Point inquiry & redemption',
                url: 'Official MyPage',
                scope: 'Balance, history, registration',
              },
              {
                name: 'ETC Usage Query',
                role: 'Trip details & certificates',
                url: 'NEXCO official',
                scope: '15 months (Corp: 62 days)',
              },
              {
                name: 'Japan Toll Receipts',
                role: 'Automated delivery & storage',
                url: 'Independent service',
                scope: 'PDF/CSV sorting, monthly reports',
              },
              {
                name: 'Card Statements',
                role: 'Billing confirmation',
                url: 'Card issuers',
                scope: 'Credit transaction records',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: 'マイレージサービスとJTRの役割比較',
            intro: 'ポイント照会と記録管理の機能を整理して理解しましょう。',
            columns: [
              'ETCマイレージサービス',
              'Japan Toll Receipts',
            ],
            rows: [
              {
                feature: 'ポイント残高照会',
                a: '公式マイページで確認可能',
                b: '対象外',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: '還元申請',
                a: 'マイページで手続き',
                b: '対象外',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: '通行記録保管',
                a: '別サービスで照会',
                b: 'PDF/CSV自動配信',
                kindA: 'neutral',
                kindB: 'yes',
              },
              {
                feature: '月次レポート作成',
                a: '対象外',
                b: 'カード別・月別に分類',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '日英対応',
                a: '日本語のみ',
                b: '日英バイリンガル',
                kindA: 'partial',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'Mileage Service vs JTR Roles',
            intro: 'Understand the distinct functions of point inquiry and record management.',
            columns: [
              'ETC Mileage Service',
              'Japan Toll Receipts',
            ],
            rows: [
              {
                feature: 'Point balance inquiry',
                a: 'Available via official MyPage',
                b: 'Not applicable',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'Redemption application',
                a: 'Apply via MyPage',
                b: 'Not applicable',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'Record storage',
                a: 'Separate query service',
                b: 'Automated PDF/CSV delivery',
                kindA: 'neutral',
                kindB: 'yes',
              },
              {
                feature: 'Monthly reporting',
                a: 'Not applicable',
                b: 'Sorted by card & month',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Bilingual support',
                a: 'Japanese only',
                b: 'Japanese & English',
                kindA: 'partial',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: 'ポイント確認時のチェックリスト',
            intro: '漏れなくポイント状況を把握するための確認項目です。',
            items: [
              {
                text: 'マイページにログインできる',
                hint: 'マイレージIDとパスワードを準備',
              },
              {
                text: '現在のポイント残高を確認',
                hint: '還元可能額も同時にチェック',
              },
              {
                text: 'ポイント付与明細を閲覧',
                hint: '平日朝夕割引の適用状況を確認',
              },
              {
                text: '還元額の有効期限を把握',
                hint: '失効前に通行料金へ充当',
              },
              {
                text: '通行記録を別途保管',
                hint: 'ETC利用照会またはJTRで管理',
              },
              {
                text: '月次でポイント変動を確認',
                hint: '経理処理や家計管理に活用',
              },
            ],
          },
          en: {
            title: 'Point Check Checklist',
            intro: 'Essential items to verify your mileage point status completely.',
            items: [
              {
                text: 'Access MyPage successfully',
                hint: 'Prepare mileage ID and password',
              },
              {
                text: 'Check current point balance',
                hint: 'Also verify available rebate amount',
              },
              {
                text: 'Review point earning details',
                hint: 'Confirm commuter discount application',
              },
              {
                text: 'Note rebate expiration dates',
                hint: 'Apply to tolls before expiry',
              },
              {
                text: 'Store trip records separately',
                hint: 'Manage via ETC Usage Query or JTR',
              },
              {
                text: 'Track monthly point changes',
                hint: 'Use for accounting or budgeting',
              },
            ],
          },
        },
      },
    ],
  },

  // 4) ETC割引が利用明細に反映されるタイミング
  {
    slug: 'etc-warikibi-meisai-hannei-timing',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETC割引 明細 反映',
      en: 'ETC discount statement timing',
    },
    ja: {
      title: 'ETC割引の明細反映タイミング | 請求・ポイントを確認する方法 – JTR',
      metaDesc: 'ETC割引（休日・深夜・平日朝夕・大口多頻度・通勤など）が利用明細に反映されるタイミングを解説。即時反映型・後日反映型・マイレージポイント還元型など方式別の確認タイミング、反映が遅い場合の原因、ETC利用照会サービスとETCマイレージサービスでの照合手順、独立サービスJTRを併用した月次レビューフローまで実務ベースで整理。',
      h1: 'ETC割引が明細に反映されるタイミング',
      primaryKeyword: 'ETC割引 明細 反映',
      answer: 'ETC割引の反映時期は割引方式により異なります。一部の割引は通行記録の料金欄に即時反映されますが、マイレージサービスによる還元ポイント、平日朝夕割引、後日還元型の深夜割引などは、利用明細とは別にマイレージアカウントやクレジットカード請求で確認が必要です。料金所表示や車載器画面には割引後金額が表示されない場合もあるため、最終的な請求額はETC利用照会サービスおよびカード明細で確認することが推奨されます。',
      whyMatters: '企業の経理担当者や運転者が「割引が適用されていない」と誤解するケースの多くは、反映タイミングの違いを知らないことが原因です。即時反映される割引と後日ポイント還元される割引を混同すると、不要な問い合わせや訂正処理が発生します。また、ETC2.0割引は料金所表示に出ず、後日カード請求時に反映されるため、通行直後の車載器画面だけでは判断できません。月次締め作業を正確に行うには、各割引制度の確認場所と反映時期を理解し、公式サービスでの照合を待つ余裕を持つことが重要です。',
      officialBackground: 'ETC利用の公式記録層は道路事業者・ETCカード・ETC利用照会サービスにあり、JTRはこれらと独立した記録配信サービスです。ETC利用照会サービスは利用明細の確認・証明書発行・PDF/CSVダウンロードを提供しますが、NEXCO公式ページでは「ETC2.0割引額は料金所や車載器に表示されず、後日カード会社請求時に反映され、照会サービスで確認できる」と注意喚起されています。ETCマイレージサービスはポイント付与と平日朝夕割引の還元額確認を担い、将来改定される深夜割引も後日還元方式でマイレージまたはコーポレートカード経由となる予定です。割引適用の可否は通行日時・区間・車種・カード・登録状況・除外日により決まるため、利用者は公式ルールと最終記録額を照合する必要があります。',
      whoFor: [
        '通行後すぐに割引適用を確認したいドライバー',
        '月次経費精算で割引反映を待つ経理担当者',
        '複数カードの割引タイミングを管理する複数車両責任者',
        '日次レポートと後日請求を突合するJTR利用企業',
      ],
      jtrSolution: {
        intro: 'JTRは公的機関とは独立したサービスですが、ETC利用記録を整理・配信することで割引確認作業を支援します。日次で記録を受け取ることで通行履歴の抜け漏れ・不審ルート・カード誤用を早期発見でき、後日マイレージや請求を照合する際の台帳として活用できます。',
        bullets: [
          '日次配信により通行記録を受信箱に蓄積し、月末まで待たずに履歴を確認',
          'PDF/CSV形式で保存し、公式サービスと照合するための整理台帳として利用',
          '通行日・区間・時刻・カードを一覧化し、割引条件との突合作業を効率化',
          'マイレージ還元やカード請求と分けて管理するため、反映タイミング違いに対応',
          'JTRは独立サービスであり、割引判定・税務保証・公式データ作成は行わない点を明示',
        ],
      },
      pdfCsv: 'JTRはPDFとCSV形式で記録を配信します。PDFは証憑として保管・印刷に適し、CSVは経理ソフトへの取込・ソート・集計作業に便利です。どちらも公式サービスから取得した記録を整理したものであり、Excel形式での出力は提供していません。両形式を併用することで書類管理と数値処理の両方に対応できます。',
      email: 'JTRは設定したスケジュールでETC利用記録をメール配信します。受信箱に届いた記録は自動的にアーカイブされ、後日マイレージポイントやカード請求を照合する際の参照台帳として機能します。手動ダウンロードの手間を減らし、記録漏れを防ぐ仕組みとして多くの企業に採用されています。',
      steps: [
        {
          t: '公式照会サービスで利用記録が表示されるまで待つ',
          d: 'ETC利用照会サービスで走行記録が反映されるまで待機します。即時反映されない場合もあるため、数時間~翌日程度の時間的余裕を持ちます。',
        },
        {
          t: '走行日時・ルート・カード・車種を割引条件と照合',
          d: '走行記録の日付・時間帯・入口/出口・利用カード・車種区分を確認し、割引条件の対象区間・時間帯・除外日などと照らし合わせます。',
        },
        {
          t: '割引の反映タイミング方式を確認',
          d: '即時割引か、後日カード請求か、ポイント還元か、還元額方式かを判別します。割引種別により確認場所が異なります。',
        },
        {
          t: 'ETCマイレージサービスでポイント・還元額を確認',
          d: '平日朝夕割引や一部の還元額方式割引はETCマイレージサービス側で確認が必要です。走行明細だけでは反映されません。',
        },
        {
          t: '必要に応じてカード請求明細で最終請求額を確認',
          d: 'クレジットカードまたはETCコーポレートカードの請求明細で、最終的に引き落とされる金額を確認します。',
        },
        {
          t: '金額確定後にPDF・CSVを保存',
          d: '金額が安定したタイミングで公式記録のPDF証明書・CSV明細をダウンロードし、月次フォルダへ保管します。',
        },
      ],
      commonProblems: [
        {
          q: '走行直後に割引額が見えない',
          a: '料金所表示や車載器には割引後金額が表示されない場合があります。特にETC2.0割引では後日カード請求時に反映され、照会サービスで確認できます。',
        },
        {
          q: '平日朝夕割引が走行明細に載らない',
          a: '平日朝夕割引は還元額方式のため、ETCマイレージサービス側で月単位の走行回数・区間を集計し、翌月20日頃に還元額付与されます。',
        },
        {
          q: '休日と思ったが割引されていない',
          a: '割引対象外日(年末年始・ゴールデンウィーク・お盆等)や、対象外区間・車種・カード登録状況により適用外となる場合があります。',
        },
        {
          q: 'JTRレポートと公式記録の金額が異なる',
          a: 'JTRは記録配信ツールであり、割引判定や金額決定は行いません。公式の照会サービス・カード請求・マイレージサービスで最終金額を確認してください。',
        },
      ],
      examples: [
        {
          who: '当日確認するドライバー',
          use: '走行直後にポータルを確認したが期待した結果が見えず、反映を待ってから再確認し、誤ったクレーム申請を避けた。',
        },
        {
          who: '通勤利用者',
          use: '平日朝夕割引を期待したが、走行明細だけでなくETCマイレージサービス側で還元額確認が必要と理解した。',
        },
        {
          who: 'ETC2.0利用ドライバー',
          use: '車載器表示に割引額が出なかったが、後日公式明細で割引適用を確認し、不要な問い合わせを回避した。',
        },
        {
          who: '月次経理チーム',
          use: '月末締めに短い猶予期間を設け、遅延反映や後日還元分による不要な修正作業を防いだ。',
        },
      ],
      faqs: [
        {
          q: 'JTRが割引適用を判定しますか?',
          a: 'いいえ。JTRは独立した記録配信サービスであり、割引判定は行いません。記録を整理・配信し、ユーザーが公式結果を確認しやすくします。',
        },
        {
          q: '料金所表示で割引額を確認できますか?',
          a: 'できない場合があります。一部の割引や後日調整は料金所や車載器に表示されず、公式明細・カード請求・プログラムポータルでの確認が必要です。',
        },
        {
          q: 'PDFとCSV両方を保管すべきですか?',
          a: '推奨されます。PDF証明書は文書レビュー用、CSV明細はソート・照合・経理処理用として使い分けられます。',
        },
        {
          q: '割引ルールは変更されますか?',
          a: 'はい。割引期間・対象・除外日・プログラム構造は変更される場合があります。最新の公式事業者ページで確認してください。',
        },
        {
          q: 'JTRはこのテーマにどう役立ちますか?',
          a: 'JTRはETC記録を定期的に配信・整理し、人による確認作業を効率化します。公式サービスや事業者ルールを置き換えるものではありません。',
        },
      ],
      relatedFeatures: [
        {
          title: '仕組み・記録配信の流れ',
          desc: 'JTRがETC記録をどのように配信・整理するかを説明。公式照会サービスとの役割分担を理解できます。',
          path: '/how-it-works',
        },
        {
          title: '法人向けプラン',
          desc: '複数カード・複数車両の記録を月次フォルダで一元管理。経理チームや管理者向けの配信ワークフローを提供します。',
          path: '/business',
        },
        {
          title: '無料トライアル',
          desc: '実際の記録配信・PDF/CSV形式・メール受信の流れを試し、割引確認ワークフローとの相性を確認できます。',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: '公式の走行明細確認・証明書発行・PDF/CSVダウンロードサービス',
        },
        {
          label: 'NEXCO東日本 ETC2.0割引',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: '料金所・車載器に割引額が表示されず、後日カード請求時に反映される旨の公式説明',
        },
        {
          label: 'ETCマイレージサービス',
          url: 'https://www.smile-etc.jp/',
          note: 'マイレージポイント・平日朝夕還元額の公式確認サイト',
        },
        {
          label: 'NEXCO東日本 深夜割引改定',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_night_fix/',
          note: '将来の深夜割引還元額方式への変更に関する公式説明',
        },
        {
          label: 'NEXCO東日本 割引概要',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: '各種割引の種類・対象条件・除外日などの公式総合ガイド',
        },
      ],
      longBody: 'ETC割引の明細反映タイミングは割引制度によって異なります。一部の割引は通行料金として即座に反映されますが、ポイント還元型や後日返還型の割引は利用明細とは別のサービスで確認が必要になります。NEXCOのETC2.0割引に関する公式ページでは、料金所表示や車載器の画面には割引後の金額が表示されない場合があり、最終的な請求額はカード会社からの請求やETC利用照会サービスで確認できると案内されています。この仕組みを理解せずに料金所通過直後の画面だけで判断すると、割引が適用されていないと誤解する可能性があります。平日朝夕割引やETCマイレージサービスのポイント還元は、走行記録とは別にマイレージサービスのアカウントで確認する必要があります。企業の経理担当者が月次締め処理を行う際、通行直後の記録だけで判断すると後日反映される還元や調整を見落とし、不要な修正作業が発生することがあります。そのため、実務では数日の猶予期間を設けて最終確定を待つ運用が推奨されます。JTRは独立した記録配信・整理サービスとして、利用者が定期的にETC利用記録をメールで受信し、PDFおよびCSV形式で保管できる環境を提供します。JTRはNEXCO、MEISAI、ETC利用照会サービス、ETCマイレージサービス、道路事業者ではなく、公式な通行料金データを生成せず、割引適用の可否を判定せず、払戻申請や税務処理の保証もしません。JTRの役割は、利用者が公式記録を整理し人間による確認作業を効率化できるよう支援することです。割引が期待どおりに反映されない場合、まず通行日時・入口・出口・車両区分・利用カード・対象区間・割引時間帯・除外日・登録状況を公式記録で確認します。感情的な問い合わせではなく、事実に基づいた検証を行うことで誤解を防ぎます。企業は通行料金精算に関する社内規程を明文化し、公式なETC利用記録または承認済み通行証憑を根拠とすること、割引は公式事業者規則と最終記録額に基づいて確認すること、JTR報告書は整理配信・保管ツールとして利用できるが公式通行データおよび適用判定は公式システムと事業者に帰属することを明記すると安全です。深夜割引の将来的な後日還元方式への変更も公式に案内されており、割引制度は固定されたものではなく時期や路線によって仕組みが変わる可能性があることを認識しておく必要があります。記録確認の実務パターンとしては、月次フォルダにPDF証明書・CSV詳細・運転者メモ・承認記録・特殊割引説明を保管し、後日の監査や問い合わせに備える運用が有効です。JTRを活用することで月末まで待たずに日次で記録を受信し、受信トレイに取扱履歴を残すことができ、カード誤用・想定外ルート・割引適用漏れの早期発見を支援します。',
    },
    en: {
      title: 'When ETC Discount Appears on Statement | Billing & Points – JTR',
      metaDesc: 'Learn when ETC discounts appear on your statement. Instant vs. deferred vs. point-rebate timing explained, with steps to verify via ETC Inquiry & Mileage Service.',
      h1: 'When ETC Discounts Appear on Your Statement',
      primaryKeyword: 'ETC discount statement timing',
      answer: "ETC discount timing varies by discount type. Some discounts appear instantly in the toll record's fare column, while Mileage Service points, weekday morning/evening discounts, and certain deferred midnight discounts are credited separately through your Mileage account or credit card billing. Tollgate displays and on-board unit screens may not show discounted amounts, so final charges should be verified via the ETC Inquiry Service and your card statement.",
      whyMatters: "Many accounting staff and drivers mistakenly believe discounts are missing simply because they don't understand timing differences. Confusing instant-apply discounts with deferred point rebates leads to unnecessary inquiries and correction requests. ETC 2.0 discounts do not appear on tollgate displays and are applied only when the card is billed, so you cannot judge from the on-board screen immediately after passage. To close monthly books accurately, understand where each discount appears and allow time for official reconciliation services to update.",
      officialBackground: "The official record layers for ETC usage are the road operator, the ETC card issuer, and the ETC Inquiry Service; JTR is an independent record delivery service. The ETC Inquiry Service provides usage statements, proof-of-use certificates, and PDF/CSV downloads. NEXCO's official pages warn that 'ETC 2.0 discount amounts are not shown at tollgates or on-board units; they are applied when the card company bills, and can be confirmed via the Inquiry Service.' The ETC Mileage Service handles point accrual and weekday morning/evening discount credits; upcoming midnight-discount reforms will also use deferred rebates via Mileage or Corporate cards. Discount eligibility depends on travel date/time, segment, vehicle class, card, registration status, and excluded dates, so users must cross-check official rules and final billed amounts.",
      whoFor: [
        'Drivers who want to confirm discount application immediately after passage',
        'Accounting staff waiting for discount reflection during monthly expense closing',
        'Vehicle managers tracking discount timing across multiple cards',
        'JTR client companies reconciling daily reports with later billing',
      ],
      jtrSolution: {
        intro: 'JTR is not an official service, but it supports discount verification by organizing and delivering ETC usage records. Daily delivery lets you spot missing trips, suspicious routes, or card misuse early, and the records serve as a ledger when you later reconcile Mileage points or card statements.',
        bullets: [
          'Daily delivery accumulates travel records in your inbox, so you can review history without waiting until month-end',
          'PDF and CSV formats save as reference ledgers for cross-checking with official services',
          'List travel date, segment, time, and card in one view to streamline discount-condition matching',
          'Separate management from Mileage rebates and card billing accommodates timing differences',
          'JTR is independent; it does not determine discounts, provide tax assurance, or produce official data',
        ],
      },
      pdfCsv: 'JTR delivers records in PDF and CSV formats. PDF suits archival, printing, and documentation; CSV suits import into accounting software, sorting, and aggregation. Both organize data retrieved from official services; we do not offer Excel-format exports. Using both formats addresses document management and numerical processing needs.',
      email: 'JTR emails ETC usage records on your chosen schedule. Records arriving in your inbox are archived automatically and serve as a reference ledger when you later reconcile Mileage points or card billing. Many companies adopt this mechanism to reduce manual download effort and prevent missing records.',
      steps: [
        {
          t: 'Wait for usage records to appear in the official inquiry service',
          d: 'Wait for driving records to be reflected in the ETC usage inquiry service. Allow several hours to one day, as reflection is not typically immediate.',
        },
        {
          t: 'Cross-check travel date/time, route, card, and vehicle class against discount conditions',
          d: "Verify the date, time slot, entry/exit points, card used, and vehicle class in the driving record, and compare them with the discount's target sections, time slots, and exclusion dates.",
        },
        {
          t: 'Confirm the discount reflection timing method',
          d: 'Determine whether the discount is applied immediately, on a later card statement, via point redemption, or through a cashback method. The confirmation location differs by discount type.',
        },
        {
          t: 'Check points and cashback amounts in the ETC Mileage Service',
          d: 'Weekday morning/evening discounts and some cashback-method discounts must be verified in the ETC Mileage Service. They will not appear in the driving statement alone.',
        },
        {
          t: 'Review the final billed amount in your card statement if needed',
          d: 'Check the final amount to be debited in your credit card or ETC corporate card statement.',
        },
        {
          t: 'Save PDF and CSV after amounts are confirmed',
          d: 'Once amounts are stable, download the official PDF certificate and CSV statement and store them in your monthly folder.',
        },
      ],
      commonProblems: [
        {
          q: 'Discount amount not visible immediately after driving',
          a: 'Discounted amounts may not appear on the tollgate display or onboard unit. Especially with ETC2.0 discounts, the discount is reflected later on the card statement and can be confirmed via the inquiry service.',
        },
        {
          q: 'Weekday morning/evening discount not shown in the driving statement',
          a: 'Weekday morning/evening discounts use a cashback method. The ETC Mileage Service aggregates the number of trips and sections each month, then credits the cashback amount around the 20th of the following month.',
        },
        {
          q: 'Expected holiday discount but not applied',
          a: 'Discounts may not apply on excluded dates (year-end/new year, Golden Week, Obon, etc.), for non-target sections, vehicle classes, or due to card registration status.',
        },
        {
          q: 'JTR report amounts differ from official records',
          a: 'JTR is a record delivery tool and does not determine discounts or final amounts. Verify final amounts via the official inquiry service, card statement, or mileage service.',
        },
      ],
      examples: [
        {
          who: 'Driver checking on the same day',
          use: "Checked the portal immediately after driving but didn't see the expected result; waited for reflection, then rechecked to avoid filing an incorrect claim.",
        },
        {
          who: 'Commuter',
          use: 'Expected the weekday morning/evening discount but learned that verification requires the ETC Mileage Service, not just the driving statement.',
        },
        {
          who: 'ETC2.0 driver',
          use: 'Onboard unit did not display the discount amount, but later confirmed the discount in the official statement and avoided an unnecessary inquiry.',
        },
        {
          who: 'Monthly accounting team',
          use: 'Set a short grace period at month-end to prevent unnecessary corrections due to delayed reflections or later cashback entries.',
        },
      ],
      faqs: [
        {
          q: 'Does JTR determine discount application?',
          a: 'No. JTR is an independent record delivery service and does not determine discounts. It organizes and delivers records, making it easier for users to review official results.',
        },
        {
          q: 'Can I confirm discount amounts on the tollgate display?',
          a: 'Not typically. Some discounts and later adjustments do not appear on the tollgate or onboard unit; confirmation is needed via the official statement, card billing, or program portal.',
        },
        {
          q: 'Should I keep both PDF and CSV files?',
          a: 'Recommended. The PDF certificate is for document review, while the CSV statement is for sorting, reconciliation, and accounting processing.',
        },
        {
          q: 'Do discount rules change?',
          a: 'Yes. Discount periods, targets, exclusion dates, and program structures may change. Check the latest official operator pages for updates.',
        },
        {
          q: 'How does JTR help with this topic?',
          a: 'JTR delivers and organizes ETC records regularly, streamlining manual review tasks. It does not replace official services or operator rules.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How It Works',
          desc: 'Explains how JTR delivers and organizes ETC records. Understand the division of roles with official inquiry services.',
          path: '/how-it-works',
        },
        {
          title: 'Business Plans',
          desc: 'Centralized management of records for multiple cards and vehicles in monthly folders. Delivery workflows for accounting teams and administrators.',
          path: '/business',
        },
        {
          title: 'Free Trial',
          desc: 'Test the actual record delivery flow, PDF/CSV formats, and email reception to see how it fits your discount verification workflow.',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC Usage Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service for checking driving statements, issuing certificates, and downloading PDF/CSV files',
        },
        {
          label: 'NEXCO East ETC2.0 Discounts',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'Official explanation that discount amounts are not displayed at tollgates or onboard units, but reflected later on card statements',
        },
        {
          label: 'ETC Mileage Service',
          url: 'https://www.smile-etc.jp/',
          note: 'Official site for checking mileage points and weekday morning/evening cashback amounts',
        },
        {
          label: 'NEXCO East Late-Night Discount Revision',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_night_fix/',
          note: 'Official explanation regarding the future transition of late-night discounts to a cashback method',
        },
        {
          label: 'NEXCO East Discount Overview',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: 'Official comprehensive guide on discount types, target conditions, and exclusion dates',
        },
      ],
      longBody: "The timing at which ETC discount details are reflected varies depending on the discount scheme. While some discounts appear immediately in the toll amount, point-redemption and later-refund discount types require checking through a separate service from the usage statement. NEXCO's official page regarding ETC 2.0 discounts notes that the post-discount amount may not appear on the tollgate display or onboard unit screen, and that the final billed amount can be confirmed through the credit card statement or the ETC Usage Inquiry Service. Without understanding this mechanism, judging solely by the screen immediately after passing through the tollgate may lead to the mistaken belief that the discount was not applied. Weekday morning-and-evening discounts and ETC Mileage Service point redemptions must be verified separately within the mileage service account, distinct from the driving records. When corporate accounting staff perform monthly closing procedures, judging only from records immediately after passage can cause them to overlook later-reflected redemptions and adjustments, resulting in unnecessary correction work. For this reason, operational practice recommends allowing a grace period of several days before finalizing records. JTR, as an independent record delivery and organization service, provides an environment where users can regularly receive ETC usage records by email and store them in PDF and CSV formats. JTR is not NEXCO, MEISAI, the ETC Usage Inquiry Service, the ETC Mileage Service, or a road operator; it does not generate official toll data, does not judge whether discounts apply, and does not guarantee refund applications or tax treatment. JTR's role is to help users organize official records and streamline human verification tasks. When a discount is not reflected as expected, first confirm the passage date and time, entry and exit points, vehicle class, card used, applicable section, discount time slot, exclusion dates, and registration status against the official record. Conducting fact-based verification rather than emotional inquiries prevents misunderstandings. Companies can safely document internal regulations for toll expense settlement by specifying that claims must be based on official ETC usage records or approved passage documentation, that discounts are confirmed according to official operator rules and final record amounts, and that while JTR reports may be used as an organization, delivery, and storage tool, official passage data and applicability determinations belong to the official systems and operators. Future changes to the overnight discount toward a later-refund model have also been officially announced, and it is necessary to recognize that discount schemes are not fixed and may vary by period and route. As a practical pattern for record verification, storing PDF certificates, CSV details, driver notes, approval records, and special discount explanations in monthly folders is an effective operation for future audits and inquiries. By utilizing JTR, users can receive records on a daily basis without waiting until month-end, retain an audit trail in their inbox, and support early detection of card misuse, unexpected routes, and unapplied discounts.",
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: 'ETC割引の反映フロー',
            intro: '通行から確認までの記録経路を図解',
            nodes: [
              {
                title: '通行',
                desc: '料金所を通過・車載器に記録',
              },
              {
                title: '即時反映',
                desc: '一部割引は利用明細に即時表示',
              },
              {
                title: '後日還元',
                desc: 'マイレージ・ETC2.0は後日処理',
              },
              {
                title: '照会サービス',
                desc: '公式サイトで記録・証明書確認',
              },
              {
                title: 'カード請求',
                desc: '最終割引額が月次請求に反映',
              },
              {
                title: 'JTR配信',
                desc: '日次メールで履歴を整理・保管',
              },
            ],
          },
          en: {
            title: 'ETC discount reflection flow',
            intro: 'Record path from passage to verification',
            nodes: [
              {
                title: 'Passage',
                desc: 'Pass through toll gate, recorded on OBU',
              },
              {
                title: 'Immediate',
                desc: 'Some discounts appear instantly',
              },
              {
                title: 'Deferred',
                desc: 'Mileage/ETC2.0 processed later',
              },
              {
                title: 'Inquiry service',
                desc: 'Official site shows records/proofs',
              },
              {
                title: 'Card billing',
                desc: 'Final discount in monthly statement',
              },
              {
                title: 'JTR delivery',
                desc: 'Daily email organizes history',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '割引確認の公式ソース',
            intro: '各サービスの役割と確認範囲',
            sources: [
              {
                name: 'ETC利用照会サービス',
                role: '通行記録・証明書・CSV取得',
                url: 'etc-meisai.jp',
                scope: '即時反映割引・通行履歴',
              },
              {
                name: 'ETCマイレージサービス',
                role: 'ポイント残高・平日朝夕割引',
                url: 'smile-etc.jp',
                scope: '還元ポイント・付与履歴',
              },
              {
                name: 'カード会社請求',
                role: '最終請求額・ETC2.0割引',
                url: '各社サイト',
                scope: '月次確定金額・割引適用後',
              },
              {
                name: 'JTR',
                role: '日次配信・記録整理・台帳管理',
                url: 'japantollreceipts.jp',
                scope: '履歴蓄積・照合準備',
              },
            ],
          },
          en: {
            title: 'Official sources for discount verification',
            intro: 'Role and scope of each service',
            sources: [
              {
                name: 'ETC usage inquiry',
                role: 'Trip records, certificates, CSV',
                url: 'etc-meisai.jp',
                scope: 'Immediate discounts, history',
              },
              {
                name: 'ETC mileage service',
                role: 'Point balance, weekday discount',
                url: 'smile-etc.jp',
                scope: 'Reward points, accrual log',
              },
              {
                name: 'Card issuer billing',
                role: 'Final charge, ETC2.0 discount',
                url: 'Issuer sites',
                scope: 'Monthly finalized, post-discount',
              },
              {
                name: 'JTR',
                role: 'Daily delivery, organization, ledger',
                url: 'japantollreceipts.jp',
                scope: 'History archive, reconciliation prep',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '即時反映 vs 後日還元',
            intro: '割引方式別の確認タイミング比較',
            columns: [
              '即時反映型',
              '後日還元型',
            ],
            rows: [
              {
                feature: '料金所表示',
                a: '割引後金額',
                b: '通常料金',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: '車載器画面',
                a: '割引額表示',
                b: '表示なし',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: '利用照会サービス',
                a: '即日確認可',
                b: '数日後反映',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: 'カード請求',
                a: '割引済み金額',
                b: '請求時に減額',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'マイレージ照合',
                a: '不要',
                b: '必須',
                kindA: 'neutral',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'Immediate vs deferred reflection',
            intro: 'Verification timing by discount type',
            columns: [
              'Immediate type',
              'Deferred type',
            ],
            rows: [
              {
                feature: 'Toll gate display',
                a: 'Discounted fare',
                b: 'Standard fare',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'OBU screen',
                a: 'Shows discount',
                b: 'No display',
                kindA: 'yes',
                kindB: 'no',
              },
              {
                feature: 'Inquiry service',
                a: 'Same‑day check',
                b: 'Days later',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: 'Card statement',
                a: 'Discounted amount',
                b: 'Reduced at billing',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'Mileage reconciliation',
                a: 'Not needed',
                b: 'Required',
                kindA: 'neutral',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '割引確認の5ステップ',
            intro: '通行後に実施する照合手順',
            items: [
              {
                text: '通行日時・区間が割引条件に合致しているか確認',
                hint: '時間帯・曜日・除外日をチェック',
              },
              {
                text: 'ETC利用照会サービスで記録が登録されているか照会',
                hint: '通行翌日以降にログイン',
              },
              {
                text: 'マイレージサービスでポイント付与・還元額を確認',
                hint: '平日朝夕・ポイント還元割引',
              },
              {
                text: 'カード会社の月次請求でETC2.0割引額を照合',
                hint: '請求確定後にWeb明細確認',
              },
              {
                text: 'JTR日次記録と公式データを突合し、差異を調査',
                hint: '台帳として履歴を整理保管',
              },
            ],
          },
          en: {
            title: '5‑step discount verification',
            intro: 'Post‑trip reconciliation procedure',
            items: [
              {
                text: 'Confirm date/time/section meet discount criteria',
                hint: 'Check time slot, day, exclusions',
              },
              {
                text: 'Query ETC usage inquiry service for recorded trip',
                hint: 'Log in day after passage',
              },
              {
                text: 'Check mileage service for points and reward amounts',
                hint: 'Weekday commute & point discounts',
              },
              {
                text: 'Reconcile ETC2.0 discount in monthly card statement',
                hint: 'Verify web statement after closing',
              },
              {
                text: 'Cross‑check JTR daily records with official data',
                hint: 'Organize history as ledger',
              },
            ],
          },
        },
      },
    ],
  },

  // 5) 通勤パス社会実験とETC割引の確認ポイント
  {
    slug: 'tsuukin-pass-shakai-jikken-etc-warikibi-guide',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: '通勤パス 社会実験 ETC',
      en: 'commuter pass trial ETC',
    },
    ja: {
      title: '通勤パス社会実験とETC割引 – 記録確認の基礎 | JTR',
      metaDesc: 'ETC通勤パス社会実験の対象区間（NEXCO公表の実施路線）、登録条件、適用される割引率と利用回数の制約、ETC利用照会サービスでの実際の明細確認方法を解説。NEXCO公式情報と利用照会サービスの使い分け、PDF利用証明書・CSV明細の整理手順、独立サービスJTRを併用した月次レビューまで通勤ドライバー向けに整理。',
      h1: '通勤パス社会実験とETC割引の記録確認',
      primaryKeyword: '通勤パス 社会実験 ETC',
      answer: 'ETC通勤パスは全国一律の割引ではなく、NEXCO各社が実施する社会実験です。対象エリア・区間・車種・カード種別・申込期間が限定されており、事前登録と月間利用条件を満たした場合に適用されます。実際の割引額はETC利用照会サービスの明細で確認し、通勤費精算や経理処理に利用します。',
      whyMatters: '通勤ルートが実験対象区間に含まれるドライバーや、従業員の通勤費精算を担当する経理部門にとって重要な情報です。平日朝夕割引との併用可否、登録区間外の走行時の扱い、実際の明細への反映タイミングを理解しておくことで、想定外の請求や精算ミスを防げます。公式サイトで最新の実験期間・条件を確認し、利用後は公式明細で実際の適用結果を記録として保管する流れが基本です。',
      officialBackground: '通勤パスは2024年度から継続されているNEXCO東日本・中日本・西日本の社会実験で、指定区間を定期的に利用する通勤者を対象に最大50%の割引を提供します。対象地域・区間・適用条件は実験年度ごとに見直されるため、NEXCOの公式リリースやDrivePlazaで最新情報を確認する必要があります。車両とETCカードの事前登録が必要で、月内の利用回数や金額条件を満たした場合に翌月以降の料金調整または割引が適用される仕組みです。平日朝夕割引や障害者割引とは別制度のため、併用ルールや優先順位も公式案内で確認します。実際の走行後はETC利用照会サービス（https://www.etc-meisai.jp/）で利用証明書や明細PDFを取得し、通勤費精算や社内記録として保管するのが一般的な流れです。',
      whoFor: [
        '対象エリアで通勤パス実験区間を日常的に利用するドライバー',
        '従業員の通勤費精算ルールを整備する人事・経理担当者',
        '複数のETC割引制度を比較して最適な通勤ルートを検討する企業',
        '月次で通行料金記録を整理・確認する個人事業主や法人管理者',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receiptsは公式ETC利用照会サービスが発行する走行データをもとに、PDF・CSV明細を自動受信・整理する独立サービスです。通勤パスの適用結果を含む月次記録を漏れなく保管し、複数カード・複数車両の一元管理を支援します。',
        bullets: [
          '走行翌日に公式明細PDFとCSVをメール自動配信',
          '通勤パス適用区間と区間外走行を一覧で確認可能',
          'カード別・車両別・月別に記録を分類・保管',
          '日英対応インターフェースで海外出張者や外資系経理も利用しやすい',
          '利用照会サービスの15ヶ月・62日制限を気にせず過去記録を参照',
        ],
      },
      pdfCsv: 'PDF明細は人間が目視確認しやすく、精算申請や監査資料として提出する際に適しています。CSV明細は月次集計・カード横断比較・会計ソフト取込に便利です。通勤パスのような条件付き割引では、実際の適用結果を両形式で保管しておくと後日の確認がスムーズです。',
      email: 'JTRは走行翌日に登録メールアドレスへPDFとCSVを自動送信します。手動ログイン・ダウンロード忘れを防ぎ、月末締め処理や四半期レビュー時に必要な記録が受信トレイに揃います。複数担当者への同時配信設定も可能で、チーム内の情報共有が円滑になります。',
      steps: [
        {
          t: '社会実験の実施地域と対象区間を確認',
          d: 'NEXCO公式ページで通勤パス社会実験が自分の通勤区間で実施されているか、対象都府県・IC区間・車種・ETCカード種別を確認します。',
        },
        {
          t: '事前登録と申込期限の確認',
          d: '対象区間の登録が必要な場合は、利用月の前月までに車両・区間・ETCカードを公式サイトで登録します。申込期限を過ぎると適用されません。',
        },
        {
          t: '指定区間内で通勤走行を実施',
          d: '登録した区間を月内に規定回数以上走行します。区間外や条件未達の場合は通常料金が適用されるため、走行記録を意識して利用します。',
        },
        {
          t: 'ETC利用照会サービスで実際の請求額を確認',
          d: '走行後、ETC利用照会サービスで利用明細を確認し、通勤パス割引が適用されているか、請求額が想定通りかを照合します。',
        },
        {
          t: '公式PDFとCSVの両方を保管',
          d: '会社精算や記録保管が必要な場合は、ETC利用照会サービスからPDFとCSV両方をダウンロードし、月次で整理します。',
        },
        {
          t: 'JTRで継続的な記録管理を自動化',
          d: 'Japan Toll Receiptsを利用すると、公式データをもとにしたPDF・CSV記録がメール配信され、手動ダウンロード漏れや整理負担を軽減できます。',
        },
      ],
      commonProblems: [
        {
          q: '通勤パスはどこでも使えますか',
          a: 'いいえ。通勤パス社会実験は対象都府県・指定区間・車種・カード種別が限定されています。NEXCO公式ページで実施地域と条件を通常は確認してください。',
        },
        {
          q: '割引は自動適用されますか',
          a: '事前登録が必要な場合が多く、登録なしでは通常料金が適用されます。また月内利用回数などの条件を満たさないと割引対象外になることがあります。',
        },
        {
          q: '料金見積りと実際の請求額が違う理由は',
          a: '料金見積りツールは目安であり、割引適用・時間帯・経路・登録状況により実際の請求額は変動します。ETC利用照会サービスで確定額を確認してください。',
        },
        {
          q: 'JTRは公式サービスですか',
          a: 'いいえ。JTRは独立した記録配信・整理サービスです。割引判定や公式データ作成はNEXCO・ETC利用照会サービスが行い、JTRは記録取得を支援します。',
        },
      ],
      examples: [
        {
          who: '対象地域の通勤ドライバー',
          use: '公式サイトで区間登録し、月内規定回数走行後、ETC利用照会サービスとJTRで割引適用を確認し精算資料として保管。',
        },
        {
          who: '通勤手当を支給する企業人事',
          use: '社員が通勤パスを利用しているか、別の割引制度か、公式明細とJTR記録で照合し適正な精算処理を実施。',
        },
        {
          who: '実験対象外地域のドライバー',
          use: '自分の通勤区間が社会実験対象外と確認し、平日朝夕割引など他の制度をNEXCO公式で調べて比較検討。',
        },
        {
          who: '経理担当者',
          use: 'JTRから配信されたCSV記録と公式登録期間を照合し、通勤パス適用月の請求額が条件通りか月次で確認。',
        },
      ],
      faqs: [
        {
          q: '通勤パス社会実験とは何ですか',
          a: 'NEXCO等が実施する期間・地域・区間限定の割引実験です。事前登録と月内利用条件を満たすと最大50%割引が適用される場合がありますが、対象は限定的です。',
        },
        {
          q: 'JTRで割引適用を判定できますか',
          a: 'いいえ。割引判定と適用はNEXCOなど公式事業者が行います。JTRは公式データをもとにした記録配信・整理を支援し、適用結果の確認を容易にします。',
        },
        {
          q: 'PDFとCSVどちらを保管すべきですか',
          a: '可能なら両方を保管してください。PDFは人間が確認しやすく、CSVは複数カード・複数月の集計や会計システムへの取込に便利です。',
        },
        {
          q: '割引や料金は変動しますか',
          a: 'はい。道路・日時・車種・経路・登録状況・実験期間により変動します。最新条件はNEXCO公式ページで確認し、実際の請求額は公式明細で照合してください。',
        },
        {
          q: '企業はどう記録管理すべきですか',
          a: 'ETCカードと運転者・車両・部署を紐付け、月次でPDF・CSVを取得・保管する運用が推奨されます。JTRは配信自動化で取得漏れを減らせます。',
        },
      ],
      relatedFeatures: [
        {
          title: '無料トライアル',
          desc: 'JTRの記録配信・整理機能を実際に試し、通勤パス利用後の明細取得がどう楽になるか体験できます。',
          path: '/free-trial',
        },
        {
          title: '仕組みと使い方',
          desc: '公式ETC利用照会サービスのデータをもとに、JTRがPDF・CSVを配信・保管する流れを詳しく解説します。',
          path: '/how-it-works',
        },
        {
          title: '法人向けプラン',
          desc: '複数カード・複数車両の通勤記録を一元管理し、精算業務と月次照合を効率化する企業向け機能を紹介します。',
          path: '/business',
        },
      ],
      references: [
        {
          label: 'NEXCO東日本 2026年度通勤パス継続のお知らせ',
          url: 'https://www.e-nexco.co.jp/pressroom/head_office/2026/0303/00015995.html',
          note: '2026年4月1日から2027年3月31日まで継続、指定区間で条件達成時最大50%割引の公式発表。',
        },
        {
          label: 'NEXCO東日本 通勤パス公式ページ',
          url: 'https://www.driveplaza.com/etc/dis/etc_commuter/',
          note: '通勤パス条件、プリペイド額超過時・区間外走行時の取扱いなど詳細説明。',
        },
        {
          label: 'NEXCO西日本 通勤パス社会実験のお知らせ',
          url: 'https://corp.w-nexco.co.jp/corporate/release/hq/r7/0314a/',
          note: 'NEXCO西日本管内での社会実験実施と申込条件の公式通知。',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETC利用明細確認・利用証明書発行・PDF/CSVダウンロードを行う公式サービス。',
        },
        {
          label: 'ETC総合情報ポータル 利用照会サービス説明',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '通常ETCカード15か月・法人カード62日の照会期間とPDF/CSV取得方法の公式解説。',
        },
      ],
      longBody: '通勤パス社会実験は、全国一律のETC割引ではなく、NEXCO各社が指定した区間・期間・車両クラス・カード種別において試行される限定的な施策です。2026年度も継続が発表されていますが、対象エリアや申込条件は年度ごとに見直されるため、利用前に通常は公式ページで最新の実施要綱を確認する必要があります。NEXCO東日本・中日本・西日本それぞれが対象区間と割引率を定めており、たとえば最大50パーセント割引が適用される区間では、事前登録した車両とカードで指定IC間を月内規定回数以上走行した場合に割引が成立します。ただし、登録区間外の走行や登録外カードでの通行には適用されず、また平日朝夕割引など他の時間帯割引との併用可否も公式ルールに従います。利用者が最も注意すべき点は、割引適用の最終判定が通行後に行われることです。通行時点では正規料金が引き落とされ、後日条件を満たした場合に還元または調整される仕組みのため、リアルタイムでの割引確認はできません。このため、月末に公式ETC利用照会サービスで利用明細PDFおよびCSVをダウンロードし、登録区間・回数・割引額が正しく反映されているかを照合する作業が不可欠です。企業の経理担当者や個人事業主にとっては、通勤実費精算や帳簿作成のために複数月分の記録を整理する負担が大きく、カード枚数や車両台数が増えるほど手作業でのダウンロードと保管は煩雑になります。Japan Toll Receiptsは、この記録取得と整理の工程を自動化する独立サービスとして機能します。JTRは公式の割引判定や料金決定を行う主体ではなく、公式システムが生成した利用明細データをPDFとCSV両形式でメール配信し、カード別・車両別・月別に分類して保管する役割を担います。通勤パス適用後の実績確認、複数カードの一元管理、年度末の帳簿突合といった場面で、JTRの継続配信機能は手間を軽減します。ただし最終的な割引適用可否や料金確定は公式オペレーターが決定するため、疑義がある場合は通常はNEXCO各社の窓口またはETC利用照会サービスの公式記録を参照してください。通勤パス社会実験の対象外エリアに居住する利用者や、登録要件を満たさない車両では割引は発生しないため、事前の資格確認と事後の明細照合を両輪で進めることが安全な運用の基本です。',
    },
    en: {
      title: 'ETC Commuter Pass Trial & Discount Record Checks | JTR',
      metaDesc: 'How to check ETC commuter pass trial eligibility, registration requirements, and statement records. Explains NEXCO official data vs. ETC inquiry service, plus PDF/CSV filing steps.',
      h1: 'Commuter Pass Trial & ETC Discount Record Checks',
      primaryKeyword: 'commuter pass trial ETC',
      answer: 'ETC commuter passes are not nationwide discounts but regional trials run by each NEXCO company. Eligibility is limited by area, route segment, vehicle class, card type, and registration period. Discounts apply only when pre-registration and monthly usage conditions are met. Actual discount amounts appear in ETC inquiry service statements and are used for commute reimbursement and accounting.',
      whyMatters: 'Critical for drivers whose commute routes fall within trial zones and for finance teams handling employee travel reimbursements. Understanding overlap rules with weekday time-of-day discounts, how off-corridor trips are handled, and statement reflection timing prevents billing surprises and settlement errors. The standard workflow is to confirm current trial periods and conditions on official NEXCO sites, then retain official statements post-trip as supporting records.',
      officialBackground: 'The commuter pass trial launched in fiscal 2024 by NEXCO East, Central, and West offers up to 50% discounts for regular commuters on designated segments. Target regions, corridors, and eligibility rules are reviewed annually, so drivers must check the latest announcements on NEXCO releases and DrivePlaza. Vehicle and ETC card pre-registration is mandatory; discounts apply via billing adjustment or credit in following months when monthly trip count or spend thresholds are met. Because the pass is separate from weekday time-of-day and disability discounts, overlap rules and priority must be confirmed in official guidance. After each trip, users download usage certificates and statement PDFs from the ETC inquiry service (https://www.etc-meisai.jp/) for reimbursement filings and internal record-keeping.',
      whoFor: [
        'Drivers who regularly use trial-corridor segments in eligible regions',
        'HR and finance staff establishing employee commute reimbursement policies',
        'Companies comparing multiple ETC discount schemes to optimize commute routes',
        'Sole proprietors and corporate administrators organizing monthly toll records',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts is an independent service that automatically receives and organizes the PDF and CSV statements issued by the official ETC inquiry portal. JTR ensures in-depth monthly records—including commuter pass outcomes—are stored without gaps and supports unified management across multiple cards and vehicles.',
        bullets: [
          'Auto-deliver official PDF and CSV statements by email the day after travel',
          'View commuter pass-eligible segments and out-of-corridor trips in one list',
          'Classify records by card, vehicle, and month for easy retrieval',
          'Bilingual interface suits international assignees and multinational finance teams',
          "Access past records beyond the inquiry service's 15-month and 62-day limits",
        ],
      },
      pdfCsv: 'PDF statements are human-readable and ideal for attaching to reimbursement claims or audit files. CSV statements streamline monthly roll-ups, cross-card comparisons, and import into accounting software. For conditional discounts like commuter passes, keeping both formats ensures smooth retrospective checks.',
      email: 'JTR sends PDF and CSV files to your registered address the day after each trip. Automated delivery eliminates manual login and download gaps, so end-of-month closings and quarterly reviews have all necessary records waiting in your inbox. Multi-recipient setup is supported for seamless team collaboration.',
      steps: [
        {
          t: 'Check pilot area and eligible sections',
          d: 'Visit NEXCO official pages to confirm whether the commuter pass pilot covers your commute route, eligible prefecture, IC sections, vehicle class, and ETC card type.',
        },
        {
          t: 'Verify pre-registration and deadlines',
          d: 'When section registration is required, register your vehicle, route, and ETC card on the official site by the end of the month before use. Missing the deadline means no discount.',
        },
        {
          t: 'Drive designated sections for qualifying trips',
          d: 'Make the required number of trips within the registered section during the month. Trips outside the section or below the threshold revert to standard tolls, so track usage carefully.',
        },
        {
          t: 'Review actual charges via ETC inquiry service',
          d: 'After driving, check your usage detail on the ETC Meisai service to confirm the commuter pass discount was applied and the billed amount matches expectations.',
        },
        {
          t: 'Save both official PDF and CSV files',
          d: 'For company reimbursement or record-keeping, download both PDF and CSV from the ETC inquiry service and organize them monthly.',
        },
        {
          t: 'Automate ongoing record management with JTR',
          d: 'Japan Toll Receipts delivers PDF and CSV records based on official data by email, reducing manual download gaps and organizing burden.',
        },
      ],
      commonProblems: [
        {
          q: 'Can I use the commuter pass anywhere?',
          a: 'No. The commuter pass pilot is limited to specific prefectures, designated sections, vehicle classes, and card types. typically check NEXCO official pages for eligible areas and conditions.',
        },
        {
          q: 'Is the discount applied automatically?',
          a: 'Pre-registration is usually required; without it, standard tolls apply. Also, failing to meet monthly trip counts or other conditions can disqualify you from the discount.',
        },
        {
          q: 'Why do estimates differ from actual bills?',
          a: 'Estimate tools provide rough figures; actual charges vary by discount status, time of day, route, and registration. Confirm final amounts on the ETC inquiry service.',
        },
        {
          q: 'Is JTR an official service?',
          a: 'No. JTR is an independent record-delivery and organization service. Discount decisions and official data creation are handled by NEXCO and the ETC inquiry service; JTR supports retrieval.',
        },
      ],
      examples: [
        {
          who: 'Commuter driver in eligible area',
          use: 'Register section on official site, make required monthly trips, then confirm discount via ETC inquiry service and JTR, and store for reimbursement.',
        },
        {
          who: 'HR staff issuing commuter allowances',
          use: 'Cross-check whether employees use commuter pass or other discount schemes by comparing official statements and JTR records for proper reimbursement.',
        },
        {
          who: 'Driver outside pilot area',
          use: 'Confirm own commute route is ineligible for the pilot, then research other schemes like weekday peak-hour discounts on NEXCO official pages for comparison.',
        },
        {
          who: 'Accounting staff',
          use: 'Compare CSV records delivered by JTR against official registration periods to verify monthly charges match commuter pass conditions.',
        },
      ],
      faqs: [
        {
          q: 'What is the commuter pass pilot?',
          a: 'A limited-term, limited-area discount trial run by NEXCO and others. Pre-registration and monthly usage conditions can yield up to 50% off, but eligibility is narrow.',
        },
        {
          q: 'Can JTR determine discount eligibility?',
          a: 'No. Discount decisions and application are made by NEXCO and other official operators. JTR delivers and organizes records based on official data, making it easier to review applied discounts.',
        },
        {
          q: 'Should I keep PDF or CSV, or both?',
          a: 'Keep both if possible. PDF is easy for human review; CSV is convenient for multi-card, multi-month aggregation and import into accounting systems.',
        },
        {
          q: 'Do discounts and tolls change?',
          a: 'Yes. They vary by road, date, time, vehicle class, route, registration status, and pilot period. Check latest conditions on NEXCO official pages and verify actual charges on official statements.',
        },
        {
          q: 'How should companies manage records?',
          a: 'Link ETC cards to drivers, vehicles, and departments, then retrieve and store PDF and CSV monthly. JTR automates delivery to reduce missed downloads.',
        },
      ],
      relatedFeatures: [
        {
          title: 'Free Trial',
          desc: "Experience JTR's record-delivery and organization features to see how retrieving statements after commuter pass use becomes easier.",
          path: '/free-trial',
        },
        {
          title: 'How It Works',
          desc: 'Learn how JTR delivers and stores PDF and CSV based on data from the official ETC inquiry service.',
          path: '/how-it-works',
        },
        {
          title: 'Business Plan',
          desc: 'Centralize commute records for multiple cards and vehicles, streamlining reimbursement and monthly reconciliation for enterprises.',
          path: '/business',
        },
      ],
      references: [
        {
          label: 'NEXCO East 2026 Commuter Pass Continuation Notice',
          url: 'https://www.e-nexco.co.jp/pressroom/head_office/2026/0303/00015995.html',
          note: 'Official announcement continuing the pilot from April 1, 2026 to March 31, 2027 with up to 50% off on designated sections when conditions are met.',
        },
        {
          label: 'NEXCO East Commuter Pass Official Page',
          url: 'https://www.driveplaza.com/etc/dis/etc_commuter/',
          note: 'Details on commuter pass conditions, handling of prepaid-balance overruns and out-of-section trips.',
        },
        {
          label: 'NEXCO West Commuter Pass Pilot Announcement',
          url: 'https://corp.w-nexco.co.jp/corporate/release/hq/r7/0314a/',
          note: 'Official notice of pilot implementation and application requirements within NEXCO West territory.',
        },
        {
          label: 'ETC Meisai Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service for checking ETC usage detail, issuing usage certificates, and downloading PDF and CSV files.',
        },
        {
          label: 'ETC General Portal—Inquiry Service Explanation',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Official guide to 15-month inquiry period for personal cards, 62-day for corporate cards, and PDF/CSV retrieval methods.',
        },
      ],
      longBody: "The Commuter Pass Social Experiment is not a nationwide ETC discount but a limited trial implemented by each NEXCO company for designated sections, periods, vehicle classes, and card types. Although continuation through fiscal 2026 has been announced, eligible areas and registration requirements are revised annually, so users must check the official pages for the latest implementation guidelines before use. NEXCO East, Central, and West each define target sections and discount rates; for example, routes offering up to 50 percent discount apply the benefit when a pre-registered vehicle and card in-depth the specified number of trips between designated interchanges within a month. However, travel outside the registered section or payment with an unregistered card disqualifies the discount, and rules for concurrent use with other time-based discounts such as weekday morning-evening discounts follow official policy. The most important point for users is that final discount determination occurs after travel. At the time of passage, the standard toll is deducted, and if conditions are later met, a refund or adjustment is applied, meaning real-time discount confirmation is not possible. Therefore, it is essential to download the usage statement PDF and CSV from the official ETC inquiry service at month-end and verify that the registered section, trip count, and discount amount are correctly reflected. For corporate accounting staff and sole proprietors, organizing records across multiple months for commuting expense reimbursement and bookkeeping becomes burdensome, and as the number of cards and vehicles grows, manual download and storage grow increasingly complex. Japan Toll Receipts functions as an independent service that automates this retrieval and organization process. JTR does not perform official discount determination or toll calculation; rather, it delivers usage statement data generated by the official system in both PDF and CSV formats via email, then sorts and stores records by card, vehicle, and month. For confirming post-discount results, centrally managing multiple cards, and reconciling year-end accounts, JTR's continuous delivery feature reduces manual effort. However, final discount eligibility and toll amounts are determined by the official operator, so any discrepancies must be resolved by consulting NEXCO company service desks or the official ETC inquiry service records. Users residing outside the Commuter Pass trial area or operating vehicles that do not meet registration requirements will receive no discount, making both advance eligibility checks and post-trip statement reconciliation the foundation of safe operation.",
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: '通勤パス適用までの流れ',
            intro: '事前登録から割引適用、明細確認までの4ステップ',
            nodes: [
              {
                title: '対象区間・条件確認',
                desc: 'NEXCO公式サイトで実験エリア・車種・期間を確認',
              },
              {
                title: '車両・カード登録',
                desc: 'DrivePlazaで事前申込、登録完了を待つ',
              },
              {
                title: '月間利用条件達成',
                desc: '指定区間を規定回数・金額以上走行',
              },
              {
                title: '割引適用・明細保管',
                desc: 'ETC利用照会サービスでPDF・CSV取得',
              },
            ],
          },
          en: {
            title: 'Commuter Pass Application Flow',
            intro: 'Four steps from registration to discount confirmation',
            nodes: [
              {
                title: 'Check Eligibility',
                desc: 'Verify target routes, vehicle types & period on NEXCO sites',
              },
              {
                title: 'Register Vehicle & Card',
                desc: 'Apply via DrivePlaza, wait for approval',
              },
              {
                title: 'Meet Monthly Criteria',
                desc: 'Drive designated routes at required frequency/amount',
              },
              {
                title: 'Apply & Archive Records',
                desc: 'Download PDF/CSV from ETC Statement Service',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '公式情報源マップ',
            intro: '通勤パス実験と利用記録の確認に必要な4つの公式サイト',
            sources: [
              {
                name: 'NEXCO各社公式',
                role: '実験概要・対象区間',
                url: 'www.e-nexco.co.jp 他',
                scope: '東日本・中日本・西日本各社のニュースリリース',
              },
              {
                name: 'DrivePlaza',
                role: '登録申込・条件詳細',
                url: 'www.driveplaza.com',
                scope: '車両・カード登録、マイページ管理',
              },
              {
                name: 'ETC利用照会サービス',
                role: '走行明細・適用結果',
                url: 'www.etc-meisai.jp',
                scope: 'PDF・CSV明細、利用証明書発行',
              },
              {
                name: 'Japan Toll Receipts',
                role: '明細自動配信・整理',
                url: 'japantollreceipts.jp',
                scope: '翌日メール送信、複数カード一元管理',
              },
            ],
          },
          en: {
            title: 'Official Source Map',
            intro: 'Four essential sites for commuter pass info and usage records',
            sources: [
              {
                name: 'NEXCO Companies',
                role: 'Trial overview & routes',
                url: 'www.e-nexco.co.jp etc.',
                scope: 'East/Central/West Japan press releases',
              },
              {
                name: 'DrivePlaza',
                role: 'Registration & criteria',
                url: 'www.driveplaza.com',
                scope: 'Vehicle/card enrollment, account dashboard',
              },
              {
                name: 'ETC Statement Service',
                role: 'Trip details & discount proof',
                url: 'www.etc-meisai.jp',
                scope: 'PDF/CSV download, usage certificates',
              },
              {
                name: 'Japan Toll Receipts',
                role: 'Auto-delivery & filing',
                url: 'japantollreceipts.jp',
                scope: 'Next-day email, multi-card consolidation',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '通勤パス vs 平日朝夕割引',
            intro: '2つの通勤向け割引制度の違いを比較',
            columns: [
              '通勤パス実験',
              '平日朝夕割引',
            ],
            rows: [
              {
                feature: '対象エリア',
                a: '実験区間のみ（限定）',
                b: '全国の主要路線',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '事前登録',
                a: '必須（車両・カード）',
                b: '必須（ETCマイレージ）',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: '割引率',
                a: '最大50%',
                b: '最大50%（還元）',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: '併用可否',
                a: '公式案内で確認',
                b: '公式案内で確認',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: '明細確認',
                a: 'ETC利用照会サービス',
                b: 'ETC利用照会サービス',
                kindA: 'yes',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'Commuter Pass vs. Weekday Discount',
            intro: 'Key differences between two commuter-focused discount programs',
            columns: [
              'Commuter Pass Trial',
              'Weekday Time Discount',
            ],
            rows: [
              {
                feature: 'Coverage',
                a: 'Trial routes only (limited)',
                b: 'Nationwide major routes',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Pre-registration',
                a: 'Required (vehicle & card)',
                b: 'Required (ETC Mileage)',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'Discount rate',
                a: 'Up to 50%',
                b: 'Up to 50% (rebate)',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'Stacking',
                a: 'Check official rules',
                b: 'Check official rules',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: 'Statement access',
                a: 'ETC Statement Service',
                b: 'ETC Statement Service',
                kindA: 'yes',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '通勤パス利用前チェックリスト',
            intro: '登録・走行・記録の3段階で確認すべき6項目',
            items: [
              {
                text: '実験期間と対象区間を公式サイトで確認',
                hint: '年度ごとに条件が変わるため最新情報を確認',
              },
              {
                text: '車両・ETCカードをDrivePlazaで登録',
                hint: '承認完了メールを受信してから走行開始',
              },
              {
                text: '月間利用条件（回数・金額）を把握',
                hint: '条件未達の月は割引が適用されない',
              },
              {
                text: '走行後、ETC利用照会サービスで明細確認',
                hint: '通行日の翌日以降にPDF・CSVが取得可能',
              },
              {
                text: '割引適用結果を月次で記録保管',
                hint: '精算申請や監査時に必要な証跡となる',
              },
              {
                text: 'JTR自動配信で受信トレイに明細蓄積',
                hint: '手動ログイン不要、15ヶ月制限を回避',
              },
            ],
          },
          en: {
            title: 'Commuter Pass Pre-Use Checklist',
            intro: 'Six checkpoints across registration, driving, and record-keeping',
            items: [
              {
                text: 'Verify trial period & eligible routes on official sites',
                hint: 'Conditions update annually—always check latest info',
              },
              {
                text: 'Register vehicle & ETC card via DrivePlaza',
                hint: 'Wait for approval email before starting trial trips',
              },
              {
                text: 'Understand monthly usage criteria (trips/amount)',
                hint: 'No discount if monthly threshold not met',
              },
              {
                text: 'Check statements on ETC service after trips',
                hint: 'PDF/CSV available day after travel',
              },
              {
                text: 'Archive discount results monthly',
                hint: 'Critical for reimbursement & audit trails',
              },
              {
                text: 'Auto-receive via JTR inbox delivery',
                hint: 'No manual login, bypass 15-month retention limit',
              },
            ],
          },
        },
      },
    ],
  },

  // 6) ETC2.0割引の対象道路と確認方法
  {
    slug: 'etc-2-warikibi-taishou-douro-guide',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETC2.0割引対象道路',
      en: 'ETC2.0 eligible roads',
    },
    ja: {
      title: 'ETC2.0割引対象道路の確認方法と請求額の照合手順 | JTR',
      metaDesc: 'ETC2.0割引が適用される道路区間（圏央道・新湘南バイパス・東海環状自動車道など）の最新一覧、ETCレーン通過時の料金表示と最終請求額の差、ETC利用照会サービスのPDF利用証明書・CSV明細での照合手順、独立サービスJTRで割引適用後の金額を継続的に確認する運用までまとめました。',
      h1: 'ETC2.0割引対象道路と適用条件の確認方法',
      primaryKeyword: 'ETC2.0割引対象道路',
      answer: 'ETC2.0割引はすべての道路で適用されるわけではありません。NEXCO東日本の公式ページでは、圏央道の茅ヶ崎JCT～海老名南JCT・海老名～木更津JCT区間や新湘南バイパスの藤沢～茅ヶ崎JCT区間が対象として示されています。割引を受けるには、ETC2.0車載器の正しいセットアップとETC無線通信での通行が必要です。料金所表示や車載器の音声では割引額が表示されない場合があるため、最終請求額はETC利用照会サービスやカード明細で確認することが推奨されます。',
      whyMatters: 'ETC2.0導入を検討する企業や個人にとって、実際の利用ルートが割引対象区間に含まれるかどうかの確認は投資判断の重要な要素です。車載器購入費用に対して月間通行料がどれだけ削減できるかを事前に見積もることで、費用対効果を適切に評価できます。また、経理担当者が「割引が適用されるはず」という申告を受けた際、対象区間・車両クラス・通行日時・カード種別・セットアップ状態を公式情報と照合することで、感情的な議論ではなく事実に基づく確認プロセスが可能になります。割引制度は変更される場合があるため、現時点の公式ルールを常に参照する習慣が、誤解や期待外れを防ぎます。',
      officialBackground: 'ETC利用の公式記録層はJTRではありません。公式記録層は道路事業者、ETCカード会社、ETC利用照会サービスから始まります。利用照会サービスは、ドライバーが利用明細を確認し、利用証明書を印刷し、PDFやCSV形式で記録をダウンロードする場所です。割引に関する具体的なルールは、NEXCO各社の公式ページ、ETCマイレージサービス、ETC2.0専用ページが管理しています。割引や経費精算に関する記事は、断定的な表現を避けることが重要です。「割引が適用されなかった」という質問に対して、推測ではなく、正確な日時・車両区分・カード・ルート・道路事業者・登録状態・公式明細を確認するよう案内することが安全です。JTRは利用者が整理された日次記録を受け取る手助けをしますが、割引の最終判定は料金システムと事業者ルールに委ねられます。',
      whoFor: [
        '圏央道エリアで定期的に通行し、ETC2.0導入を検討している個人ドライバー',
        '複数車両を保有し、東京外環状エリアで車載器アップグレードの費用対効果を評価する企業',
        '従業員から「割引が適用されるはず」という申告を受け、公式情報との照合が必要な経理担当者',
        '中古車購入時にETC2.0ラベルを見つけ、セットアップ状態と対象ルートを再確認したい購入者',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts（JTR）は、独立した記録配信・整理サービスです。JTRはNEXCO、MEISAI、ETC利用照会サービス、ETCマイレージサービス、道路事業者ではありません。JTRは公式な料金データを作成せず、割引適用の可否を判定せず、経費精算の承認を保証しません。JTRは手作業を減らし、整理されたPDF・CSV記録を配信することで、人間による確認作業を支援します。',
        bullets: [
          '月末まで待たず、ETC利用記録を定期的にメールで受信',
          '受信箱に実用的な取扱履歴を作成し、未確認通行や想定外ルートの早期発見を支援',
          'PDF形式は書類形式のレビューに適し、CSV形式は並べ替え・照合・会計作業に適した整理',
          '割引適用の有無や最終請求額の確認は、公式サービスと事業者ルールで照合',
          'JTR記録を補助ツールとして利用し、公式な料金源として扱わない運用を推奨',
        ],
      },
      pdfCsv: 'JTRはPDF形式とCSV形式でETC利用記録を提供します。PDF形式は利用証明書として印刷・保管に適しており、CSV形式はExcelや会計ソフトでの並べ替え・集計・照合作業に便利です。両形式を保管することで、書類レビューとデータ分析の両方に対応できます。JTRはExcelファイル（XLSX）を出力しません。',
      email: 'JTRは設定した頻度でETC利用記録をメールで自動配信します。月次・週次など選択可能な配信スケジュールにより、経理担当者や管理者は手動ダウンロードの手間を省き、受信箱内で時系列の記録アーカイブを維持できます。配信されたPDF・CSVファイルは、そのまま社内承認フローや会計システムへ転送可能です。',
      steps: [
        {
          t: 'ETC2.0車載器が正しくセットアップされているか確認',
          d: '通常のETC車載器ではなく、ETC2.0対応の車載器が車両に搭載され、正しくセットアップされていることを確認してください。割引適用にはETC2.0機器が必要です。',
        },
        {
          t: '公式の対象道路区間を事前に確認',
          d: 'すべての高速道路でETC2.0割引が適用されるわけではありません。NEXCO東日本などの公式ページで、利用予定の区間が割引対象かどうかを事前に確認してください。',
        },
        {
          t: 'ETC無線通信で入口・出口を通過',
          d: '割引を受けるには、ETC設備が整った入口ICと出口ICをETC無線通信で通過する必要があります。一般レーンや現金利用では割引が適用されません。',
        },
        {
          t: '料金所表示やOBU音声に頼らない',
          d: '割引後の金額が料金所の表示や車載器の音声に反映されない場合があります。割引は後日請求時に反映されることがあるため、最終確認は別途行ってください。',
        },
        {
          t: 'ETC利用照会サービスまたはカード明細で最終請求額を確認',
          d: '実際に割引が適用されたかは、ETC利用照会サービスやカード会社の請求明細で最終的な請求額を確認してください。これが公式な記録となります。',
        },
        {
          t: '法人は導入コストと実際の走行ルートを比較検討',
          d: '複数台の車両を管理する法人は、車載器の更新費用と実際の走行ルート、月間通行料金を比較し、ETC2.0への切り替えが費用対効果に見合うか検討してください。',
        },
      ],
      commonProblems: [
        {
          q: '圏央道を走ったのに割引が適用されなかった',
          a: 'ETC2.0割引は圏央道の全区間が対象ではありません。公式ページで対象区間を確認し、車載器がETC2.0であること、入退出がETC無線通信で行われたことを確認してください。車両クラスや日時による除外条件がある場合もあります。',
        },
        {
          q: '料金所で割引後の金額が表示されなかった',
          a: 'NEXCO公式情報によれば、ETC2.0割引額は料金所の表示や車載器に表示されないことがあります。後日、カード請求やETC利用照会サービスで割引が反映されているか確認してください。',
        },
        {
          q: 'JTRで割引が適用されたか判定できるか',
          a: 'JTRは記録の整理・配信サービスであり、割引適用の判定機関ではありません。割引の有無は、公式のETC利用照会サービスやカード明細、道路事業者の規定で確認してください。JTRは確認作業を整理するために役立ちます。',
        },
        {
          q: '中古車に付いていたETC2.0機器でも割引されるか',
          a: 'ETC2.0のラベルがあっても、車両に対して正しく再セットアップされていなければ割引が適用されない場合があります。購入後に車載器のセットアップ状況を確認し、必要に応じて再セットアップを行ってください。',
        },
      ],
      examples: [
        {
          who: '圏央道エリアの通勤ドライバー',
          use: '新しい車載器を購入する前に、自分が普段利用する入口IC・出口ICの組み合わせが公式のETC2.0割引対象区間に含まれているかを確認し、投資効果を判断する。',
        },
        {
          who: '東京外環エリアの法人車両管理者',
          use: '複数の社用車が走行する実際のルートと月間通行料金を集計し、対象区間と照合することで、ETC2.0車載器への更新費用に見合う割引効果があるか見積もる。',
        },
        {
          who: '経理担当者',
          use: 'ドライバーが新湘南バイパスでETC2.0割引が適用されたはずだと主張した際、公式のETC2.0割引ページと利用照会サービスで実際の請求額と対象条件を確認する。',
        },
        {
          who: 'JTR利用中の個人ドライバー',
          use: 'JTRで日次の利用記録を受け取り整理しながら、割引が適用されたと思われる走行について公式の利用照会サービスで最終請求額を照合し、記録を保管する。',
        },
      ],
      faqs: [
        {
          q: 'JTRはETC2.0割引の適用可否を判定しますか?',
          a: 'いいえ。JTRは独立した記録配信・整理サービスであり、割引判定は行いません。公式の道路事業者やETC利用照会サービスの情報をもとに、利用者が確認作業を行う際の整理を支援します。',
        },
        {
          q: '料金所の表示で割引後の金額を確認できますか?',
          a: '通常はしもできません。割引や後日調整が料金所表示や車載器音声に反映されない場合があります。最終的な請求額は、カード明細、ETC利用照会サービス、プログラムポータルなどで確認してください。',
        },
        {
          q: '法人はPDFとCSVの両方を保管すべきですか?',
          a: 'はい。PDFは書類形式のレビューや保管に適しており、CSVはソート、照合、会計処理に便利です。両方を月次で整理しておくことで、監査や経費精算の際にスムーズな確認が可能になります。',
        },
        {
          q: 'ETC2.0割引のルールは変更されることがありますか?',
          a: 'はい。割引の対象期間、対象区間、除外日、プログラム構成などは変更される可能性があります。利用前に現在の公式ページで最新の情報を確認することをお勧めします。',
        },
        {
          q: '期待した割引が適用されていない場合、通常はエラーですか?',
          a: 'いいえ。車両クラス、対象外道路、除外日、走行ルート、登録状況、通行時刻、カード不一致、ポイント還元型プログラムの後日処理など、さまざまな理由が考えられます。公式記録と条件を照合して原因を確認してください。',
        },
      ],
      relatedFeatures: [
        {
          title: 'JTRの仕組み',
          desc: 'JTRがどのようにETC利用記録を整理・配信し、月次の確認作業を効率化するかを説明します。',
          path: '/how-it-works',
        },
        {
          title: '法人向けプラン',
          desc: '複数車両のETC記録を一元管理し、経理承認や確認対応の準備を支援する法人向け機能を紹介します。',
          path: '/business',
        },
        {
          title: '無料トライアル',
          desc: 'JTRの記録配信とPDF・CSV出力を実際に試し、自社の業務フローに適合するか確認できます。',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'NEXCO東日本 ETC2.0割引',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: '公式の対象区間、要件、確認方法が記載されています。',
        },
        {
          label: 'ETC総合情報ポータル ETC2.0',
          url: 'https://www.go-etc.jp/etc2',
          note: 'ETC2.0の公式メリット概要が掲載されています。',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: '走行履歴や最終請求額を確認するための公式サービスです。',
        },
        {
          label: 'NEXCO東日本 ルート・料金検索',
          url: 'https://www.driveplaza.com/',
          note: '公式のルートおよび通行料金の参考情報です。',
        },
        {
          label: 'ITSサービス高度化機構 ETCポータル',
          url: 'https://www.go-etc.jp/',
          note: 'ETCに関する公式案内を提供するポータルサイトです。',
        },
      ],
      longBody: 'ETC2.0割引対象道路は、すべての高速道路で一律に適用されるわけではありません。NEXCO東日本が公式に示している代表例は、圏央道の茅ヶ崎JCTから海老名南JCT間および海老名から木更津JCT間、そして新湘南バイパスの藤沢から茅ヶ崎JCT間です。この割引を受けるには、車両にETC2.0対応の車載器が正しくセットアップされている必要があり、通常のETC車載器では対象になりません。さらに、ETC無線通信を利用して対象区間のETC設置入口・出口ICを通過することが条件となります。実際の利用場面では、料金所の表示や車載器の音声案内に割引後の金額が表示されないことがあるため、最終的な請求金額はETCカードの明細や利用照会サービスで確認する必要があります。この仕組みを理解せずに目視だけで判断すると、割引が適用されていないと誤解する原因になります。企業や個人事業主がETC2.0車載器の導入を検討する際は、実際に利用する路線が対象区間に含まれているか、月間の通行頻度と車載器の導入コストを比較し、投資対効果を慎重に見極めることが大切です。特に車両入れ替えの予定がある場合は、次期車両への移設可否も含めて計画する必要があります。割引が適用されなかった場合の確認手順としては、まず利用日時・ETCカード・入口と出口IC・車両区分・対象区間内であるかどうか・除外日に該当していないかを一つずつ照らし合わせることが基本です。感情的に「割引されるはずだった」と主張する前に、公式の記録と条件を照合する冷静なプロセスが求められます。企業の経理担当者が従業員の通行記録を審査する際には、PDF形式の利用証明書とCSV形式の明細データを月次で整理し、運転者のメモ・承認記録・特殊な割引適用の説明を一つのフォルダにまとめておくと、後日の問い合わせや確認対応がスムーズになります。JTRはこうした記録整理の負担を軽減する独立したサービスであり、NEXCO・MEISAI・ETC利用照会サービス・マイレージサービスとは別の立場で、ユーザーがETC利用記録を定期的にメールで受け取り、PDFとCSV形式で保管できる仕組みを提供します。JTRは公式の通行料金データを生成せず、割引適用の可否を判定する権限もなく、税務や経理の保証を行うものでもありません。JTRの役割は、ユーザーが公式記録を自分で確認しやすくするための整理と配信の支援にあります。よくある誤解として、運転者の記憶だけで割引時間帯を判断する、休日なら自動的に休日割引が適用されると思い込む、ETC2.0割引がすべての道路で使えると考える、ポイント還元プログラムが即時割引と同じ形で記録に現れると期待する、JTRのレポートを新しい公式記録源と勘違いする、といったケースが挙げられます。企業が社内規程を策定する際は、「通行料金の精算には公式のETC利用記録または承認された料金証憑が必要です。運転者は求めに応じて通行目的・車両・カード・部署情報を提供してください。割引は公式の運営者ルールと最終記録額に基づいて確認します。JTRレポートは整理・配信・保管の補助ツールとして利用できますが、公式の料金データと適用判定は公式の料金システムおよび運営者に属します」という明確な文言を使うことで、現場の混乱を防ぐことができます。',
    },
    en: {
      title: 'ETC2.0 Eligible Roads: How to Verify & Match Charges | JTR',
      metaDesc: 'Learn which road sections qualify for ETC2.0 discounts (Ken-Ō Expressway, Shin-Shōnan Bypass), why displayed tolls differ from final charges, and how to verify amounts using official services.',
      h1: 'ETC2.0 Eligible Roads and Verification Methods',
      primaryKeyword: 'ETC2.0 eligible roads',
      answer: "ETC2.0 discounts do not apply to all roads. NEXCO East's official pages list eligible sections: Ken-Ō Expressway (Chigasaki JCT–Ebina-Minami JCT, Ebina–Kisarazu JCT) and Shin-Shōnan Bypass (Fujisawa–Chigasaki JCT). To receive discounts, your ETC2.0 device must be properly registered and you must pass through via ETC wireless communication. Tollbooth displays and in-vehicle announcements may not show discount amounts, so final charges should be confirmed via the ETC Inquiry Service or card statements.",
      whyMatters: "For companies and individuals considering ETC2.0 investment, verifying whether regular routes include eligible sections is essential for decision-making. Estimating monthly toll savings against device purchase costs allows proper cost-benefit evaluation. When accounting staff receive claims that 'a discount should have applied,' cross-checking eligible sections, vehicle class, transit date-time, card type, and setup status against official sources enables fact-based verification instead of emotional debate. Discount rules may change, so consulting current official guidelines prevents misunderstandings and unmet expectations.",
      officialBackground: "The official record layer for ETC usage does not begin with JTR. It begins with road operators, ETC card issuers, and the ETC Inquiry Service. The Inquiry Service is where drivers view usage details, print usage certificates, and download records in PDF or CSV format. Specific discount rules are managed by NEXCO companies' official pages, the ETC Mileage Service, and dedicated ETC2.0 pages. Articles about discounts and expense claims must avoid definitive language. When faced with 'discount was not applied' questions, it is safer to guide users to verify exact date-time, vehicle classification, card, route, road operator, registration status, and official statements rather than speculate. JTR helps users receive organized daily records, but final discount determination rests with toll systems and operator rules.",
      whoFor: [
        'Individual drivers regularly using Ken-Ō Expressway areas who are evaluating whether to invest in ETC2.0 equipment',
        'Companies with multiple vehicles operating in Tokyo outer-loop areas, assessing cost-benefit of device upgrades',
        "Accounting staff who receive employee claims that 'a discount should apply' and need to cross-check against official sources",
        'Used-car buyers who found an ETC2.0 label and want to reconfirm setup status and eligible routes',
      ],
      jtrSolution: {
        intro: 'Japan Toll Receipts (JTR) is an independent record delivery and organization service. JTR is not NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC Inquiry Service, ETC Mileage Service, or a road operator. JTR does not create official toll data, determine discount eligibility, or guarantee expense approval. JTR reduces manual work and delivers organized PDF and CSV records to support human review.',
        bullets: [
          'Receive ETC usage records via email on a regular schedule, without waiting until month-end',
          'Build a practical audit trail in your inbox, supporting early detection of unrecognized trips or unexpected routes',
          'PDF format suits document-style review; CSV format suits sorting, reconciliation, and accounting workflows',
          'Discount application and final charge confirmation remain with official services and operator rules',
          'Use JTR records as a supporting tool; do not treat them as the official toll source',
        ],
      },
      pdfCsv: 'JTR provides ETC usage records in PDF and CSV formats. PDF is suitable for printing and filing usage certificates; CSV is convenient for sorting, aggregation, and reconciliation in Excel or accounting software. Retaining both formats supports document review and data analysis. JTR does not output Excel files (XLSX).',
      email: 'JTR automatically delivers ETC usage records by email at your chosen frequency. Selectable delivery schedules (monthly, weekly, etc.) allow accounting staff and administrators to eliminate manual downloads and maintain a chronological record archive in their inbox. Delivered PDF and CSV files can be forwarded directly into internal approval workflows or accounting systems.',
      steps: [
        {
          t: 'Verify ETC2.0 OBU is properly set up',
          d: 'Confirm that an ETC2.0-compatible on-board unit, not a standard ETC device, is installed in your vehicle and correctly set up. ETC2.0 equipment is required for discount eligibility.',
        },
        {
          t: 'Check official eligible road sections in advance',
          d: 'Not all expressways qualify for ETC2.0 discounts. Consult official pages such as NEXCO East to confirm whether your planned route sections are eligible before traveling.',
        },
        {
          t: 'Pass entry and exit via ETC wireless communication',
          d: 'To receive discounts, you must pass through ETC-equipped entrance and exit interchanges via wireless communication. Using general lanes or cash payment will disqualify you from discounts.',
        },
        {
          t: 'Do not rely on tollbooth displays or OBU voice announcements',
          d: 'Discounted amounts may not appear on tollbooth displays or in-vehicle voice announcements. Discounts may be applied later during billing, so verify final charges separately.',
        },
        {
          t: 'Verify final billing via ETC inquiry service or card statement',
          d: 'To confirm whether discounts were applied, check the final billed amount through the ETC inquiry service or your card company statement. These are the official records.',
        },
        {
          t: 'Corporate users should compare upgrade costs against actual routes',
          d: 'Businesses managing multiple vehicles should compare OBU upgrade costs with actual driving routes and monthly toll expenses to assess whether switching to ETC2.0 offers cost-effective benefits.',
        },
      ],
      commonProblems: [
        {
          q: "I drove on Ken-Ō Expressway but the discount wasn't applied",
          a: 'ETC2.0 discounts do not cover all Ken-Ō sections. Check the official page for eligible segments, confirm your OBU is ETC2.0, and verify entry/exit occurred via ETC wireless. Vehicle class or time-based exclusions may also apply.',
        },
        {
          q: "The discounted amount didn't show at the tollbooth",
          a: 'According to NEXCO official information, ETC2.0 discount amounts may not display at tollbooths or on OBUs. Check later via card billing or the ETC inquiry service to confirm the discount was reflected.',
        },
        {
          q: 'Can JTR determine whether a discount was applied?',
          a: 'JTR is a record organization and delivery service, not a discount determination authority. Verify discount application through the official ETC inquiry service, card statements, or road operator guidelines. JTR helps organize your verification work.',
        },
        {
          q: 'Will a used ETC2.0 device from a previous owner qualify for discounts?',
          a: "Even with an ETC2.0 label, discounts may not apply if the device hasn't been properly re-setup for your vehicle. After purchase, verify the OBU setup status and perform re-setup if necessary.",
        },
      ],
      examples: [
        {
          who: 'Commuter driver in Ken-Ō area',
          use: 'Before purchasing a new OBU, verify that the entry/exit IC combinations used daily are included in the official ETC2.0 discount eligible sections to judge return on investment.',
        },
        {
          who: 'Corporate vehicle manager in Tokyo Gaikan area',
          use: 'Aggregate actual routes and monthly toll expenses for multiple company vehicles, cross-reference with eligible sections, and estimate whether ETC2.0 OBU upgrade costs yield sufficient discount benefits.',
        },
        {
          who: 'Accounting staff',
          use: 'When a driver claims an ETC2.0 discount should have applied on Shin-Shonan Bypass, verify the actual billed amount and eligibility conditions using the official ETC2.0 discount page and inquiry service.',
        },
        {
          who: 'Individual driver using JTR',
          use: 'Receive and organize daily usage records via JTR, then cross-check final billed amounts for trips where discounts were expected using the official inquiry service and archive the records.',
        },
      ],
      faqs: [
        {
          q: 'Does JTR determine ETC2.0 discount eligibility?',
          a: 'No. JTR is an independent record delivery and organization service and does not perform discount determination. It supports users in organizing their verification work based on information from official road operators and the ETC inquiry service.',
        },
        {
          q: 'Can I confirm the discounted amount on the tollbooth display?',
          a: 'Not necessarily. Discounts and post-adjustments may not appear on tollbooth displays or OBU voice announcements. Verify final billed amounts via card statements, ETC inquiry service, program portals, or similar official sources.',
        },
        {
          q: 'Should businesses archive both PDF and CSV?',
          a: 'Yes. PDFs are suitable for document-style review and archiving, while CSVs are convenient for sorting, cross-checking, and accounting processes. Organizing both monthly enables smooth verification during audits and expense processing.',
        },
        {
          q: 'Can ETC2.0 discount rules change?',
          a: 'Yes. Eligible periods, sections, exclusion dates, and program structures may be revised. We recommend checking the current official page for the latest information before use.',
        },
        {
          q: "If an expected discount wasn't applied, is it necessarily an error?",
          a: 'No. Various reasons are possible: vehicle class, ineligible roads, exclusion dates, driving route, registration status, travel time, card mismatch, or post-processing in point-based programs. Cross-check official records and conditions to identify the cause.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How JTR Works',
          desc: 'Explains how JTR organizes and delivers ETC usage records to streamline monthly verification tasks.',
          path: '/how-it-works',
        },
        {
          title: 'Business Plans',
          desc: 'Introduces corporate features that centralize ETC records for multiple vehicles and support accounting approval and audit preparation.',
          path: '/business',
        },
        {
          title: 'Free Trial',
          desc: "Try JTR's record delivery and PDF/CSV export to confirm compatibility with your workflow.",
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'NEXCO East ETC2.0 Discounts',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'Official eligible sections, requirements, and verification methods are listed.',
        },
        {
          label: 'ETC Portal ETC2.0',
          url: 'https://www.go-etc.jp/etc2',
          note: 'Official overview of ETC2.0 benefits.',
        },
        {
          label: 'ETC Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service for checking travel history and final billed amounts.',
        },
        {
          label: 'NEXCO East Route & Toll Search',
          url: 'https://www.driveplaza.com/',
          note: 'Official reference for routes and toll information.',
        },
        {
          label: 'ITS Service Enhancement Organization ETC Portal',
          url: 'https://www.go-etc.jp/',
          note: 'Portal site providing official ETC guidance.',
        },
      ],
      longBody: 'ETC2.0 discounts are not applied uniformly across all expressways. Representative examples officially published by NEXCO East include the Ken-Ō Expressway between Chigasaki JCT and Ebina-Minami JCT and between Ebina and Kisarazu JCT, as well as the Shin-Shōnan Bypass between Fujisawa and Chigasaki JCT. To receive this discount, your vehicle must be equipped with a properly set-up ETC2.0 onboard unit; standard ETC devices do not qualify. Additionally, you must pass through designated ETC-equipped entry and exit interchanges in the applicable sections using ETC wireless communication. In actual use, the discounted amount may not appear on the toll booth display or in the onboard unit\'s voice guidance, so the final billed amount should be confirmed through your ETC card statement or the official usage inquiry service. Relying on visual observation alone without understanding this mechanism can lead to the mistaken belief that the discount was not applied. When companies or sole proprietors consider installing an ETC2.0 unit, it is important to verify whether the routes they actually use fall within the applicable sections, compare monthly travel frequency against the installation cost, and carefully assess return on investment. If vehicle replacement is planned, the feasibility of transferring the unit to the next vehicle should also be included in the decision. When a discount appears not to have been applied, the basic verification process involves systematically checking the date and time of use, the ETC card, entry and exit interchanges, vehicle classification, whether the section is covered, and whether any exclusion dates apply. Before asserting emotionally that "a discount should have been given," a calm process of cross-checking official records against the published conditions is required. When corporate accounting staff review employee toll records, organizing monthly PDF usage certificates and CSV detail data, then consolidating driver notes, approval records, and explanations of special discount applications into a single folder will streamline later inquiries and audit responses. JTR is an independent service designed to reduce this record-keeping burden; it operates separately from NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC usage inquiry service, and mileage programs, providing users with a way to receive ETC usage records periodically by email and store them in PDF and CSV formats. JTR does not generate official toll data, does not have authority to determine discount eligibility, and does not provide tax or accounting guarantees. JTR\'s role is to assist users in organizing and receiving official records for easier self-review. Common misunderstandings include relying solely on driver memory to judge discount time periods, assuming holiday discounts apply automatically on any holiday, believing ETC2.0 discounts work on all roads, expecting point reward programs to appear in records like immediate discounts, and mistaking JTR reports for a new official data source. When companies draft internal policies, using clear language such as "Toll reimbursement requires official ETC usage records or approved toll receipts. Drivers shall provide trip purpose, vehicle, card, and department information upon request. Discounts are confirmed based on the official operator\'s rules and final recorded amounts. JTR reports may be used as supplementary tools for organizing, distributing, and storing records, but official toll data and eligibility determinations belong to the official toll system and operator" can prevent confusion in daily operations.',
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: 'ETC2.0割引適用フロー',
            intro: '圏央道・新湘南バイパスでの割引適用は、車載器・通行方法・対象区間の3要素で決まります。',
            nodes: [
              {
                title: 'ETC2.0車載器セットアップ',
                desc: '正しくセットアップされた車載器を搭載',
              },
              {
                title: '無線通行',
                desc: 'ETC無線通信で対象区間を通行',
              },
              {
                title: '料金所表示',
                desc: '割引額が表示されない場合あり',
              },
              {
                title: '最終請求額',
                desc: '利用照会サービスで割引後金額を確認',
              },
            ],
          },
          en: {
            title: 'ETC2.0 Discount Application Flow',
            intro: 'Discounts on Ken-Ō Expressway and Shin-Shōnan Bypass depend on device setup, passage method, and eligible sections.',
            nodes: [
              {
                title: 'ETC2.0 Device Setup',
                desc: 'Properly registered ETC2.0 device installed',
              },
              {
                title: 'Wireless Passage',
                desc: 'Pass through eligible sections via ETC wireless',
              },
              {
                title: 'Toll Gate Display',
                desc: 'Discount may not show on display',
              },
              {
                title: 'Final Charge',
                desc: 'Confirm discounted amount via ETC usage inquiry service',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '割引対象道路の公式情報源',
            intro: 'ETC2.0割引の最新ルール・対象区間・適用条件は、必ず公式サービスで確認してください。',
            sources: [
              {
                name: 'NEXCO東日本公式ページ',
                role: '割引対象区間・適用条件の公表',
                url: 'https://www.e-nexco.co.jp/',
                scope: '圏央道・新湘南バイパス等の対象区間リスト',
              },
              {
                name: 'ETC利用照会サービス',
                role: '通行履歴・最終請求額の確認',
                url: 'https://www.etc-meisai.jp/',
                scope: '割引適用後の金額・利用証明書発行',
              },
              {
                name: 'ETCマイレージサービス',
                role: 'ポイント還元・登録状態の管理',
                url: 'https://www.smile-etc.jp/',
                scope: 'マイレージ登録・ポイント照会',
              },
              {
                name: '道路事業者公式サイト',
                role: '料金制度変更の告知',
                url: '各事業者サイト',
                scope: '割引率・対象期間の最新情報',
              },
            ],
          },
          en: {
            title: 'Official Sources for Discount-Eligible Roads',
            intro: 'Always check official services for the latest ETC2.0 discount rules, eligible sections, and application conditions.',
            sources: [
              {
                name: 'NEXCO East Official Site',
                role: 'Publishes eligible sections & conditions',
                url: 'https://www.e-nexco.co.jp/',
                scope: 'Ken-Ō Expressway, Shin-Shōnan Bypass eligible lists',
              },
              {
                name: 'ETC Usage Inquiry Service',
                role: 'Usage history & final charge confirmation',
                url: 'https://www.etc-meisai.jp/',
                scope: 'Post-discount amounts & usage certificates',
              },
              {
                name: 'ETC Mileage Service',
                role: 'Point redemption & registration status',
                url: 'https://www.smile-etc.jp/',
                scope: 'Mileage registration & point inquiry',
              },
              {
                name: 'Road Operator Official Sites',
                role: 'Toll system change announcements',
                url: 'Each operator site',
                scope: 'Latest discount rates & validity periods',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '料金所表示 vs 最終請求額',
            intro: 'ETC2.0割引は料金所で表示されない場合があります。最終確認は必ず利用照会サービスで行いましょう。',
            columns: [
              '料金所表示',
              '最終請求額',
            ],
            rows: [
              {
                feature: '割引額の即時表示',
                a: '表示されない場合あり',
                b: '確実に割引適用後',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '確認タイミング',
                a: '通行直後',
                b: '数日後（照会サービス）',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: '印刷・保管',
                a: '領収書発行機のみ',
                b: 'PDF・CSV形式で可能',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '会計処理での信頼性',
                a: '参考値',
                b: '公式記録',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'Toll Gate Display vs Final Charge',
            intro: 'ETC2.0 discounts may not appear on toll gate displays. Always confirm final amounts via the usage inquiry service.',
            columns: [
              'Toll Gate Display',
              'Final Charge',
            ],
            rows: [
              {
                feature: 'Instant discount display',
                a: 'May not show',
                b: 'Guaranteed post-discount',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Confirmation timing',
                a: 'Immediately after passage',
                b: 'Few days later (inquiry service)',
                kindA: 'partial',
                kindB: 'partial',
              },
              {
                feature: 'Print & archive',
                a: 'Receipt printer only',
                b: 'PDF & CSV available',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Accounting reliability',
                a: 'Reference only',
                b: 'Official record',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '割引未適用時の確認チェックリスト',
            intro: '「割引が適用されなかった」と感じた場合、公式情報と照合すべき6つの要素を確認しましょう。',
            items: [
              {
                text: '対象区間を通行したか',
                hint: '圏央道（茅ヶ崎JCT～海老名南JCT・海老名～木更津JCT）・新湘南バイパス（藤沢～茅ヶ崎JCT）',
              },
              {
                text: 'ETC2.0車載器が正しくセットアップされているか',
                hint: '中古車・車両入替時は再セットアップが必要',
              },
              {
                text: 'ETC無線通信で通行したか',
                hint: '一般レーン・現金払いは対象外',
              },
              {
                text: '車両クラスが対象か',
                hint: '一部割引は車種制限あり',
              },
              {
                text: 'カード種別・マイレージ登録状態',
                hint: '法人カード・個人カードで条件が異なる場合あり',
              },
              {
                text: '利用照会サービスで最終請求額を確認',
                hint: '料金所表示と異なる場合あり',
              },
            ],
          },
          en: {
            title: 'Discount Non-Application Checklist',
            intro: "If you believe a discount wasn't applied, verify these six elements against official sources.",
            items: [
              {
                text: 'Did you use an eligible section?',
                hint: 'Ken-Ō (Chigasaki JCT–Ebina-minami JCT / Ebina–Kisarazu JCT), Shin-Shōnan (Fujisawa–Chigasaki JCT)',
              },
              {
                text: 'Is your ETC2.0 device properly set up?',
                hint: 'Re-setup required for used cars or vehicle changes',
              },
              {
                text: 'Did you pass via ETC wireless?',
                hint: 'General lanes & cash payments are ineligible',
              },
              {
                text: 'Is your vehicle class eligible?',
                hint: 'Some discounts have vehicle type restrictions',
              },
              {
                text: 'Card type & mileage registration status',
                hint: 'Corporate vs personal cards may have different conditions',
              },
              {
                text: 'Confirm final charge via usage inquiry service',
                hint: 'May differ from toll gate display',
              },
            ],
          },
        },
      },
    ],
  },

  // 7) ETC周遊パス利用時の明細確認方法
  {
    slug: 'etc-shuyu-pass-meisai-howto',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETC周遊パス 明細 記録方法',
      en: 'ETC touring pass statement recording',
    },
    ja: {
      title: 'ETC周遊パス明細の記録管理方法 | Japan Toll Receipts',
      metaDesc: 'ETC周遊パス・ドライブプラン（高速道路乗り放題プラン）利用時のETC明細を確認・整理・保存する実務ガイド。事前申込手順、対象エリア、適用期間、ETC利用照会サービスでのPDF利用証明書・CSV明細での割引適用確認、独立サービスJTRの日次配信を併用した観光・出張経費の記録運用までまとめました。',
      h1: 'ETC周遊パス明細の記録管理方法',
      primaryKeyword: 'ETC周遊パス 明細 記録方法',
      answer: 'ETC周遊パス・エリアパスを利用する場合、通行料金の記録だけでなく、利用カード・車両・入口IC・出口IC・利用日時・パス申込情報を一元的に保存することが重要です。ETC利用照会サービスで利用証明書やPDF・CSV記録を取得し、社内メモやパス確認書と併せて管理することで、後日の確認・経理処理・精算がスムーズになります。',
      whyMatters: '周遊パスやドライブプランは公式の適用条件・車種区分・ETCカード種別・利用ルールに従うことで旅行コストを削減できる制度です。しかし利用後のETC明細だけでは割引適用の全体像が分かりにくいため、パス申込確認・旅程計画・ETC利用明細を一緒に保管する必要があります。記録が不詳細だと数週間後・数ヶ月後に「なぜこの料金になったのか」「どの車両で通行したか」を説明できず、経理処理や精算承認が困難になります。公式記録と社内説明を分けて整理することで、業務・政府・レンタカー・家族利用のいずれでも安心して管理できます。',
      officialBackground: '日本の通行料金記録管理は複数の独立したシステムで構成されています。道路事業者は路線・料金・割引・車種区分・安全情報を公開し、ETC利用照会サービスはETCカード利用明細と利用証明書を提供します(通常カードは過去15ヶ月間)。カード会社は月次明細を発行します。JTRはこれら公式記録の受信・整理・保管・確認支援を行う独立サービスであり、道路事業者・NEXCO・MEISAI・ETC利用照会サービス・政府機関ではありません。JTRは公式通行料金データを作成せず、既存の公式記録を利用者が理解しやすい形に整理します。実務的な記録には5つの基本情報が必要です:どのカードで課金されたか、どの車両が通行したか、どの路線・IC区間を利用したか、なぜその通行が発生したか、公式証拠はどこに保管されているか。この情報が揃わないと後日の説明が困難になります。業務・政府・軍・レンタカー・家族利用では、公式利用明細・PDF出力・CSV出力・カード明細・社内メモを一体管理することで、精算確認・運転者質問・部署配分・不正利用疑義への対応が容易になります。',
      whoFor: [
        'ETC周遊パスやドライブプランを利用する旅行者・観光客',
        'レンタカーでエリア割引プランを使う個人・団体',
        '社用車・営業車で複数のETC通行記録を管理する経理担当者',
        '複数車両・複数カードを使い分ける家族や事業者',
      ],
      jtrSolution: {
        intro: 'JTRはETC利用記録を実務的な確認ワークフローに変換します。利用者が手動で検索・印刷・改名・転送する手間を減らし、配信・整理・保管・確認支援に特化しています。',
        bullets: [
          'PDF・CSV記録を自動配信し、手動ダウンロードの手間を削減',
          'ETCカード別・車両別にグループ化し(設定時)、複数記録の管理を簡素化',
          '確認が必要な記録を強調表示し、早期レビューを支援',
          '社内ポリシーと利用実績の比較作業を補助',
          '税務・請求書・精算処理では記録整理を支援するが、最終判断は会計士・雇用主・公式指針で確認を推奨',
        ],
      },
      pdfCsv: 'JTRはPDF形式(閲覧・共有に便利)とCSV形式(並べ替え・フィルタ・会計システム取込に適する)の両方で記録を提供します。ダウンロード後のCSVは利用者が表計算ソフトで自由に加工できますが、JTR自体はExcel・XLSXファイルを出力しません。',
      email: 'JTRは設定に応じてETC利用記録を指定メールアドレスへ自動配信します。配信先は管理者・経理担当・部門責任者など複数設定が可能で、記録の手動転送や印刷配布の手間を削減します。配信内容は公式記録由来のデータであり、JTRが独自に通行料金データを作成することはありません。',
      steps: [
        {
          t: '対象トリップまたは質問の特定',
          d: 'ETCシュユパスやエリアパスの利用記録を確認する具体的な旅程、カード、車両、日付範囲を特定します。公式の申込内容と利用記録を照合できるよう準備します。',
        },
        {
          t: '公式有料道路運営会社サイトで料金・割引ルールを確認',
          d: 'ルート、料金額、車種区分、割引適用条件、ETC専用ゲート、道路固有ルールは各道路運営会社の公式サイトで先に確認します。',
        },
        {
          t: 'ETC利用照会サービスまたはカード明細で利用記録を取得',
          d: 'ETC利用照会サービスで利用証明書・PDF・CSV記録を取得、またはカード発行会社の明細で利用明細行を確認します。',
        },
        {
          t: 'トリップ詳細を統一形式で記録',
          d: '利用日、入口IC、出口IC、ETCカード、車両、車種区分、運転者または部署、利用目的を一貫した社内フォーマットで記録します。',
        },
        {
          t: '公式記録と社内説明を分離して保管',
          d: '公式の利用記録は通行実績を示し、社内メモは経費精算目的や承認情報を示します。両者を明確に分けて一緒に保管します。',
        },
        {
          t: '不明点は公式窓口へ問い合わせ',
          d: '記録が不詳細、遅延、予想外、または不一致の場合は推測せず、該当する道路運営会社またはカード発行会社へ問い合わせ、回答を記録と共に保管します。',
        },
      ],
      commonProblems: [
        {
          q: 'パス利用なのに通常料金が表示される',
          a: 'パス申込内容、対象車種、対象カード、利用期間、対象区間を公式確認資料と照合してください。記録タイミングによってはパス適用前の明細が表示される場合があります。運営会社へ問い合わせを推奨します。',
        },
        {
          q: '利用記録の日付や区間が記憶と異なる',
          a: '入口IC・出口IC・日時・車両を公式記録で再確認し、運転者や同乗者に確認してください。記憶違いや別車両の可能性もあります。不明な場合は運営会社またはカード会社へ問い合わせます。',
        },
        {
          q: 'PDF記録とCSV記録のどちらを保存すべきか',
          a: '両方の保存を推奨します。PDF記録は閲覧・共有しやすく、CSV記録は並び替え・絞り込み・会計システムへの取り込みに適しています。用途に応じて使い分けてください。',
        },
        {
          q: '経費精算や税務にそのまま使えるか',
          a: '記録は精算や税務の参考資料となりますが、最終的な取り扱いは勤務先の規定、会計士の助言、公式ガイダンスで確認してください。このガイドは税務助言ではありません。',
        },
      ],
      examples: [
        {
          who: '出張ドライバー',
          use: 'ETCシュユパス利用後、公式の利用証明書とパス確認書類を揃えて経費精算申請を行い、どの公式ソースをチェックすべきか確認します。',
        },
        {
          who: '企業経理チーム',
          use: '月次でPDF・CSV記録をエクスポートし、社内の車両・部署割当と照合して利用明細行を確認、不明点があれば該当部署へ問い合わせます。',
        },
        {
          who: '複数車両を持つ家族',
          use: 'ETCカード記録から個人用と業務用の通行を分離し、会計士へ送付する前に公式利用明細と社内メモを整理します。',
        },
        {
          who: '車両管理者',
          use: '見覚えのない通行を発見した際、公式ETC利用記録を確認してから運転者へ状況を問い合わせ、レビュー項目として扱います。',
        },
      ],
      faqs: [
        {
          q: 'JTRはこのトピックの公式有料道路情報源ですか?',
          a: 'いいえ。JTRは独立したサービスです。公式のルート、料金、割引、設定、安全ルールは各道路運営会社または公式ETCサービスで確認してください。JTRは利用記録の受信・整理・保管・レビュー支援を行います。',
        },
        {
          q: 'ETC利用照会サービスは道路会社サイトの代わりになりますか?',
          a: 'いいえ。ETC利用照会サービスはETCカード利用明細や利用証明書の取得に便利ですが、最新のルート、料金、割引、車線、車種区分ルールは道路運営会社サイトでの確認が必要です。',
        },
        {
          q: 'PDFとCSV記録のどちらを保存すべきですか?',
          a: '両方が有用です。PDF記録は閲覧・共有が容易で、CSV記録は並び替え・絞り込み・会計システムへの取り込みに適しています。用途に応じて使い分けてください。',
        },
        {
          q: 'これらの記録を税務や経費精算に使えますか?',
          a: '税務や経費精算のレビュー資料として活用できますが、最終的な取り扱いは勤務先規定、会計士助言、公式ガイダンスに従ってください。このガイドは税務助言ではありません。',
        },
        {
          q: '金額やルートが間違っているように見える場合はどうすればよいですか?',
          a: '公式記録を確認し、カード・車両・利用日・IC情報を照合してください。問題が解決しない場合は該当する道路運営会社またはカード発行会社へ問い合わせてください。',
        },
      ],
      relatedFeatures: [
        {
          title: 'JTRの仕組み',
          desc: 'ETC利用記録の受信、整理、保管、レビュー支援の流れを理解し、公式記録と社内説明を安全に管理する方法を確認できます。',
          path: '/how-it-works',
        },
        {
          title: 'ビジネス向けプラン',
          desc: '複数車両・複数カード・部署別割当のレビュー支援、PDF・CSV一括エクスポート、管理者向けレビュー機能を提供します。',
          path: '/business',
        },
        {
          title: 'セキュリティ',
          desc: '公式ETC記録の取り扱い、データ保管、アクセス制御、独立性の説明により、安全な記録管理体制を確認できます。',
          path: '/security',
        },
      ],
      references: [
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETCカード利用照会、利用証明書発行、PDF・CSV形式の利用明細ダウンロードを提供する公式サービス。通常のETCカード記録は過去15か月分が対象です。',
        },
        {
          label: 'ETC総合情報ポータル:ETC利用照会サービス',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '対象カード種別、利用証明書発行、通常ETCカード記録期間、ETCコーポレートカード記録期間、無線・非無線ETC利用、PDF・CSVダウンロードの説明。',
        },
        {
          label: 'NEXCO中日本 早旅ドライブプランFAQ',
          url: 'https://hayatabi.c-nexco.co.jp/drive/faq/',
          note: 'NEXCO中日本の公式ドライブプランFAQ。車種区分の適用条件やレンタカー利用条件を確認できます。',
        },
        {
          label: 'ドラぷら 料金・ルート検索',
          url: 'https://www.driveplaza.com/dp/SearchTop',
          note: 'NEXCO高速道路および関連ルートの料金・ルート検索サービス。',
        },
        {
          label: 'NEXCO西日本 料金・ルート検索',
          url: 'https://search.w-nexco.co.jp/',
          note: 'NEXCO西日本の公式料金・ルート検索サービス。',
        },
      ],
      longBody: 'ETCの周遊パスやエリアパスは、定められた区域内で一定期間乗り放題となる割引制度であり、NEXCO各社や地域高速道路会社が観光促進や交通分散を目的として提供しています。制度の歴史は古く、紙の回数券時代から存在しましたが、ETC専用化によって事前登録制や車載器番号紐付けが主流となり、利用後の明細確認が重要性を増しました。周遊パスは通常、対象車種・申込期限・利用期間・対象IC範囲が厳密に定められており、条件を一つでも満たさない場合は通常料金が請求されます。そのため事後の利用明細を確認する際には、パス適用分なのか通常料金なのかを判別し、公式の申込確認書と照合する作業が欠かせません。ETC利用照会サービスは、カード単位で過去15か月分の通行履歴をPDFまたはCSV形式で取得できる公式窓口ですが、明細そのものにはパス名称や割引根拠が詳細に記載されないことが多く、利用者側で入口IC・出口IC・日時・車両クラスを元に適用範囲内か確認する必要があります。特にレンタカーや社用車で複数名が同一カードを共有している場合、誰がどの目的で走行したかを記録していないと、経理担当者が数週間後に明細を見ても判断できません。また、法人ETCカードは通行日から最長62か月間照会可能ですが、カード会社の月次明細とETC利用照会サービスの記録とでは表示形式や更新タイミングが異なるため、両方を突き合わせて初めて全体像が見えるケースもあります。JTRは公式の料金データを生成する立場ではなく、利用者が取得した明細を受け取り、整理・保管・閲覧しやすい形で提示する独立サービスです。JTRを活用することで、PDF・CSV双方の記録を一元管理し、車両別・カード別にグループ化したり、想定外の通行を早期に発見したりする運用が可能になります。ただし、金額や経路に疑問が生じた場合は、道路会社またはカード発行元へ直接問い合わせることが原則であり、JTRはあくまで記録の整理と確認を補助する位置付けです。税務処理や精算可否の最終判断は、会計士・雇用主・所属機関の規定に従って行う必要があります。周遊パス利用後の明細管理で最も多い失敗例は、スクリーンショットや手書きメモだけで済ませ、公式の利用証明書を取得しないまま数か月が経過し、照会期限を過ぎてしまうパターンです。また、複数車両で同一カードを使い回した結果、どの車両がパス対象車種だったか判別できなくなるケースも散見されます。こうしたトラブルを防ぐには、通行直後に入口IC・出口IC・日時・車両番号・運転者・目的をメモし、公式明細と照合できる状態を保つことが最も確実です。',
    },
    en: {
      title: 'How to Record ETC Touring Pass Statements | Japan Toll Receipts',
      metaDesc: 'Learn to record, organize, and save ETC touring pass statements. Covers ETC inquiry service, PDF/CSV records, JTR workflows, and common questions.',
      h1: 'How to Record ETC Touring Pass Statements',
      primaryKeyword: 'ETC touring pass statement recording',
      answer: 'When using ETC touring passes or area passes, it is essential to save not only toll charges but also the card used, vehicle, entry/exit ICs, date/time, and pass application details in one place. By retrieving usage certificates, PDF and CSV records from the ETC inquiry service and managing them alongside internal notes and pass confirmation documents, you simplify later verification, accounting, and reimbursement.',
      whyMatters: "Touring passes and drive plans reduce travel costs when official conditions—vehicle class, ETC card type, and usage rules—are followed. However, post-travel ETC statements alone do not show the full discount picture, so you must store pass applications, itineraries, and ETC statements together. Incomplete records make it difficult weeks or months later to explain 'why this charge?' or 'which vehicle traveled?', hindering accounting and approval. Separating official records from internal explanations ensures confident management for business, government, rental-car, and family use.",
      officialBackground: "Japan's toll-record management comprises multiple independent systems. Road operators publish routes, fares, discounts, vehicle classes, and safety notices; the ETC inquiry service provides ETC card statements and usage certificates (typically 15 months for standard cards); card issuers send monthly statements. JTR is an independent service that helps users receive, organize, store, and review these official records—it is not a road operator, NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC inquiry service, or a government agency. JTR does not create official toll data; it reorganizes existing official records into user-friendly formats. Practical recordkeeping requires five basics: which card was charged, which vehicle traveled, which route/IC segment was used, why that trip occurred, and where official proof is stored. Without this information, later explanations become difficult. For business, government, public-sector, rental-car, and family use, unified management of official statements, PDF output, CSV output, card statements, and internal notes simplifies reimbursement review, driver inquiries, department allocation, and responses to suspected misuse.",
      whoFor: [
        'Travelers and tourists using ETC touring passes or drive plans',
        'Individuals and groups renting cars with area discount plans',
        'Accounting staff managing multiple ETC records for company or business vehicles',
        'Families and operators juggling multiple vehicles and cards',
      ],
      jtrSolution: {
        intro: 'JTR converts ETC usage records into practical review workflows. It reduces the manual effort to search, print, rename, and forward records, focusing instead on delivery, organization, storage, and review support.',
        bullets: [
          'Auto-delivers PDF and CSV records, cutting manual download work',
          'Groups by ETC card and vehicle (when configured), simplifying multi-record management',
          'Highlights records needing review to support early checks',
          'Assists in comparing internal policy with actual usage',
          'Supports record organization for tax, invoicing, and reimbursement—final decisions rest with accountants, employers, and official guidance',
        ],
      },
      pdfCsv: 'JTR provides records in both PDF (convenient for viewing and sharing) and CSV (suitable for sorting, filtering, and importing into accounting systems). After download, users may edit CSV in spreadsheet software, but JTR itself does not output Excel or XLSX files.',
      email: 'JTR auto-delivers ETC usage records to designated email addresses per your settings. You may configure multiple recipients—managers, accounting staff, department heads—reducing manual forwarding and print distribution. Delivered content derives from official records; JTR does not independently create toll-charge data.',
      steps: [
        {
          t: 'Identify the target trip or question',
          d: 'Identify the specific itinerary, card, vehicle, and date range for the ETC area pass or Shuyu Pass record you need to review. Prepare to cross-check official registration details against usage records.',
        },
        {
          t: 'Check toll and discount rules on official highway operator sites',
          d: "Verify route, toll amounts, vehicle class, discount eligibility, ETC-only gates, and road-specific rules on each highway operator's official site first.",
        },
        {
          t: 'Obtain usage records via ETC Meisai Service or card statement',
          d: "Download usage certificates, PDF, or CSV records from the ETC Meisai Service, or review usage line items on your card issuer's statement.",
        },
        {
          t: 'Record trip details in a consistent format',
          d: 'Log usage date, entry IC, exit IC, ETC card, vehicle, vehicle class, driver or department, and purpose in a consistent internal format.',
        },
        {
          t: 'Keep official records and internal notes separate',
          d: 'Official usage records show actual travel history; internal notes document expense purposes and approval information. Keep both clearly separated but stored together.',
        },
        {
          t: 'Contact official support for unclear items',
          d: 'If records are incomplete, delayed, unexpected, or inconsistent, do not guess. Contact the relevant highway operator or card issuer, and store responses with the records.',
        },
      ],
      commonProblems: [
        {
          q: 'Pass usage showing regular toll charges',
          a: 'Cross-check pass registration details, eligible vehicle class, card, validity period, and eligible sections against official confirmation materials. Depending on record timing, pre-pass statements may appear. Contact the operator for clarification.',
        },
        {
          q: 'Usage record dates or sections differ from memory',
          a: 'Re-confirm entry IC, exit IC, date-time, and vehicle in official records, and check with the driver or passengers. Memory error or another vehicle is possible. If unclear, contact the operator or card company.',
        },
        {
          q: 'Should I save PDF or CSV records?',
          a: 'Saving both is recommended. PDF records are easier to view and share; CSV records suit sorting, filtering, and importing into accounting systems. Use each format according to your needs.',
        },
        {
          q: 'Can I use these records directly for expense or tax purposes?',
          a: "Records serve as reference materials for expense and tax review, but final handling must follow your employer's rules, accountant's advice, and official guidance. This guide is not tax advice.",
        },
      ],
      examples: [
        {
          who: 'Business trip driver',
          use: 'After using an ETC Shuyu Pass, gathers official usage certificate and pass confirmation documents for expense reimbursement, checking which official sources to review.',
        },
        {
          who: 'Corporate accounting team',
          use: 'Exports PDF and CSV records monthly, cross-checks usage line items against internal vehicle and department assignments, and queries relevant departments for unclear items.',
        },
        {
          who: 'Family with multiple vehicles',
          use: 'Separates personal and business travel from ETC card records, organizing official usage statements and internal notes before sending to accountant.',
        },
        {
          who: 'Vehicle manager',
          use: 'Upon discovering unfamiliar trips, checks official ETC usage records, then queries drivers for context, treating the item as a review flag.',
        },
      ],
      faqs: [
        {
          q: 'Is JTR the official highway information source for this topic?',
          a: 'No. JTR is an independent service. For official routes, tolls, discounts, settings, and safety rules, consult each highway operator or official ETC service. JTR helps you receive, organize, store, and review usage records.',
        },
        {
          q: 'Does ETC Meisai Service replace highway operator sites?',
          a: 'No. ETC Meisai Service is convenient for obtaining ETC card usage statements and certificates, but the latest route, toll, discount, lane, and vehicle class rules must be verified on highway operator sites.',
        },
        {
          q: 'Should I save PDF or CSV records?',
          a: 'Both are useful. PDF records are easy to view and share; CSV records suit sorting, filtering, and importing into accounting systems. Use each format according to your needs.',
        },
        {
          q: 'Can I use these records for tax or expense purposes?',
          a: "They can serve as review materials for tax and expense purposes, but final handling must follow your employer's rules, accountant's advice, and official guidance. This guide is not tax advice.",
        },
        {
          q: 'What should I do if amounts or routes appear incorrect?',
          a: 'Review official records and cross-check card, vehicle, usage date, and IC information. If the issue persists, contact the relevant highway operator or card issuer.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How JTR Works',
          desc: 'Understand the flow of receiving, organizing, storing, and reviewing ETC usage records, and learn how to securely manage official records alongside internal notes.',
          path: '/how-it-works',
        },
        {
          title: 'Business Plans',
          desc: 'Review support for multiple vehicles, cards, and departmental assignments, plus bulk PDF and CSV export and administrator review features.',
          path: '/business',
        },
        {
          title: 'Security',
          desc: 'Review how official ETC records are handled, stored, access-controlled, and kept independent, ensuring secure record management practices.',
          path: '/security',
        },
      ],
      references: [
        {
          label: 'ETC Meisai Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service providing ETC card usage inquiry, usage certificate issuance, and PDF/CSV format usage statement downloads. Regular ETC card records cover the past 15 months.',
        },
        {
          label: 'ETC General Information Portal: ETC Meisai Service',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Explains eligible card types, usage certificate issuance, regular ETC card record period, ETC Corporate card record period, wireless/non-wireless ETC usage, and PDF/CSV download.',
        },
        {
          label: 'NEXCO Central Hayatabi Drive Plan FAQ',
          url: 'https://hayatabi.c-nexco.co.jp/drive/faq/',
          note: 'Official NEXCO Central drive plan FAQ. Verify vehicle class eligibility and rental car usage conditions.',
        },
        {
          label: 'Driveplaza Toll & Route Search',
          url: 'https://www.driveplaza.com/dp/SearchTop',
          note: 'Toll and route search service for NEXCO expressways and related routes.',
        },
        {
          label: 'NEXCO West Toll & Route Search',
          url: 'https://search.w-nexco.co.jp/',
          note: 'Official NEXCO West toll and route search service.',
        },
      ],
      longBody: 'ETC touring passes and area passes are discount schemes that allow unlimited travel within designated zones for a fixed period, offered by NEXCO companies and regional expressway operators to promote tourism and distribute traffic. The system has a long history, dating back to paper coupon eras, but with ETC-only implementation, pre-registration and on-board unit number linking have become standard, making post-use statement verification increasingly important. Touring passes typically have strict requirements for eligible vehicle types, application deadlines, usage periods, and IC coverage; failing to meet even one condition results in standard toll charges. When reviewing statements afterward, it is therefore necessary to distinguish pass-applied entries from standard charges and cross-check against official application confirmation documents. The ETC utilization inquiry service is the official portal that retrieves up to fifteen months of travel history per card in PDF or CSV format, yet the statements themselves often do not show pass names or discount rationale in detail, requiring users to verify entry IC, exit IC, timestamp, and vehicle class against eligible ranges. Particularly when rental cars or company vehicles share a single card among multiple drivers, if no one records who drove for what purpose, accounting staff cannot make determinations weeks later when reviewing statements. Corporate ETC cards allow inquiries for up to sixty-two months from the travel date, but because card issuer monthly statements and ETC inquiry service records differ in display format and update timing, a in-depth picture sometimes emerges only by comparing both. JTR is not an entity that generates official toll data; it is an independent service that receives user-obtained statements and presents them in an organized, stored, and easily reviewable form. By using JTR, operations can centralize both PDF and CSV records, group them by vehicle or card, and detect unexpected travel early. However, when questions about amounts or routes arise, the principle is to contact the road company or card issuer directly; JTR remains positioned to assist with record organization and confirmation. Final decisions on tax processing and reimbursement eligibility must follow the rules of accountants, employers, and governing institutions. The most common failure in post-pass statement management is relying only on screenshots or handwritten notes, letting months pass without obtaining official proof-of-use documents, and missing the inquiry deadline. Cases also occur where multiple vehicles share one card, leaving no way to determine which vehicle matched the pass-eligible type. To prevent such trouble, the most reliable approach is to note entry IC, exit IC, timestamp, vehicle number, driver, and purpose immediately after travel, maintaining a state that allows cross-checking against official statements.',
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: '周遊パス明細の記録フロー',
            intro: '申込から保管まで5つの主要ステップ',
            nodes: [
              {
                title: 'パス申込',
                desc: 'ドライブプラン・周遊パスを申込、確認書を保存',
              },
              {
                title: 'ETC通行',
                desc: '登録カード・車両で対象エリア内を走行',
              },
              {
                title: '照会取得',
                desc: 'ETC利用照会サービスでPDF・CSV記録を取得',
              },
              {
                title: '記録統合',
                desc: '申込確認・利用明細・社内メモを一元管理',
              },
              {
                title: '精算対応',
                desc: '経理処理・承認・後日確認に備えて保管',
              },
            ],
          },
          en: {
            title: 'Area Pass Record Flow',
            intro: '5 key steps from application to storage',
            nodes: [
              {
                title: 'Apply Pass',
                desc: 'Reserve drive plan, save confirmation',
              },
              {
                title: 'ETC Transit',
                desc: 'Drive in target area with registered card/vehicle',
              },
              {
                title: 'Fetch Records',
                desc: 'Download PDF/CSV from ETC inquiry service',
              },
              {
                title: 'Consolidate',
                desc: 'Merge application, usage, internal notes',
              },
              {
                title: 'Settlement',
                desc: 'Store for accounting, approval, future review',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '公式記録の入手元',
            intro: '周遊パス記録に必要な4つの情報源',
            sources: [
              {
                name: '道路事業者公式サイト',
                role: 'パス申込・確認書・適用条件',
                url: 'expressway-pass.jp (例)',
                scope: '申込確認・プラン詳細',
              },
              {
                name: 'ETC利用照会サービス',
                role: '利用証明書・PDF/CSV明細',
                url: 'etc-meisai.jp',
                scope: '過去15ヶ月の通行記録',
              },
              {
                name: 'カード会社',
                role: '月次請求明細',
                url: 'card-statement',
                scope: '課金確認・支払い証跡',
              },
              {
                name: '社内システム',
                role: '目的・車両・運転者メモ',
                url: 'internal',
                scope: '業務説明・配分根拠',
              },
            ],
          },
          en: {
            title: 'Official Record Sources',
            intro: '4 information sources for area pass records',
            sources: [
              {
                name: 'Toll Operator Site',
                role: 'Pass application & confirmation',
                url: 'expressway-pass.jp (example)',
                scope: 'Booking proof, plan details',
              },
              {
                name: 'ETC Inquiry Service',
                role: 'Usage certificate, PDF/CSV',
                url: 'etc-meisai.jp',
                scope: '15-month transit history',
              },
              {
                name: 'Card Issuer',
                role: 'Monthly billing statement',
                url: 'card-statement',
                scope: 'Charge confirmation, payment proof',
              },
              {
                name: 'Internal System',
                role: 'Purpose, vehicle, driver notes',
                url: 'internal',
                scope: 'Business justification, allocation',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '手動管理 vs JTR自動配信',
            intro: '記録整理の手間と確実性を比較',
            columns: [
              '手動管理',
              'JTR自動配信',
            ],
            rows: [
              {
                feature: 'PDF/CSV取得',
                a: '毎回ログイン・検索',
                b: '設定後は自動配信',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'カード別整理',
                a: '手作業で分類',
                b: 'タグで自動分類',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '記録漏れ防止',
                a: '忘れるリスク高',
                b: '定期配信で確実',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '複数担当共有',
                a: '転送・印刷が必要',
                b: '複数宛先設定可',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '初期設定',
                a: '不要',
                b: 'カード登録必要',
                kindA: 'yes',
                kindB: 'partial',
              },
            ],
          },
          en: {
            title: 'Manual vs JTR Auto-Delivery',
            intro: 'Compare effort and reliability',
            columns: [
              'Manual Mgmt',
              'JTR Auto-Delivery',
            ],
            rows: [
              {
                feature: 'PDF/CSV fetch',
                a: 'Login & search each time',
                b: 'Auto after setup',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Card grouping',
                a: 'Manual sorting',
                b: 'Auto-tag by card',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Missing records',
                a: 'High forget risk',
                b: 'Scheduled delivery',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Multi-staff share',
                a: 'Forward/print needed',
                b: 'Multi-recipient setup',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Initial setup',
                a: 'None',
                b: 'Card registration',
                kindA: 'yes',
                kindB: 'partial',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '周遊パス記録の5大チェック項目',
            intro: '後日トラブルを防ぐ確認ポイント',
            items: [
              {
                text: 'パス申込確認書を保存したか',
                hint: '割引適用の証拠として必須',
              },
              {
                text: '登録カード・車両が一致しているか',
                hint: '異なると割引適用外になる場合あり',
              },
              {
                text: '利用日時が対象期間内か',
                hint: 'パス有効期限外は通常料金',
              },
              {
                text: 'ETC利用照会でPDF/CSV取得済みか',
                hint: 'カード明細だけでは詳細不明',
              },
              {
                text: '社内メモに目的・経路を記入したか',
                hint: '数ヶ月後の質問対応に備える',
              },
            ],
          },
          en: {
            title: '5 Essential Pass Record Checks',
            intro: 'Prevent future disputes with these steps',
            items: [
              {
                text: 'Saved pass confirmation?',
                hint: 'Required proof of discount eligibility',
              },
              {
                text: 'Card & vehicle match registration?',
                hint: 'Mismatch may void discount',
              },
              {
                text: 'Usage within valid period?',
                hint: 'Outside dates = regular toll',
              },
              {
                text: 'Downloaded PDF/CSV from ETC inquiry?',
                hint: 'Card statement alone lacks detail',
              },
              {
                text: 'Noted purpose & route internally?',
                hint: 'Prepare for questions months later',
              },
            ],
          },
        },
      },
    ],
  },

  // 8) 障がい者割引とETC利用明細の確認ポイント
  {
    slug: 'shougaisha-warikibi-etc-meisai-guide',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: '障害者割引 ETC 明細',
      en: 'disability discount ETC statement',
    },
    ja: {
      title: '障害者割引とETC明細の確認方法 – JTR利用記録配信',
      metaDesc: '障害者割引が適用されたETC走行の利用明細を確認し、記録を保管する実務フローを解説。事前登録手順、ETC利用照会サービスでの割引適用後金額の確認、PDF利用証明書・CSV明細の保存、福祉・医療目的の通院記録管理、独立サービスJTRが日次配信で支援できる範囲までまとめました。',
      h1: '障害者割引とETC明細の確認・記録管理',
      primaryKeyword: '障害者割引 ETC 明細',
      answer: '障害者割引を利用したETC走行後は、公式のETC利用照会サービスで利用証明書を発行し割引後の金額を確認できます。JTRは公式システムが生成した走行記録の受信・整理を支援するサービスで、割引の適用判定や登録手続きには関与しません。家族介護者や支援スタッフが月次の記録整理を行う際、PDF・CSVの自動配信により記録漏れを減らせます。',
      whyMatters: '障害者割引に関する登録要件・証明書の提示・対象道路・適用条件は公式の制度に基づくため、走行前の確認と走行後の記録確認が重要です。公式照会サービスでは通常のETCカードは15か月、ETCコーポレートカードは62日間の照会期間があり、その間に利用証明書や明細のダウンロードを行います。家計管理・通院記録・福祉支援の記録整理において、走行ごとの手作業ダウンロードは負担が大きく、記録の抜け漏れや形式の不統一が起こりやすいため、配信の自動化が役立ちます。',
      officialBackground: 'DrivePlazaの公式案内によれば、障害者割引制度は通勤・通学・通院など日常生活に必要な移動を支援する目的で設けられており、ETC利用時は利用証明書に割引後の金額が記載されます。割引の適用には事前の登録手続きや証明書類の携行が求められる場合があり、料金所スタッフの指示に従う必要があります。ETC利用照会サービス(etc-meisai.jp)は走行後の利用明細・利用証明書をPDFまたはCSV形式でダウンロードできる公式サービスで、通常カードは15か月、法人カードは62日の照会期間が設定されています。走行記録の確認は利用者自身の責任で行い、割引額・対象路線・適用期間などの最新情報は公式サイトで確認する必要があります。',
      whoFor: [
        '障害者割引を利用して通院・通学などの移動記録を整理する本人・家族',
        '家族の介護送迎を担当し月次の通行料を確認する介護者',
        '福祉支援の一環として利用者の移動記録を説明する市区町村スタッフ',
        '複数枚のETCカードを管理し経費精算・家計簿に記録を反映する事業者・家庭',
      ],
      jtrSolution: {
        intro: 'JTRは公式のETC利用照会サービスが生成した走行記録を受信・整理する独立サービスです。割引適用の判定や登録手続きには関与せず、走行後の記録配信・保管・閲覧の自動化を支援します。',
        bullets: [
          '走行後にPDF利用証明書とCSV明細を自動でメール配信、ダウンロード忘れを防止',
          'カード別・車両別・月別に記録を整理し、家族や担当者間での共有がスムーズ',
          '日英対応の画面で外国籍の家族や支援スタッフも記録を確認可能',
          '公式サイトの照会期間内に記録を受信・保存し長期アーカイブを実現',
          '割引額の記載された明細をそのまま保管、会計・精算・家計簿への転記を効率化',
        ],
      },
      pdfCsv: 'PDF利用証明書は人が読みやすく提出書類として使いやすい形式、CSVは表計算ソフトで集計・並べ替え・月次比較に適した形式です。事業者・家計管理・福祉記録では両方を保存し、用途に応じて使い分けることを推奨します。',
      email: 'JTRは走行後に登録メールアドレス宛へPDF・CSVを自動送信します。受信メールをフォルダ分けして保管すれば、カード・月・車両ごとの記録が整理され、後日の確認や会計処理がスムーズになります。',
      steps: [
        {
          t: '公式の障害者割引登録要件を確認',
          d: 'DrivePlazaなど公式サイトで障害者割引の対象条件・登録手続き・必要書類を確認します。JTRは登録や資格判定を行いません。',
        },
        {
          t: '必要な証明書類または登録情報を携行',
          d: '走行時には公式ルールに従い、手帳・アプリ・登録証など必要な書類を携行します。料金所スタッフから確認を求められる場合があります。',
        },
        {
          t: '登録車両と登録ETCプロセスで利用',
          d: '障害者割引が適用される車両・ETCカードの組み合わせで走行します。事前登録が必要な場合は公式手続きを完了させておきます。',
        },
        {
          t: 'スタッフ対応が必要な場合は指示に従う',
          d: '料金所でスタッフ対応レーンを利用する場合や、書類確認が必要な場合は、係員の指示に従い必要情報を提示します。',
        },
        {
          t: '走行後に利用明細で割引額を確認',
          d: 'ETC利用照会サービスで利用証明書や明細を確認し、割引後の金額が記載されているかチェックします。公式記録が最終的な証拠です。',
        },
        {
          t: 'JTRで記録を整理・保管(資格判定用途ではない)',
          d: 'JTRは走行後の明細PDF・CSVを受信・保管する補助ツールです。割引適用の可否判定や公式証明の発行はできません。',
        },
      ],
      commonProblems: [
        {
          q: '料金見積りと実際の利用明細を混同してしまう',
          a: 'ドライブコンパスなどの見積りは参考値です。割引適用の最終確認はETC利用照会サービスの利用証明書で行い、PDF・CSVを保管してください。',
        },
        {
          q: 'すべての割引が自動適用されると思い込む',
          a: '障害者割引には事前登録・証明書携行・対象道路の条件があります。自動適用されない場合もあるため、公式ルールを事前に確認してください。',
        },
        {
          q: 'スクリーンショットのみ保存して正式記録を取得しない',
          a: '会計や補助申請では公式PDF・CSVが必要な場合が多くあります。画面キャプチャではなく、ETC利用照会サービスから正式ファイルを取得してください。',
        },
        {
          q: 'JTRを公式のNEXCO・明細サービスだと誤解する',
          a: 'JTRは独立した記録配信サービスです。料金決定・割引判定・ポイント管理・公式証明発行は行いません。公式情報は各運営元サイトで確認してください。',
        },
      ],
      examples: [
        {
          who: '家族介護者',
          use: '通院や日常移動のETC明細を毎月確認し、割引後の料金が正しく記録されているかチェックします。JTRメールで記録を整理。',
        },
        {
          who: '割引対象の運転者',
          use: '公式条件を満たした走行後、利用証明書で割引後金額を確認。家計簿用にJTRのPDF・CSVを保管します。',
        },
        {
          who: '自治体支援担当者',
          use: '利用者に対し、割引適用は公式手続きが必要であること、JTRは記録保管の補助ツールであることを説明します。',
        },
        {
          who: '家計管理担当',
          use: '複数カードの明細をJTRメールで受信し、家族の移動コストを整理。公式の割引ルールは別途確認します。',
        },
      ],
      faqs: [
        {
          q: '障害者割引とETC明細で最も重要なポイントは?',
          a: '割引適用は公式の登録・証明・条件確認が必要で、JTRは走行後の明細整理を補助するツールという点です。資格判定や公式証明はJTRでは行いません。',
        },
        {
          q: 'JTRは公式のETC利用照会サービスを代替できますか?',
          a: 'いいえ。JTRは独立サービスで、明細の受信・整理を支援します。料金・割引・ポイント・資格判定は公式サイトと道路事業者が管理します。',
        },
        {
          q: 'PDFとCSVのどちらを保管すべきですか?',
          a: '可能であれば両方保管してください。PDFは人間が確認しやすく、CSVは並べ替え・集計・会計ソフト連携に適しています。',
        },
        {
          q: '料金や割引額は日付や条件で変わりますか?',
          a: 'はい。道路・日時・車種・ルート・登録状況・公式キャンペーンなどにより料金と割引適用条件が変わる場合があります。最新情報は公式サイトで確認してください。',
        },
        {
          q: '企業利用と個人利用で記録管理の違いはありますか?',
          a: '企業ではカード・車両・部門・精算ルールを紐付け、PDF・CSVを共有保管する体制が推奨されます。法人ETCカードは照会期間が62日と短い点に注意してください。',
        },
      ],
      relatedFeatures: [
        {
          title: '仕組みを理解する',
          desc: 'JTRがETC利用照会サービスと連携し、PDF・CSV明細を自動配信する流れを確認できます。',
          path: '/how-it-works',
        },
        {
          title: '個人向けプラン',
          desc: '家族や個人のETC明細を整理し、通院・日常移動の記録管理を簡単にします。',
          path: '/personal',
        },
        {
          title: 'セキュリティとプライバシー',
          desc: 'JTRが機密性の高い通行記録をどのように保護しているかを説明します。',
          path: '/security',
        },
      ],
      references: [
        {
          label: 'DrivePlaza 障害者割引とETC',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_handicapped/',
          note: '公式の障害者割引案内。利用証明書に割引後金額が記載されること、証明書携行が必要な場合があることを説明。',
        },
        {
          label: 'DrivePlaza 割引制度概要',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: '通勤・通学・通院など日常生活の移動を支援する障害者割引制度の公式概要。',
        },
        {
          label: 'ETCシステム利用規程',
          url: 'https://www.driveplaza.com/etc/etc_guide/etc_rule/detail.html',
          note: '障害者割引処理に関連するレーンやスタッフ対応の公式ルール。',
        },
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETC利用履歴の確認、利用証明書発行、PDF・CSV取得が可能な公式照会サービス。',
        },
        {
          label: 'ETC総合情報ポータル 利用照会サービス案内',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '一般ETCカードは15カ月、法人ETCカードは62日間の照会期間。PDF・CSV取得に関する公式説明。',
        },
      ],
      longBody: '日本の高速道路における障害者割引制度は、通勤、通学、通院といった日常生活に必要な移動を支援する公的な仕組みとして運用されています。ETC利用時にこの割引を適用するには、事前の登録手続き、所定の証明書の携帯、登録された車両とETCカードの組み合わせなど、公式に定められた条件を満たす必要があります。割引が適用されるかどうかの判定、割引率の決定、対象道路や期間の設定はすべて道路事業者や関係機関が管理しており、Japan Toll Receiptsはその公式プロセスには関与しません。JTRの役割は、走行後に公式システムが生成した利用明細や利用証明書を受け取り、整理・保管する支援を提供することです。障害者割引に関する最新の適用条件や登録方法については、NEXCO各社のDrivePlazaやETC利用照会サービスなど公式サイトで確認することが不可欠です。走行後、利用証明書を確認する際には、割引後の金額が正しく反映されているかをチェックすることが推奨されます。公式のETC利用照会サービスでは、通常のETCクレジットカードやETCパーソナルカードであれば過去15か月分の利用履歴を照会でき、PDF形式とCSV形式の両方でダウンロードが可能です。一方、ETCコーポレートカードは照会期間が62日間と短いため、記録が必要な場合は早めの取得が求められます。PDF形式の記録は人間が確認しやすく、書類として提出する際に適していますが、CSV形式は複数のカードや車両、部署ごとの集計や月次の突合作業に向いています。家族介護者や福祉支援担当者が通院などの移動記録を整理する際にも、両方の形式を保管しておくと後々の確認が容易になります。JTRは公式システムが発行した利用明細データを受け取り、メールで定期的に配信することで、利用者が手動でダウンロード作業を繰り返す手間を軽減します。ただし、JTRは割引の適用可否を判定したり、公式な利用証明書を発行したりする機能は持っていません。あくまで記録の受信と整理を支援する独立したサービスです。障害者割引に関する記録を扱う際には、個人の尊厳と公式手続きの正確性を最優先し、必要に応じて自治体の窓口や道路事業者の案内に従うことが大切です。JTRを利用する場合も、公式サイトで最新の割引条件や登録状況を確認し、走行後の利用証明書と照らし合わせながら、記録を整理する補助ツールとして活用する姿勢が適切です。割引適用の最終判断は公式システムが行い、JTRはその結果としての明細を整理する役割を担います。',
    },
    en: {
      title: 'Disability Discount & ETC Statement Check – JTR Records',
      metaDesc: 'How to verify disability-discounted ETC trips and retain records. Official inquiry service vs. JTR roles, plus PDF & CSV retention tips.',
      h1: 'Disability Discount & ETC Statement Review',
      primaryKeyword: 'disability discount ETC statement',
      answer: 'After an ETC trip using the disability discount, you can issue a usage certificate through the official ETC Inquiry Service to confirm the discounted toll. JTR is a separate service that receives and organizes trip records generated by the official system—it does not determine discount eligibility or handle registration procedures. When family caregivers or support staff organize monthly records, automatic PDF and CSV delivery helps reduce missed entries.',
      whyMatters: 'Disability discount registration requirements, certificate presentation, eligible roads, and eligibility conditions are governed by official programs, making pre-trip confirmation and post-trip record review essential. The official inquiry service retains regular ETC card records for 15 months and ETC Corporate card records for 62 days, during which users must download usage certificates and statements. For household budgets, medical travel logs, and welfare support documentation, manual download of each trip creates a heavy workload and often leads to missing records or inconsistent formats; automated delivery addresses these challenges.',
      officialBackground: 'According to DrivePlaza official guidance, the disability discount program supports daily mobility for commuting, school, medical appointments, and similar needs; when using ETC, the usage certificate shows the discounted amount. Discount eligibility requires advance registration and may require carrying supporting documents; tollbooth staff instructions must be followed. The ETC Meisai Inquiry Service (etc-meisai.jp) is the official platform for downloading post-trip statements and usage certificates in PDF or CSV format, with a 15-month retention window for regular cards and 62 days for corporate cards. Users are responsible for verifying their own trip records, and the latest information on discount amounts, eligible routes, and validity periods must be confirmed on official sites.',
      whoFor: [
        'Individuals and families using the disability discount who organize travel records for medical visits, school, and other trips',
        'Caregivers responsible for family transportation who verify monthly toll charges',
        'Municipal welfare staff who document user mobility as part of support services',
        'Businesses and households managing multiple ETC cards and reconciling expenses or household budgets',
      ],
      jtrSolution: {
        intro: 'JTR is an independent service that receives and organizes trip records generated by the official ETC Inquiry Service. It does not determine discount eligibility or handle registration—it automates post-trip record delivery, storage, and review.',
        bullets: [
          'Automatically emails PDF usage certificates and CSV statements after each trip, preventing download oversights',
          'Organizes records by card, vehicle, and month for smooth sharing among family members and support staff',
          'Bilingual interface (Japanese/English) enables foreign-national family members and support workers to review records',
          'Receives and stores records within the official inquiry window, enabling long-term archiving',
          'Preserves statements showing discount amounts as-is, streamlining accounting, reimbursement, and household budget entry',
        ],
      },
      pdfCsv: 'PDF usage certificates are human-readable and well-suited for submission as documentation; CSV is ideal for spreadsheet aggregation, sorting, and month-over-month comparison. Businesses, household managers, and welfare record-keepers are encouraged to retain both formats and select the appropriate one for each use case.',
      email: 'JTR automatically sends PDF and CSV files to your registered email address after each trip. By sorting incoming messages into folders, you organize records by card, month, and vehicle, making later review and accounting processes smoother.',
      steps: [
        {
          t: 'Check official disability discount eligibility requirements',
          d: 'Verify eligibility conditions, registration procedures, and required documents on official sites like DrivePlaza. JTR does not perform registration or eligibility determination.',
        },
        {
          t: 'Carry necessary proof documents or registration information',
          d: 'When driving, carry required documents such as disability handbooks, apps, or registration certificates according to official rules. Tollbooth staff may request verification.',
        },
        {
          t: 'Use registered vehicle and registered ETC process',
          d: 'Drive with the vehicle and ETC card combination eligible for disability discount. If pre-registration is required, finish official procedures in advance.',
        },
        {
          t: 'Follow instructions when staff assistance is needed',
          d: 'When using staffed lanes at toll plazas or when document verification is required, follow attendant instructions and present necessary information.',
        },
        {
          t: 'Verify discount amount in usage details after driving',
          d: 'Check usage certificates and details via ETC Inquiry Service to confirm discounted amounts are recorded. Official records are the final proof.',
        },
        {
          t: 'Organize and store records with JTR (not for eligibility determination)',
          d: 'JTR is a support tool for receiving and storing post-trip PDF and CSV details. It cannot determine discount eligibility or issue official certificates.',
        },
      ],
      commonProblems: [
        {
          q: 'Confusing fare estimates with actual usage details',
          a: 'Estimates from tools like Drive Compass are reference values. Final discount confirmation must be done via ETC Inquiry Service usage certificates; save PDF and CSV files.',
        },
        {
          q: 'Assuming all discounts apply automatically',
          a: 'Disability discounts require pre-registration, carrying proof, and meeting eligible road conditions. Not all discounts apply automatically, so check official rules beforehand.',
        },
        {
          q: 'Saving only screenshots without obtaining official records',
          a: 'Accounting and subsidy applications often require official PDF and CSV files. Obtain formal files from ETC Inquiry Service rather than relying on screen captures.',
        },
        {
          q: 'Misunderstanding JTR as official NEXCO or inquiry service',
          a: 'JTR is an independent record delivery service. It does not handle fare determination, discount eligibility, point management, or official certificate issuance. Verify official information on operator sites.',
        },
      ],
      examples: [
        {
          who: 'Family caregiver',
          use: 'Checks ETC details monthly for medical visits and daily trips to confirm discounted fares are recorded correctly. Organizes records via JTR email.',
        },
        {
          who: 'Eligible driver',
          use: 'After driving under official conditions, verifies discounted amounts on usage certificates. Stores JTR PDF and CSV for household budgeting.',
        },
        {
          who: 'Municipal support staff',
          use: 'Explains to users that discount eligibility requires official procedures, and that JTR is a support tool for record storage only.',
        },
        {
          who: 'Household budget manager',
          use: 'Receives details from multiple cards via JTR email to organize family travel costs. Checks official discount rules separately.',
        },
      ],
      faqs: [
        {
          q: 'What is the most important point about disability discounts and ETC details?',
          a: 'Discount eligibility requires official registration, proof, and condition checks. JTR is a tool that assists with organizing post-trip details; it does not perform eligibility determination or issue official certificates.',
        },
        {
          q: 'Can JTR replace the official ETC Inquiry Service?',
          a: 'No. JTR is an independent service that supports receiving and organizing details. Fares, discounts, points, and eligibility determination are managed by official sites and road operators.',
        },
        {
          q: 'Should I store PDF or CSV files?',
          a: 'Store both if possible. PDFs are easy for humans to review, while CSVs are suitable for sorting, aggregation, and accounting software integration.',
        },
        {
          q: 'Do fares and discount amounts change by date or conditions?',
          a: 'Yes. Fares and discount eligibility can vary by road, time, vehicle class, route, registration status, and official campaigns. Check official sites for the latest information.',
        },
        {
          q: 'Are there differences in record management for corporate vs. personal use?',
          a: 'Corporations should establish systems linking cards, vehicles, departments, and settlement rules, with shared PDF and CSV storage. Note that corporate ETC cards have a shorter 62-day inquiry period.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How It Works',
          desc: 'Learn how JTR integrates with ETC Inquiry Service to automatically deliver PDF and CSV details.',
          path: '/how-it-works',
        },
        {
          title: 'Personal Plans',
          desc: 'Simplify organizing ETC details for family and personal medical visits and daily travel record management.',
          path: '/personal',
        },
        {
          title: 'Security & Privacy',
          desc: 'Explains how JTR protects sensitive toll transaction records.',
          path: '/security',
        },
      ],
      references: [
        {
          label: 'DrivePlaza Disability Discounts and ETC',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_handicapped/',
          note: 'Official disability discount guidance. Explains that usage certificates show discounted amounts and that carrying proof may be required.',
        },
        {
          label: 'DrivePlaza Discount Programs Overview',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: 'Official overview of disability discount programs supporting daily travel for commuting, school, and medical visits.',
        },
        {
          label: 'ETC System Usage Regulations',
          url: 'https://www.driveplaza.com/etc/etc_guide/etc_rule/detail.html',
          note: 'Official rules regarding lanes and staff assistance related to disability discount processing.',
        },
        {
          label: 'ETC Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official inquiry service for checking ETC usage history, issuing usage certificates, and obtaining PDF and CSV files.',
        },
        {
          label: 'ETC Portal Inquiry Service Guide',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Official explanation of inquiry periods: 15 months for personal ETC cards, 62 days for corporate cards. Details on PDF and CSV retrieval.',
        },
      ],
      longBody: "Japan's expressway disability discount system operates as a public framework designed to support essential daily travel for commuting, attending school, and visiting medical facilities. To apply this discount when using ETC, drivers must in-depth advance registration procedures, carry designated certificates, and satisfy officially established conditions including the combination of registered vehicle and ETC card. Determination of discount eligibility, calculation of discount rates, and designation of applicable roads and periods are all managed by road operators and related agencies; Japan Toll Receipts does not participate in that official process. JTR's role is to receive, organize, and help store usage statements and proof-of-use records generated by the official system after travel has occurred. For the latest eligibility criteria and registration methods regarding disability discounts, it is essential to consult official sources such as the DrivePlaza sites operated by the NEXCO companies and the ETC Usage Inquiry Service. After travel, when reviewing proof-of-use documents, it is advisable to verify that the discounted amounts are correctly reflected. The official ETC Usage Inquiry Service allows holders of standard ETC credit cards and ETC Personal Cards to retrieve up to fifteen months of usage history, available for download in both PDF and CSV formats. In contrast, ETC Corporate Cards have a shorter inquiry window of sixty-two days, so timely retrieval is necessary when records are required. PDF records are well suited for human review and for submission as documentation, while CSV format is better adapted to aggregation across multiple cards, vehicles, or departments, as well as monthly reconciliation tasks. For family caregivers and welfare support staff organizing travel records for medical visits and similar purposes, retaining both formats facilitates later verification. JTR receives usage statement data issued by the official system and delivers it periodically by email, reducing the need for users to perform repeated manual downloads. However, JTR does not determine discount eligibility or issue official proof-of-use certificates; it remains an independent service supporting only the receipt and organization of records. When handling records related to disability discounts, it is paramount to prioritize personal dignity and the accuracy of official procedures, and to follow guidance from municipal offices or road operators as needed. Even when using JTR, the appropriate approach is to confirm the latest discount conditions and registration status on official websites, cross-reference records with post-travel proof-of-use documents, and treat JTR as a supplementary tool for organizing records. Final decisions on discount application are made by the official system, while JTR serves to organize the resulting statements.",
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: '障害者割引ETC走行の記録フロー',
            intro: '走行から記録保管までの4ステップ',
            nodes: [
              {
                title: 'ETC走行',
                desc: '障害者割引適用で通行',
              },
              {
                title: '公式照会',
                desc: 'ETC利用照会サービスで明細生成',
              },
              {
                title: 'JTR配信',
                desc: 'PDF・CSVを自動メール送信',
              },
              {
                title: '記録保管',
                desc: '月別・カード別に整理',
              },
            ],
          },
          en: {
            title: 'Disability Discount ETC Record Flow',
            intro: '4 steps from toll passage to archive',
            nodes: [
              {
                title: 'ETC passage',
                desc: 'Drive with discount applied',
              },
              {
                title: 'Official query',
                desc: 'Statement generated by ETC service',
              },
              {
                title: 'JTR delivery',
                desc: 'Auto-email PDF & CSV',
              },
              {
                title: 'Archive',
                desc: 'Organize by month & card',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '公式情報ソースと役割分担',
            intro: '割引制度と記録サービスは異なる運営主体です',
            sources: [
              {
                name: 'DrivePlaza',
                role: '障害者割引制度の案内',
                url: 'driveplaza.com',
                scope: '対象路線・適用条件・登録手続き',
              },
              {
                name: 'ETC利用照会サービス',
                role: '走行後の明細・証明書発行',
                url: 'etc-meisai.jp',
                scope: '15か月(通常)・62日(法人)照会',
              },
              {
                name: 'JTR',
                role: '記録の自動配信・整理',
                url: 'japantollreceipts.jp',
                scope: 'PDF・CSV受信・保管・共有',
              },
            ],
          },
          en: {
            title: 'Official Sources & Responsibilities',
            intro: 'Discount system and record delivery have separate operators',
            sources: [
              {
                name: 'DrivePlaza',
                role: 'Disability discount program',
                url: 'driveplaza.com',
                scope: 'Eligibility, routes, registration',
              },
              {
                name: 'ETC Query Service',
                role: 'Post-passage statements',
                url: 'etc-meisai.jp',
                scope: '15mo (personal) / 62d (corporate)',
              },
              {
                name: 'JTR',
                role: 'Auto-delivery & archiving',
                url: 'japantollreceipts.jp',
                scope: 'PDF/CSV receipt, storage, sharing',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: 'PDF vs CSV 記録形式の使い分け',
            intro: '用途に応じて両方を保存',
            columns: [
              'PDF利用証明書',
              'CSV明細',
            ],
            rows: [
              {
                feature: '割引額の記載',
                a: '明確に表示',
                b: '項目として記録',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: '書類提出',
                a: 'そのまま提出可',
                b: '要加工',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: '表計算ソフト',
                a: '手入力必要',
                b: '直接インポート',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '月次集計',
                a: '目視確認',
                b: '自動計算',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'PDF vs CSV Format Use Cases',
            intro: 'Save both for different purposes',
            columns: [
              'PDF certificate',
              'CSV detail',
            ],
            rows: [
              {
                feature: 'Discount shown',
                a: 'Clearly displayed',
                b: 'Recorded field',
                kindA: 'yes',
                kindB: 'yes',
              },
              {
                feature: 'Document submit',
                a: 'Ready to use',
                b: 'Needs processing',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: 'Spreadsheet',
                a: 'Manual entry',
                b: 'Direct import',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Monthly totals',
                a: 'Visual review',
                b: 'Auto-calc',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '記録整理の5つのポイント',
            intro: '家族・介護者・支援スタッフ向けチェックリスト',
            items: [
              {
                text: '割引登録が事前に完了しているか',
                hint: '公式サイトで手続き状況を確認',
              },
              {
                text: '走行後15か月以内に記録を取得',
                hint: '法人カードは62日と短い',
              },
              {
                text: 'JTR自動配信でダウンロード忘れ防止',
                hint: 'メールフォルダで月別整理',
              },
              {
                text: 'PDFは書類保管、CSVは集計用',
                hint: '両方を保存して用途別に活用',
              },
              {
                text: '家族・スタッフ間で記録を共有',
                hint: '日英画面で多言語対応',
              },
            ],
          },
          en: {
            title: '5 Record Management Tips',
            intro: 'Checklist for families, caregivers & support staff',
            items: [
              {
                text: 'Discount registration completed',
                hint: 'Verify status on official site',
              },
              {
                text: 'Retrieve records within 15 months',
                hint: 'Corporate cards: only 62 days',
              },
              {
                text: 'JTR auto-delivery prevents missed downloads',
                hint: 'Organize emails by month',
              },
              {
                text: 'PDF for filing, CSV for totals',
                hint: 'Save both for different uses',
              },
              {
                text: 'Share records with family & staff',
                hint: 'Bilingual interface available',
              },
            ],
          },
        },
      },
    ],
  },

  // 9) 大口・多頻度割引と法人ETC管理
  {
    slug: 'oguchi-tahindo-warikibi-houjin-etc-kanri',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: '大口 多頻度 割引 法人 etc 管理',
      en: 'bulk frequency discount corporate etc management',
    },
    ja: {
      title: '大口・多頻度割引の法人ETC管理ガイド | Japan Toll Receipts',
      metaDesc: 'ETC大口・多頻度割引を利用する法人（建設・物流・タクシー）向けに、ETCコーポレートカードでの利用明細管理を解説。割引率・上限・契約条件、ETC利用照会サービス（過去62日制約）からのPDF利用証明書・CSV明細取得、車両別・部署別の集計、独立サービスJTRの日次配信を併用した記録運用までまとめました。',
      h1: '大口・多頻度割引の法人ETC管理ガイド',
      primaryKeyword: '大口 多頻度 割引 法人 etc 管理',
      answer: '大口・多頻度割引は、法人ETCカード・契約条件・車両台数・利用量に基づく公式ビジネス向け割引制度です。運送会社・物流企業・経理担当者は、通常の走行記録と割引適用資格を分けて管理し、予想割引額と確定請求額を混同しないよう注意が求められます。公式なETC利用記録と社内説明を一緒に保管することで、後日の確認作業が容易かつ安全になります。',
      whyMatters: '法人の大口・多頻度割引管理では、どのカードが課金されたか、どの車両が通行したか、どの区間を利用したか、なぜその走行が発生したか、公式証拠がどこに保管されているかという5つの基本情報が不可欠です。これらが揃っていないと、数週間後や数か月後に利用明細を説明することが困難になり、精算・ドライバー照会・部門配分・不正利用の疑いが生じた際に対応が遅れる恐れがあります。公式利用明細・PDF出力・CSV出力・カード明細・社内メモを一体で保管する習慣が、業務効率と内部統制の両面で強い基盤となります。',
      officialBackground: '大口・多頻度割引の適用条件・割引率・対象車両区分・契約手続きはNEXCOやその他の道路事業者が公式に定めており、DrivePlazaやNEXCO西日本の公式ページで最新情報が公開されています。ETC利用照会サービスは法人ETCカード・個人ETCカードの利用明細照会・利用証明書発行・PDF/CSVダウンロードに対応し、通常のETCカードは過去15か月分、ETCコーポレートカードは別途期間設定が適用されます。カード発行会社は月次明細を提供する場合があり、道路事業者サイトは料金・割引・車両区分・安全情報を掲載します。JTRはこれら公式記録の受領・整理・保管・確認作業を支援する独立サービスであり、公式な通行料金データを作成する立場にはありません。利用者は公式照会先と独立支援ツールの役割を正しく理解し、税務・請求・内部監査の最終判断は会計士・雇用主・公式指針に従って行う必要があります。',
      whoFor: [
        '大口・多頻度割引を利用する運送会社の経理担当者',
        '法人ETCカードを複数台の車両で運用する物流企業',
        '高頻度通行記録を月次で集計・報告する車両管理者',
        '割引適用状況と請求額を照合する社内監査チーム',
      ],
      jtrSolution: {
        intro: 'JTRはETC利用記録を実務的な確認フローに変換します。手動検索・印刷・ファイル名変更・転送作業を減らし、受領・整理・保管・確認支援に集中することで、担当者・企業・管理者が記録を容易に理解できるよう支援します。',
        bullets: [
          'PDF・CSV記録を保管し、設定に応じてETCカードや車両ごとにグループ化',
          '確認が求められる記録を強調表示し、早期レビューを促進',
          '利用実績と社内規定の比較作業を支援',
          '通常と異なる記録があれば不正利用の可能性として担当者に提示（法的判定は行わない）',
          '税務・請求・精算処理では記録整理を支援し、最終判断は会計士・雇用主・公式指針に委ねる仕組み',
        ],
      },
      pdfCsv: 'PDF記録は閲覧・共有が容易で、CSV記録は並べ替え・絞り込み・会計システムや社内確認フローへの取り込みに適しています。どちらも用途に応じて活用し、公式照会先から取得した記録と社内説明を一体で保管することが推奨されます。',
      email: 'メール配信を設定すると、月次や週次でPDF・CSV記録を受け取り、手動ログイン回数を減らせます。複数のカードや車両を管理する法人では、定期配信により記録の取りこぼしや遅延確認のリスクを低減し、経理締め日に合わせた運用が可能になります。',
      steps: [
        {
          t: '対象となる利用区分と割引条件を確認',
          d: '大口・多頻度割引は法人ETCカードと契約車両単位による公式割引制度です。通常の利用明細と分けて、契約条件・車両台数・利用量に基づく割引適用状況を管理します。',
        },
        {
          t: '公式の料金・割引条件を道路事業者サイトで確認',
          d: '経路・料金・車種区分・割引適用条件・ETC専用レーンなど道路固有のルールは、該当する公式道路事業者サイトで最初に確認します。',
        },
        {
          t: 'ETC利用照会サービスまたはカード明細で利用記録を取得',
          d: '走行後のETC利用明細・利用証明書・PDFおよびCSV形式の記録は、ETC利用照会サービスまたはカード発行会社の明細サービスから取得します。',
        },
        {
          t: '利用日・IC・カード・車両・部署・目的を統一形式で記録',
          d: '利用日・入口IC・出口IC・ETCカード・車両・車種区分・運転者または部署・利用理由を、社内の一貫した形式で記録します。',
        },
        {
          t: '公式データと社内説明を分離して保管',
          d: '公式の利用明細は通行実績を示し、社内メモは精算目的や承認情報を示します。両者を明確に分けて保管することで、後日の確認が安全かつ容易になります。',
        },
        {
          t: '不明点や不一致があれば公式窓口へ問い合わせ',
          d: '記録が不詳細・遅延・予想外・照合不一致の場合は、推測せず該当する公式道路事業者またはカード発行会社へ問い合わせ、回答を記録と一緒に保管します。',
        },
      ],
      commonProblems: [
        {
          q: '割引適用額が予想と異なる場合はどうすればよいですか?',
          a: '契約条件・利用量・車両台数・利用区分を公式サイトで再確認し、公式のETC利用照会サービスまたはカード明細で実際の請求額と照合します。不明な場合は道路事業者またはカード発行会社へ問い合わせます。',
        },
        {
          q: '複数車両・複数カードの利用記録を効率的に管理するには?',
          a: 'PDF記録で確認しやすくし、CSV記録を用いて車両・カード・部署ごとにフィルタや並べ替えを行います。JTRは記録の整理・保管・確認をサポートしますが、公式記録の作成元ではありません。',
        },
        {
          q: '税務処理や社内精算にこの記録は使えますか?',
          a: '記録は税務や精算の根拠資料として利用できますが、最終的な処理方法は雇用主の規定・税理士の助言・公式ガイダンスに従って確認してください。このガイドは税務助言ではありません。',
        },
        {
          q: '想定外の利用記録が見つかった場合の対応は?',
          a: '公式のETC利用記録で日時・IC・カード・車両を確認し、運転者や部署へ確認依頼を行います。JTRは疑わしい利用を確認対象として示しますが、不正を断定する機能ではありません。',
        },
      ],
      examples: [
        {
          who: '運送会社の経理担当者',
          use: '月末にPDF+CSV形式で利用記録をエクスポートし、社内の車両・部署割当と照合して精算処理を行います。',
        },
        {
          who: '物流企業の車両管理者',
          use: '見慣れない利用記録を確認対象として扱い、公式のETC利用照会サービスで詳細を確認してから運転者へ問い合わせます。',
        },
        {
          who: '複数車両を持つ法人の担当者',
          use: 'ETCカード記録を車両ごとに分類し、業務利用と個人利用を分離してから税理士へ情報を提出します。',
        },
        {
          who: 'レンタカー利用者',
          use: 'レンタル契約書・ETCカード明細・公式利用明細を一緒に保管し、精算パケットの内容を明確にします。',
        },
      ],
      faqs: [
        {
          q: 'JTRは大口・多頻度割引の公式サービスですか?',
          a: 'いいえ。JTRは独立したサービスです。公式の経路・料金・割引・設定・安全ルールは該当する道路事業者または公式ETCサービスで確認してください。JTRは利用記録の受信・整理・保管・確認をサポートします。',
        },
        {
          q: 'ETC利用照会サービスだけで管理は完結しますか?',
          a: 'ETC利用照会サービスはETCカード利用明細と利用証明書の取得に有用ですが、最新の経路・料金・割引・レーン・車種区分ルールは道路事業者サイトでの確認が必要です。',
        },
        {
          q: 'PDFとCSVのどちらを保存すべきですか?',
          a: '両方が有用です。PDF記録は確認・共有が容易で、CSV記録は並べ替え・フィルタ・経理システムへの取り込みに適しています。',
        },
        {
          q: '税務や精算にこの記録を使えますか?',
          a: '税務や精算の根拠資料として利用できますが、最終的な取扱いは雇用主の規定・税理士の助言・公式ガイダンスに従ってください。このガイドは税務助言ではありません。',
        },
        {
          q: '金額や経路が間違っている場合はどうすればよいですか?',
          a: '公式記録を確認し、カード・車両・利用日・IC情報を照合した上で、問題が解決しない場合は該当する道路事業者またはカード発行会社へ問い合わせます。',
        },
      ],
      relatedFeatures: [
        {
          title: '法人向けETC管理機能',
          desc: '複数車両・複数カードの利用記録を整理し、部署別・車両別のレポート作成をサポートします。',
          path: '/business',
        },
        {
          title: 'PDF+CSV一括エクスポート',
          desc: '月次の利用記録をPDFおよびCSV形式で一括取得し、社内システムや経理ワークフローへ取り込めます。',
          path: '/features',
        },
        {
          title: '無料トライアル',
          desc: 'JTRの記録整理・保管・確認機能を試して、自社の管理フローに適合するか確認できます。',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: 'ETCカード利用照会・利用証明書発行・利用明細のPDFまたはCSVダウンロードが可能な公式サービス。通常のETCカード記録は過去15か月分が対象です。',
        },
        {
          label: 'ETC総合情報ポータル: ETC利用照会サービス',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: '対象カード種別・利用証明書発行・通常ETCカード記録期間・ETC法人カード記録期間・無線/非無線利用・PDF/CSVダウンロードについて説明しています。',
        },
        {
          label: 'DrivePlaza 大口・多頻度割引',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_frequency/',
          note: '大口・多頻度割引の公式ガイダンス。契約割引および車両単位割引について説明しています。',
        },
        {
          label: 'NEXCO西日本 大口・多頻度割引',
          url: 'https://www.w-nexco.co.jp/etc/discount/oguchi_tahindo/',
          note: 'NEXCO西日本による大口・多頻度割引およびETC法人カード利用に関する公式ガイダンスです。',
        },
        {
          label: 'NEXCO 車種区分表',
          url: 'https://www.driveplaza.com/traffic/tolls_etc/etc_dis/etc_dis_vehicle.html',
          note: '料金計算および車種区分に関するNEXCO公式ガイダンスです。',
        },
      ],
      longBody: '大口・多頻度割引は、NEXCO各社が提供する法人向けETC割引制度であり、契約単位割引と車両単位割引の二つの体系から構成されています。契約単位割引は、企業が保有する全車両の月間利用額合計に応じて翌月以降に還元される仕組みであり、車両単位割引は個別車両ごとの月間利用額に応じて計算されます。いずれの割引も事前に法人ETCカードの契約が必要であり、個人カードや家族カードは対象外となります。割引率は利用額に応じて段階的に設定されており、高額利用ほど還元率が高まる設計ですが、割引適用の確定は請求確定後となるため、通行時点では割引前の金額が記録されます。このため経理担当者は、ETC利用照会サービスで確認できる通行明細と、カード会社から送付される請求明細書に記載される割引適用後金額とを照合する必要があります。多くの運送会社や物流事業者では、車両ごとの通行記録を社内システムで管理し、月末に割引適用見込み額を試算しますが、実際の割引額は請求書到着まで確定しないため、予測と実績のズレが生じることがあります。特に月をまたぐ通行や、深夜割引・休日割引との併用時には、どの割引が優先適用されたかを明細上で確認しなければ正確な仕訳ができません。JTRは、こうした通行明細のPDF・CSV記録を整理し、車両別・カード別に分類して保管する支援を行いますが、割引適用の判定や請求額の確定はカード発行会社および道路会社が行うものであり、JTRが割引率を計算したり公式記録を作成したりすることはありません。実務上よくある誤りとして、通行明細の金額をそのまま経費計上してしまい、後日届いた請求書の割引適用後金額との差額処理を忘れるケースが挙げられます。また、複数のETCカードを使い分けている企業では、どのカードがどの車両に紐づいているかを記録せず、後から利用者を特定できなくなる事例も少なくありません。こうした混乱を防ぐには、通行日・入口IC・出口IC・ETCカード・車両番号・利用部署・利用目的を一つの記録として残し、公式の利用明細と社内メモを分離して保管することが重要です。不明な通行が発見された場合は、推測で処理せず、ETC利用照会サービスまたはカード発行会社に問い合わせて公式記録を確認し、その回答を記録とともに保存してください。',
    },
    en: {
      title: 'Corporate ETC Management for Bulk & Frequency Discounts | JTR',
      metaDesc: 'In-depth guide for corporate ETC record management under bulk & frequent-use discount programs. Official inquiry sources, PDF/CSV records, JTR support, FAQs, and key considerations.',
      h1: 'Corporate ETC Management for Bulk & Frequency Discounts',
      primaryKeyword: 'bulk frequency discount corporate etc management',
      answer: 'Bulk and frequent-use discounts are official business-focused discount schemes based on corporate ETC cards, contract conditions, fleet size, and usage volume. Carriers, logistics firms, and accounting staff must manage regular toll records separately from discount eligibility, and avoid confusing estimated discount amounts with finalized invoices. Storing official ETC usage records alongside internal explanations ensures that later verification work remains straightforward and secure.',
      whyMatters: 'Managing bulk & frequency discounts requires five fundamental pieces of information: which card was charged, which vehicle traveled, which segment was used, why that journey occurred, and where the official evidence is stored. Without these, explaining statements weeks or months later becomes difficult, delaying responses to settlement, driver inquiries, department allocation, or suspected misuse. The habit of storing official statements, PDF exports, CSV exports, card invoices, and internal notes together builds a strong foundation for both operational efficiency and internal control.',
      officialBackground: 'Eligibility conditions, discount rates, vehicle classifications, and contract procedures for bulk & frequent-use discounts are officially defined by NEXCO and other road operators, with current information published on DrivePlaza and NEXCO West official pages. The ETC Usage Inquiry Service supports corporate and personal ETC card statement lookup, usage certificate issuance, and PDF/CSV downloads; regular ETC cards cover the past 15 months, while ETC Corporate Cards have separate retention periods. Card issuers may provide monthly statements, and road operator sites publish toll, discount, vehicle classification, and safety information. JTR is an independent service supporting receipt, organization, storage, and review of these official records—it does not create authoritative toll data. Users must correctly understand the roles of official inquiry sources and independent support tools, and final decisions for tax, billing, and internal audit must follow accountants, employers, and official guidelines.',
      whoFor: [
        'Accounting staff at carriers using bulk & frequent-use discount programs',
        'Logistics companies operating corporate ETC cards across multiple vehicles',
        'Vehicle managers compiling and reporting high-frequency toll records monthly',
        'Internal audit teams reconciling discount application status with invoices',
      ],
      jtrSolution: {
        intro: 'JTR converts ETC usage records into a practical review workflow. By reducing manual search, printing, file renaming, and forwarding tasks and focusing on receipt, organization, storage, and review support, JTR helps staff, companies, and managers understand records with ease.',
        bullets: [
          'Store PDF & CSV records and group them by ETC card or vehicle as configured',
          'Highlight records requiring review and encourage early examination',
          'Support comparison of usage data against internal policies',
          'Present unusual records as possible misuse for staff attention (without legal determination)',
          'Assist record organization for tax, billing, and settlement work, leaving final judgment to accountants, employers, and official guidelines',
        ],
      },
      pdfCsv: 'PDF records are easy to view and share, while CSV records suit sorting, filtering, and importing into accounting systems or internal review workflows. Both formats should be used according to need, and storing records obtained from official inquiry sources together with internal explanations is recommended.',
      email: 'Configuring email delivery allows you to receive PDF & CSV records monthly or weekly, reducing manual login frequency. For companies managing multiple cards and vehicles, scheduled delivery lowers the risk of missed records or delayed review, and enables operation aligned with accounting close dates.',
      steps: [
        {
          t: 'Verify eligible usage types and discount conditions',
          d: 'Volume/frequency discounts are official discount schemes based on corporate ETC cards and registered vehicles. Manage discount application status separately from regular usage records, based on contract terms, fleet size, and usage volume.',
        },
        {
          t: 'Check official toll rates and discount conditions on road operator sites',
          d: 'Route-specific rules—rates, vehicle classification, discount eligibility, ETC-only lanes—must first be verified on the relevant official road operator website.',
        },
        {
          t: 'Obtain usage records via ETC Meisai Service or card statements',
          d: "Post-journey ETC usage statements, certificates, and PDF/CSV records are retrieved from the ETC Meisai Service or your card issuer's statement service.",
        },
        {
          t: 'Record date, IC, card, vehicle, department, and purpose in unified format',
          d: 'Record usage date, entry IC, exit IC, ETC card, vehicle, vehicle class, driver or department, and usage reason in a consistent internal format.',
        },
        {
          t: 'Store official data and internal notes separately',
          d: 'Official usage statements show transit facts; internal notes show settlement purpose or approval information. Keeping them clearly separate makes later review safe and straightforward.',
        },
        {
          t: 'Contact official support for unclear or mismatched items',
          d: "When records are incomplete, delayed, unexpected, or don't reconcile, do not guess—contact the relevant road operator or card issuer, and store the response with your records.",
        },
      ],
      commonProblems: [
        {
          q: 'What should I do if the discount amount differs from my expectation?',
          a: 'Reconfirm contract terms, usage volume, fleet size, and usage type on the official site, then cross-check actual charges against the ETC Meisai Service or card statement. If still unclear, contact the road operator or card issuer.',
        },
        {
          q: 'How can I efficiently manage records for multiple vehicles and cards?',
          a: 'Use PDF records for easy review and CSV records to filter and sort by vehicle, card, or department. JTR helps organize, store, and review records but is not the creator of official records.',
        },
        {
          q: 'Can I use these records for tax filings or internal reimbursement?',
          a: "Records can serve as supporting documentation for tax or reimbursement purposes, but final treatment must follow your employer's policies, accountant's advice, and official guidance. This guide is not tax advice.",
        },
        {
          q: 'How should I respond to unexpected usage records?',
          a: 'Check date, IC, card, and vehicle in the official ETC records, then ask the driver or department for confirmation. JTR flags questionable usage for review but does not determine fraud.',
        },
      ],
      examples: [
        {
          who: 'Accounting staff at a shipping company',
          use: 'At month-end, export usage records in PDF + CSV format, cross-check against internal vehicle and department assignments, and process reimbursement.',
        },
        {
          who: 'Vehicle manager at a logistics firm',
          use: 'Treat unfamiliar usage records as items to review, verify details in the official ETC Meisai Service, then inquire with the driver.',
        },
        {
          who: 'Corporate manager with multiple vehicles',
          use: 'Classify ETC card records by vehicle, separate business from personal use, then submit the information to the accountant.',
        },
        {
          who: 'Rental car user',
          use: 'Store rental contract, ETC card statement, and official usage statement together to keep the reimbursement package clear.',
        },
      ],
      faqs: [
        {
          q: 'Is JTR the official service for volume/frequency discounts?',
          a: 'No. JTR is an independent service. Official routes, rates, discounts, settings, and safety rules are confirmed with the relevant road operator or official ETC service. JTR helps receive, organize, store, and review usage records.',
        },
        {
          q: 'Is the ETC Meisai Service alone enough for in-depth management?',
          a: 'The ETC Meisai Service is useful for retrieving ETC card usage statements and certificates, but current route, rate, discount, lane, and vehicle classification rules must be confirmed on road operator sites.',
        },
        {
          q: 'Should I save PDF or CSV records?',
          a: 'Both are useful. PDF records are easy to review and share; CSV records are suited to sorting, filtering, and importing into accounting systems.',
        },
        {
          q: 'Can I use these records for tax or reimbursement purposes?',
          a: "They can serve as supporting documentation for tax or reimbursement, but final treatment must follow your employer's policies, accountant's advice, and official guidance. This guide is not tax advice.",
        },
        {
          q: 'What should I do if an amount or route appears incorrect?',
          a: 'Verify the official record, cross-check card, vehicle, date, and IC information, and if the issue persists, contact the relevant road operator or card issuer.',
        },
      ],
      relatedFeatures: [
        {
          title: 'Corporate ETC management features',
          desc: 'Organize usage records for multiple vehicles and cards, and support report generation by department or vehicle.',
          path: '/business',
        },
        {
          title: 'PDF + CSV bulk export',
          desc: 'Retrieve monthly usage records in bulk as PDF and CSV formats for import into internal systems or accounting workflows.',
          path: '/features',
        },
        {
          title: 'Free trial',
          desc: "Test JTR's record organization, storage, and review features to see if they fit your company's management workflow.",
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC Meisai Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official service for ETC card usage inquiry, certificate issuance, and PDF/CSV download of usage statements. Regular ETC card records cover the past 15 months.',
        },
        {
          label: 'ETC General Information Portal: ETC Meisai Service',
          url: 'https://www.go-etc.jp/useful/meisai',
          note: 'Explains eligible card types, certificate issuance, record retention periods for regular and corporate ETC cards, wireless/non-wireless usage, and PDF/CSV download.',
        },
        {
          label: 'DrivePlaza Volume/Frequency Discounts',
          url: 'https://www.driveplaza.com/etc/dis/etc_dis_frequency/',
          note: 'Official guidance on volume/frequency discounts. Explains contract discounts and vehicle-based discounts.',
        },
        {
          label: 'NEXCO West Japan Volume/Frequency Discounts',
          url: 'https://www.w-nexco.co.jp/etc/discount/oguchi_tahindo/',
          note: 'Official guidance from NEXCO West Japan on volume/frequency discounts and corporate ETC card usage.',
        },
        {
          label: 'NEXCO Vehicle Classification Table',
          url: 'https://www.driveplaza.com/traffic/tolls_etc/etc_dis/etc_dis_vehicle.html',
          note: 'Official NEXCO guidance on toll calculation and vehicle classification.',
        },
      ],
      longBody: 'The High-Volume, High-Frequency Discount is a corporate ETC discount scheme offered by NEXCO group companies, composed of two systems: contract-unit discounts and vehicle-unit discounts. Contract-unit discounts are refunded from the following month onward based on the total monthly usage amount of all vehicles owned by a company, while vehicle-unit discounts are calculated according to the monthly usage amount of each individual vehicle. Both discount types require advance enrollment in a corporate ETC card contract; personal cards and family cards are not eligible. Discount rates are set in tiers according to usage amounts, with higher usage leading to higher refund rates, but discount application is finalized only after billing is confirmed, meaning that amounts recorded at the time of passage reflect pre-discount figures. Accounting personnel must therefore reconcile the passage details visible in the ETC Usage Inquiry Service with the post-discount amounts shown on billing statements sent by card issuers. Many transportation and logistics companies manage vehicle-by-vehicle passage records in internal systems and estimate expected discount amounts at month-end, but because actual discount amounts are not finalized until invoices arrive, discrepancies between projections and results can occur. Particularly when passages span multiple months or when combined with late-night or holiday discounts, accurate journal entries cannot be made unless the statement clearly indicates which discount was applied with priority. JTR supports the organization of such passage detail PDF and CSV records, classifying and storing them by vehicle and by card, but discount determination and billing confirmation are performed by card issuers and road companies; JTR does not calculate discount rates or create official records. A common operational error is booking passage detail amounts directly as expenses and forgetting to process the difference when the post-discount invoice arrives later. In companies that use multiple ETC cards, there are also frequent cases where no record is kept of which card is linked to which vehicle, making it impossible to identify users afterward. To prevent such confusion, it is important to preserve passage date, entry IC, exit IC, ETC card, vehicle number, department, and purpose as a single record, and to store official usage details separately from internal notes. When unidentified passages are discovered, do not process them based on assumptions; instead, contact the ETC Usage Inquiry Service or the card issuer to verify the official record, and save that response together with the record.',
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: '大口・多頻度割引の利用記録フロー',
            intro: '法人ETC管理の4ステップを理解しましょう。',
            nodes: [
              {
                title: '通行発生',
                desc: '車両が高速道路を利用',
              },
              {
                title: '割引適用',
                desc: '条件を満たせば自動割引',
              },
              {
                title: '記録照会',
                desc: '公式サイトでPDF/CSV取得',
              },
              {
                title: '社内保管',
                desc: '利用明細と説明を一体管理',
              },
            ],
          },
          en: {
            title: 'Corporate Discount ETC Flow',
            intro: 'Four steps to manage corporate high-volume discount records.',
            nodes: [
              {
                title: 'Passage',
                desc: 'Vehicle uses expressway',
              },
              {
                title: 'Discount',
                desc: 'Auto-applied if eligible',
              },
              {
                title: 'Query',
                desc: 'Download PDF/CSV from official site',
              },
              {
                title: 'Archive',
                desc: 'Store records with internal notes',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '大口・多頻度割引の公式照会先',
            intro: '各サイトの役割を正しく理解し、記録を取得しましょう。',
            sources: [
              {
                name: 'NEXCO公式',
                role: '割引制度・適用条件の説明',
                url: 'https://www.driveplaza.com/',
                scope: '制度概要・車両区分',
              },
              {
                name: 'ETC利用照会サービス',
                role: '通行記録・利用証明書発行',
                url: 'https://www.etc-meisai.jp/',
                scope: '過去15か月分PDF/CSV',
              },
              {
                name: 'カード発行会社',
                role: '月次請求明細の提供',
                url: '各社サイト',
                scope: '請求額・支払期日',
              },
              {
                name: 'JTR',
                role: '記録整理・保管支援',
                url: 'https://japantollreceipts.jp/',
                scope: '受領・確認フロー支援',
              },
            ],
          },
          en: {
            title: 'Official Corporate Discount Sources',
            intro: "Understand each site's role to retrieve correct records.",
            sources: [
              {
                name: 'NEXCO Official',
                role: 'Discount scheme & eligibility',
                url: 'https://www.driveplaza.com/',
                scope: 'Rules, vehicle classes',
              },
              {
                name: 'ETC Query Service',
                role: 'Usage records & certificates',
                url: 'https://www.etc-meisai.jp/',
                scope: '15-month PDF/CSV',
              },
              {
                name: 'Card Issuer',
                role: 'Monthly billing statements',
                url: 'Issuer sites',
                scope: 'Invoices, due dates',
              },
              {
                name: 'JTR',
                role: 'Record organizing support',
                url: 'https://japantollreceipts.jp/',
                scope: 'Receipt & review workflow',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: 'PDF vs CSV 記録の使い分け',
            intro: '両形式を用途に応じて活用しましょう。',
            columns: [
              'PDF',
              'CSV',
            ],
            rows: [
              {
                feature: '閲覧・共有',
                a: '容易',
                b: '要ツール',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: '並べ替え',
                a: '不可',
                b: '自由',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '会計取込',
                a: '手入力',
                b: '直接取込',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '公式証拠',
                a: '適',
                b: '適',
                kindA: 'yes',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'PDF vs CSV Record Use',
            intro: 'Leverage both formats for different tasks.',
            columns: [
              'PDF',
              'CSV',
            ],
            rows: [
              {
                feature: 'View & Share',
                a: 'Easy',
                b: 'Needs tool',
                kindA: 'yes',
                kindB: 'partial',
              },
              {
                feature: 'Sort/Filter',
                a: 'N/A',
                b: 'Full',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Accounting Import',
                a: 'Manual',
                b: 'Direct',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Official Evidence',
                a: 'Valid',
                b: 'Valid',
                kindA: 'yes',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '大口・多頻度割引の管理チェックリスト',
            intro: '5つの基本情報を揃えて、後日の確認作業を容易にします。',
            items: [
              {
                text: 'どのカードが課金されたか',
                hint: '法人ETCカード番号を記録',
              },
              {
                text: 'どの車両が通行したか',
                hint: '車両番号・ドライバー名を紐付け',
              },
              {
                text: 'どの区間を利用したか',
                hint: '入口・出口・料金所を確認',
              },
              {
                text: 'なぜその走行が発生したか',
                hint: '業務目的・配送先を社内メモに記載',
              },
              {
                text: '公式証拠がどこに保管されているか',
                hint: 'PDF/CSVと社内説明を一体で保管',
              },
            ],
          },
          en: {
            title: 'Corporate Discount Management Checklist',
            intro: 'Capture five key details to simplify future reviews.',
            items: [
              {
                text: 'Which card was charged',
                hint: 'Record corporate ETC card number',
              },
              {
                text: 'Which vehicle passed',
                hint: 'Link vehicle ID & driver name',
              },
              {
                text: 'Which segment was used',
                hint: 'Verify entry, exit, toll gates',
              },
              {
                text: 'Why the trip occurred',
                hint: 'Note business purpose & destination',
              },
              {
                text: 'Where official proof is stored',
                hint: 'Archive PDF/CSV with internal notes',
              },
            ],
          },
        },
      },
    ],
  },

  // 10) ETC割引をカード別・車両別に確認する方法 (replacement for duplicate #10)
  {
    slug: 'etc-warikibi-card-vehicle-betsu-check-howto',
    pathPrefix: 'ja',
    defaultLang: 'ja',
    lastUpdated: '2026-05-17',
    primaryKeyword: {
      ja: 'ETCカード別 割引確認',
      en: 'ETC discount check by card',
    },
    ja: {
      title: 'ETCカード別・車両別に割引適用を確認する方法 | JTR',
      metaDesc: '複数のETCカード・社用車・自家用車を併用する場合に、カード別・車両別に割引適用状況（休日割引・深夜割引・平日朝夕割引・ETC2.0など）を確認する実務手順を解説。ETC利用照会サービスからのCSV明細活用、車載器管理番号での突合、独立サービスJTRで継続的に整理するコツまでカバー。',
      h1: 'ETCカード別・車両別に割引を確認する方法',
      primaryKeyword: 'ETCカード別 割引確認',
      answer: '複数のETCカードや車両を利用する場合、公式記録はカード単位で発行されるため、車両・運転者ごとの割引適用状況を把握しづらくなります。カードと車両の対応表を作成し、ETC利用照会サービスのCSV記録に車両名や部署情報を追加することで、割引結果を実務的に確認できます。JTRは記録の定期配信と整理をサポートし、月次照合作業を軽減します。',
      whyMatters: '公式のETC記録はカード中心ですが、企業や家庭では車両・運転者・部署単位で管理したい場合が多く、このギャップが混乱を生みます。1枚のカードを複数車両で使ったり、1台の車両を複数のカードで利用したりする際、どのカードがどの車両でどの割引を受けたかを把握するには、カード番号・日時・区間・車種・道路事業者・登録状況・明細金額を照合する必要があります。感覚や記憶に頼らず、事実ベースで確認することで誤解や不要な問い合わせを防ぎます。',
      officialBackground: 'ETC利用記録の公式起点はETC利用照会サービスです。このサービスはカード単位で利用明細・利用証明書PDF・CSV記録を提供します。割引ルールは道路事業者・割引種別・対象道路・日時・車種・ETC2.0登録状況により決まり、NEXCOやETC総合情報ポータル、ETCマイレージサービスが公式ルールを公開しています。ETC2.0割引は対応車載器と対象区間が必要で、料金所表示額と最終請求額が異なる場合があります。JTRは独立したサービスであり、NEXCO・MEISAI・ETC利用照会サービス・道路事業者とは無関係です。JTRは公式データを作成・変更せず、記録の整理と配信を支援します。割引判定や払戻保証はJTRの範囲外です。',
      whoFor: [
        '複数のETCカードと車両を共有する家庭',
        '車両別に通行料を確認したい車両管理者',
        '想定した割引が適用されたか確認する経理担当者',
        '法人カード・個人カード・運転者保有カードを比較する企業',
      ],
      jtrSolution: {
        intro: 'JTRは独立した記録配信・整理サービスです。ETC利用記録を定期的にメール配信し、月末まで待たずに記録を受け取れます。車両名や部署情報を付加して整理することで、人手による照合作業を軽減します。',
        bullets: [
          'ETC記録をPDFとCSV形式で定期配信、受信箱に記録を蓄積',
          '車両ニックネーム・ナンバー末尾・運転者・部署をラベル化',
          '月次照合作業の前倒しと抜け漏れ早期発見を支援',
          '公式明細を整理し、割引結果の人的確認を容易に',
          '公式サービスや事業者ルールの確認を前提とした記録整理ツール',
        ],
      },
      pdfCsv: 'JTRはETC記録をPDFとCSV形式で配信します。PDFは書類形式での確認・保管に便利で、CSVは表計算ソフトで並べ替え・フィルタ・集計が可能です。車両名や部署列を追加することで、カード中心の公式記録を実務的な視点で整理できます。',
      email: 'JTRは設定した頻度でETC記録をメール配信します。月末を待たず定期的に受信することで、想定外のカード利用・経路・割引結果を早期に発見でき、運転者への確認や公式サービスへの照会をタイムリーに行えます。受信箱が記録の証跡となり、月次処理を効率化します。',
      steps: [
        {
          t: '使用中のETCカードを全てリスト化',
          d: '家庭または会社で使用している全てのETCカードを洗い出し、カード番号や発行元、名義人を一覧にまとめます。複数枚の管理が必要な場合は台帳化が有効です。',
        },
        {
          t: 'カードと車両・利用者の対応表を作成',
          d: '各ETCカードに対して、普段使用する車両、ドライバー名、部署、用途、ナンバー下4桁などを紐付けた対応表を作成します。実運用に即した分類が重要です。',
        },
        {
          t: '公式明細をCSV形式でダウンロード',
          d: 'ETC利用照会サービスなど公式サービスから、利用明細をCSV形式でダウンロードします。PDF証明書と併せて保管することで検証がしやすくなります。',
        },
        {
          t: 'CSV明細に車両・ドライバー情報を追加',
          d: 'ダウンロードしたCSVに、車両ニックネーム、ドライバー名、部署、利用目的などの列を追加し、カード単位ではなく車両単位での集計・確認を可能にします。',
        },
        {
          t: '割引適用の有無を明細と照合',
          d: '公式明細の請求金額と、期待される割引条件(日時・曜日・路線・車種・登録状況など)を照らし合わせ、割引が正しく適用されたかを確認します。',
        },
        {
          t: 'JTRで日次配信と車両ラベルを活用',
          d: 'JTRの定期配信機能と車両ニックネーム設定を利用することで、月次の突合作業を軽減し、利用記録の整理と確認作業を効率化できます。',
        },
      ],
      commonProblems: [
        {
          q: '割引が適用されていないのはなぜ?',
          a: '走行日時、曜日、路線、車種、登録状況、除外日、カードの種類などが割引条件を満たしていない可能性があります。公式の割引ルールと明細を照合してください。',
        },
        {
          q: '料金所の表示額と請求額が違う',
          a: '一部の割引やETC2.0割引は料金所やETC車載器の表示に反映されない場合があります。公式明細やカード請求で最終金額を確認する必要があります。',
        },
        {
          q: '複数カードで車両ごとの集計ができない',
          a: '公式記録はカード単位のため、車両単位での集計には手作業での紐付けが必要です。JTRの車両ニックネームやCSV追記で整理すると管理が容易になります。',
        },
        {
          q: '期待した割引が記録に出てこない',
          a: 'ポイント還元や後日還元型の割引は、利用明細に即時反映されない場合があります。ETCマイレージサービスや別途プログラムの確認が必要です。',
        },
      ],
      examples: [
        {
          who: '2台の車を持つ家庭',
          use: '2枚のETCカードをどちらの車で使ったか、週末割引がどちらに適用されたかを公式明細の日時・経路・カードで照合し、家計簿に反映する。',
        },
        {
          who: '車両管理者',
          use: '営業車ごとに割引適用の有無を確認し、想定ルートと異なるカード使用や車種の不一致がないかを定期的にチェックする。',
        },
        {
          who: '経理担当者',
          use: 'CSVデータに部署名と車両ニックネームを追加し、記憶に頼らず割引の妥当性を検証。月次レポート作成の負担を軽減する。',
        },
        {
          who: '小規模事業者',
          use: '法人ETCカードが個人車両で使われたか、想定割引が車種や経路変更で変わっていないかを明細とカード履歴で確認する。',
        },
      ],
      faqs: [
        {
          q: 'JTRは割引の適用可否を判定しますか?',
          a: 'いいえ。JTRは独立したサービスであり、割引の判定や決定は行いません。公式の利用記録を整理し、確認作業を支援するツールです。',
        },
        {
          q: 'PDFとCSVの両方を保管すべきですか?',
          a: 'はい。PDFは証明書として保管し、CSVは集計・照合・会計処理に活用できます。用途に応じて使い分けると効率的です。',
        },
        {
          q: '割引ルールは変更されることがありますか?',
          a: 'はい。割引対象日、除外日、対象路線、登録要件などは変更される場合があります。最新の情報は公式の道路会社やサービスサイトで確認してください。',
        },
        {
          q: '期待した割引が無い場合は通常はエラーですか?',
          a: 'いいえ。車種、走行路線、日時、除外日、登録状況、カードの種類、後日還元型などの条件により適用されない場合があります。公式条件を確認してください。',
        },
        {
          q: 'JTRはこのテーマでどう役立ちますか?',
          a: 'JTRはETC利用記録を定期的に整理・配信し、車両やドライバーごとの確認作業を効率化します。公式サービスや道路会社のルールを置き換えるものではありません。',
        },
      ],
      relatedFeatures: [
        {
          title: 'JTRの仕組み',
          desc: 'ETC利用記録の整理と定期配信の仕組みを詳しく解説',
          path: '/how-it-works',
        },
        {
          title: '法人向けプラン',
          desc: '複数車両・複数カードの管理を効率化する法人向け機能',
          path: '/business',
        },
        {
          title: '無料トライアル',
          desc: '実際の配信とCSV出力を試せる無料トライアル',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC利用照会サービス',
          url: 'https://www.etc-meisai.jp/',
          note: '利用記録、PDF、CSVの公式取得元',
        },
        {
          label: 'NEXCO東日本 ETC割引案内',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: '公式割引種別の概要',
        },
        {
          label: 'NEXCO東日本 ETC2.0割引',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'ETC2.0対象路線と確認に関する公式案内',
        },
        {
          label: 'ETC総合情報ポータル ETC2.0',
          url: 'https://www.go-etc.jp/etc2',
          note: 'ETC2.0サービスと特典の公式概要',
        },
        {
          label: 'ETCマイレージサービス',
          url: 'https://www.smile-etc.jp/',
          note: 'ポイント還元と通勤割引の公式サービス',
        },
      ],
      longBody: 'ETC割引の記録は公式にはカード単位で管理されているため、企業や家庭が「どの車両でいくら割引が適用されたか」を確認したい場合、カード記録だけでは実務上の整理が難しいことがあります。特に複数のETCカードを複数の車両で使い回している場合、後日割引の適用状況を確認しようとしても、どのカードがどの車両で使われたのか、どのドライバーが運転していたのかが分からず、経理担当者や管理者が混乱する原因となります。この課題を解決するには、まずETCカードと車両の対応表を社内で整備することが有効です。対応表にはカード番号の下四桁、車両のニックネーム、ナンバープレートの末尾四桁、通常の利用者名、部署名、想定される走行ルートパターンなどを記載しておくと、後日の照合作業が格段に楽になります。この対応表は公式記録を変更するものではなく、あくまで業務上の補助情報として機能します。割引が適用されたかどうかを確認する際は、まず公式のETC利用照会サービスや明細書で実際の走行日時、入口と出口、車種区分、利用したカード、請求金額を確認し、次に対象路線が割引対象であるか、走行時間帯が割引時間に含まれるか、除外日に該当していないかを照らし合わせます。感情的に「割引されていないのはおかしい」と主張する前に、事実ベースで記録を整理することが重要です。企業が複数車両を管理する場合、毎月の記録をフォルダやアーカイブで保管し、PDF証明書、CSV詳細データ、ドライバーからの補足メモ、上長承認記録、特殊な割引事由の説明文書を一式揃えておくと監査や確認作業がスムーズになります。JTRはこの業務フローの中で、整理された記録を定期的にメールで配信する役割を担います。JTRはNEXCO、MEISAI、ETC利用照会サービス、道路会社とは独立したサービスであり、公式の料金データを生成したり、割引の適格性を判定したりするものではありません。JTRが提供するPDFおよびCSV形式の記録を用いて、利用者が車両ニックネームや部署情報を付加し、人間による確認作業を支援する仕組みです。よくある誤解として、ドライバーの記憶だけで割引時間帯を判断する、週末はすべて休日割引が適用されると思い込む、ETC2.0割引がすべての路線で自動適用されると考える、ポイント還元と即時割引を同じ明細行で確認できると期待する、といったものがあります。割引ルールは道路会社ごと、プログラムごとに異なり、除外期間や対象区間、車載器の登録状態、車種区分によって結果が変わるため、常に最新の公式情報を参照することが求められます。企業が社内規程を作成する際は、通行料金の精算には公式のETC利用記録または承認された通行料金書類が必要であること、ドライバーは求めに応じて走行目的、車両、カード、部署情報を提供すること、割引の確認は公式の道路会社ルールと最終記録額に基づいて行うこと、JTR報告書は整理配信およびアーカイブツールとして利用できるが、公式の料金データと適格性判定は公式システムおよび道路会社に帰属することを明記しておくと、後日のトラブルを防ぎやすくなります。車両別の割引確認を効率化するには、公式明細のCSVエクスポート機能を活用し、社内で車両名や部署列を追加した上で並べ替えやフィルタリングを行うことが現実的です。JTRはこの作業の前段階で、記録を受信しやすくし、月末まで待たずに日次で整理された情報を手元に置けるようにすることで、カードと車両の不一致や想定外のルート利用を早期に発見する助けとなります。',
    },
    en: {
      title: 'Check ETC Discounts by Card & Vehicle | JTR',
      metaDesc: "For multi-card, multi-vehicle fleets: how to verify discount application by ETC card and vehicle using CSV, mapping tables, and JTR's sorting tools.",
      h1: 'Verify ETC Discounts by Card & Vehicle',
      primaryKeyword: 'ETC discount check by card',
      answer: 'When using multiple ETC cards and vehicles, official records are issued per card, making it difficult to track discount application by vehicle or driver. By creating a card-to-vehicle mapping table and adding vehicle names or department labels to ETC inquiry service CSV records, you can verify discount results in practical terms. JTR supports scheduled record delivery and sorting to reduce monthly reconciliation effort.',
      whyMatters: 'Official ETC records are card-centric, but businesses and households often need to manage by vehicle, driver, or department—a gap that causes confusion. When one card is shared across multiple vehicles, or one vehicle uses several cards, understanding which card received which discount on which vehicle requires matching card number, date-time, route, vehicle class, road operator, registration status, and itemized amounts. Fact-based verification—rather than memory or assumptions—prevents misunderstandings and unnecessary inquiries.',
      officialBackground: "The official starting point for ETC usage records is the ETC Inquiry Service, which provides usage statements, proof-of-use PDFs, and CSV records on a per-card basis. Discount rules are determined by road operator, discount type, eligible road, date-time, vehicle class, and ETC2.0 registration status; NEXCO, the ETC General Information Portal, and ETC Mileage Service publish official rules. ETC2.0 discounts require compatible OBUs and eligible sections; tollbooth display amounts may differ from final billed amounts. JTR is an independent service, unrelated to NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC Inquiry Service, or road operators. JTR does not create or alter official data; it assists with record sorting and delivery. Discount determination and refund guarantees are outside JTR's scope.",
      whoFor: [
        'Households sharing multiple ETC cards and vehicles',
        'Vehicle managers verifying tolls by vehicle',
        'Accounting staff confirming expected discount application',
        'Companies comparing corporate, personal, and driver-held cards',
      ],
      jtrSolution: {
        intro: 'JTR is an independent record delivery and sorting service. It emails ETC usage records on a schedule, so you receive records before month-end. By adding vehicle names or department labels, JTR reduces manual reconciliation work.',
        bullets: [
          'Scheduled delivery of ETC records in PDF and CSV, building an inbox archive',
          'Label records with vehicle nickname, plate suffix, driver, or department',
          'Bring forward monthly reconciliation and detect gaps early',
          'Organise official statements to simplify human discount verification',
          'Record-sorting tool premised on checking official services and operator rules',
        ],
      },
      pdfCsv: 'JTR delivers ETC records in PDF and CSV formats. PDFs suit document-style review and archiving; CSVs enable sorting, filtering, and aggregation in spreadsheet software. By appending vehicle-name or department columns, you can reshape card-centric official records into a practical, operations-focused view.',
      email: 'JTR emails ETC records at your chosen frequency. Regular delivery—before month-end—lets you spot unexpected card use, routes, or discount outcomes early, enabling timely driver checks or official-service inquiries. Your inbox becomes a record trail, streamlining monthly processing.',
      steps: [
        {
          t: 'List all ETC cards in use',
          d: 'Identify every ETC card used at home or in your company, and compile a list showing card numbers, issuers, and cardholders. A ledger format is effective when managing multiple cards.',
        },
        {
          t: 'Create a card-to-vehicle mapping table',
          d: 'For each ETC card, create a mapping table linking the card to the usual vehicle, driver name, department, purpose, and last four digits of the license plate. Classification aligned with actual operations is key.',
        },
        {
          t: 'Download official statements in CSV format',
          d: 'Download usage statements in CSV format from official services such as ETC Usage Inquiry Service. Storing CSV files alongside PDF certificates makes verification easier.',
        },
        {
          t: 'Add vehicle and driver info to CSV statements',
          d: 'Add columns such as vehicle nickname, driver name, department, and usage purpose to the downloaded CSV, enabling aggregation and verification by vehicle rather than by card alone.',
        },
        {
          t: 'Cross-check discount application against statements',
          d: 'Compare the billed amounts in official statements with the expected discount conditions (date, time, day of week, route, vehicle class, registration status) to confirm whether discounts were correctly applied.',
        },
        {
          t: "Use JTR's daily delivery and vehicle labels",
          d: "Leverage JTR's scheduled delivery and vehicle nickname features to reduce monthly reconciliation workload and streamline the organization and verification of usage records.",
        },
      ],
      commonProblems: [
        {
          q: 'Why was no discount applied?',
          a: 'Possible reasons include travel date/time, day of week, route, vehicle class, registration status, excluded dates, or card type not meeting discount conditions. Cross-check the official discount rules with your statements.',
        },
        {
          q: 'Toll gate display and billed amount differ',
          a: 'Some discounts and ETC2.0 fare reductions are not reflected in the toll gate or onboard unit display. You must verify the final amount in the official statements or card billing.',
        },
        {
          q: 'Cannot aggregate by vehicle with multiple cards',
          a: 'Official records are organized by card, so aggregation by vehicle requires manual mapping. Organizing via JTR vehicle nicknames or CSV annotation makes management easier.',
        },
        {
          q: 'Expected discount does not appear in records',
          a: 'Point rebates and deferred-refund discounts may not appear immediately in usage statements. Check the ETC Mileage Service or separate promotional programs for details.',
        },
      ],
      examples: [
        {
          who: 'Household with two vehicles',
          use: 'Cross-check two ETC cards against official statements by date, route, and card to determine which vehicle was used and which received weekend discounts, then record in household budget.',
        },
        {
          who: 'Vehicle manager',
          use: 'Verify discount application for each company vehicle and periodically check for any card usage on unexpected routes or mismatches between vehicle class and card.',
        },
        {
          who: 'Accounting staff',
          use: 'Add department names and vehicle nicknames to CSV data to verify discount validity without relying on memory, reducing the burden of monthly reporting.',
        },
        {
          who: 'Small business operator',
          use: 'Check whether a corporate ETC card was used in a personal vehicle, and confirm that expected discounts have not changed due to vehicle class or route modifications.',
        },
      ],
      faqs: [
        {
          q: 'Does JTR determine discount eligibility?',
          a: 'No. JTR is an independent service and does not judge or determine discount eligibility. It is a tool to organize official usage records and assist with verification tasks.',
        },
        {
          q: 'Should I keep both PDF and CSV files?',
          a: 'Yes. PDFs serve as certificates for record-keeping, while CSVs are useful for aggregation, reconciliation, and accounting. Using both formats for their respective purposes is efficient.',
        },
        {
          q: 'Do discount rules change over time?',
          a: 'Yes. Eligible dates, excluded dates, target routes, registration requirements, and other conditions may change. typically check the latest information on official road operator and service websites.',
        },
        {
          q: 'Is it an error if an expected discount is missing?',
          a: 'Not necessarily. Discounts may not apply due to vehicle class, route traveled, date/time, excluded dates, registration status, card type, or deferred-refund structures. Confirm the official conditions.',
        },
        {
          q: 'How does JTR help with this topic?',
          a: 'JTR organizes and delivers ETC usage records on a regular basis, streamlining verification tasks by vehicle and driver. It does not replace official services or road operator rules.',
        },
      ],
      relatedFeatures: [
        {
          title: 'How JTR Works',
          desc: 'Detailed explanation of ETC record organization and scheduled delivery',
          path: '/how-it-works',
        },
        {
          title: 'Business Plans',
          desc: 'Corporate features to streamline multi-vehicle and multi-card management',
          path: '/business',
        },
        {
          title: 'Free Trial',
          desc: 'Try actual delivery and CSV export with a free trial',
          path: '/free-trial',
        },
      ],
      references: [
        {
          label: 'ETC Usage Inquiry Service',
          url: 'https://www.etc-meisai.jp/',
          note: 'Official source for usage records, PDF, and CSV',
        },
        {
          label: 'NEXCO East ETC Discount Guide',
          url: 'https://www.driveplaza.com/etc/dis/',
          note: 'Official overview of discount categories',
        },
        {
          label: 'NEXCO East ETC2.0 Discounts',
          url: 'https://www.driveplaza.com/etc/dis/discount_etc2/',
          note: 'Official guidance on ETC2.0 eligible routes and verification',
        },
        {
          label: 'ETC General Information Portal ETC2.0',
          url: 'https://www.go-etc.jp/etc2',
          note: 'Official overview of ETC2.0 services and benefits',
        },
        {
          label: 'ETC Mileage Service',
          url: 'https://www.smile-etc.jp/',
          note: 'Official service for point rebates and commuter discounts',
        },
      ],
      longBody: 'ETC discount records are officially managed on a per-card basis, which can make it difficult for companies and households to determine which vehicle benefited from which discount when cards are shared across multiple vehicles. When several ETC cards are rotated among different vehicles, accounting staff and managers often struggle to trace which card was used in which vehicle and by which driver when reviewing discount application later. To address this challenge, maintaining an internal mapping table that links ETC cards to vehicles is highly effective. The table should include the last four digits of each card number, vehicle nicknames, the last four digits of license plates, usual driver names, department names, and typical route patterns. This mapping table does not alter official records; it serves purely as supplementary business information. When verifying whether a discount was applied, start by consulting the official ETC usage inquiry service or billing statements to confirm the actual travel date and time, entry and exit points, vehicle classification, card used, and billed amount. Then cross-check whether the route is eligible for discounts, whether the travel time falls within discount hours, and whether any exclusion dates apply. Before emotionally insisting that a discount should have been applied, it is important to organize the facts objectively. For companies managing multiple vehicles, archiving monthly records in folders with PDF certificates, CSV detail data, supplementary notes from drivers, supervisor approval records, and explanatory documents for special discount cases streamlines audits and verification work. JTR plays a role in this workflow by delivering organized records via email on a regular basis. JTR is an independent service from NEXCO, ETC Usage Inquiry Service (MEISAI), the ETC usage inquiry service, and road operators; it does not generate official toll data or determine discount eligibility. Users employ the PDF and CSV records provided by JTR to add vehicle nicknames and department information, supporting human review processes. Common misconceptions include relying solely on driver memory to judge discount time slots, assuming all weekends qualify for holiday discounts, believing ETC 2.0 discounts apply automatically on all routes, and expecting point rebates and instant discounts to appear on the same statement line. Discount rules vary by road operator and program, and outcomes depend on exclusion periods, eligible segments, onboard unit registration status, and vehicle classification, so consulting the latest official information is essential. When drafting internal policies, companies should specify that toll reimbursement requires official ETC usage records or approved toll documentation, that drivers must provide trip purpose, vehicle, card, and department details upon request, that discount verification relies on official road operator rules and final billed amounts, and that JTR reports serve as an organizing, delivery, and archiving tool while official toll data and eligibility determinations remain with official systems and road operators. To streamline per-vehicle discount checks, export official statement CSV files, add internal vehicle name and department columns, then sort and filter accordingly. JTR supports this workflow by making records easier to receive and enabling daily access to organized information without waiting until month-end, helping detect card-vehicle mismatches and unexpected route usage early.',
    },
    animations: [
      {
        component: 'TollFlowDiagram',
        labels: {
          ja: {
            title: 'カード別・車両別の割引確認フロー',
            intro: '複数カード・車両を使う場合の割引適用確認手順',
            nodes: [
              {
                title: 'ETC利用照会サービスでカード別記録取得',
                desc: 'カード単位でCSV・PDF明細をダウンロード',
              },
              {
                title: 'カードと車両の対応表を作成',
                desc: '日付・時刻・区間から実際の利用車両を特定',
              },
              {
                title: 'CSV記録に車両名・部署列を追加',
                desc: 'カード中心の公式記録を実務視点で整理',
              },
              {
                title: '割引種別・金額・車種を照合',
                desc: '想定した割引が適用されたか事実ベースで確認',
              },
              {
                title: '差異があれば公式ルール・登録状況を再確認',
                desc: 'ETC2.0登録、対象道路、時間帯条件を検証',
              },
            ],
          },
          en: {
            title: 'Card & Vehicle Discount Verification Flow',
            intro: 'Step-by-step process for multi-card, multi-vehicle discount checks',
            nodes: [
              {
                title: 'Download card-level records from ETC Portal',
                desc: 'Obtain CSV & PDF statements per card',
              },
              {
                title: 'Build card-to-vehicle mapping table',
                desc: 'Match trips to actual vehicles by date, time, route',
              },
              {
                title: 'Add vehicle name & department columns to CSV',
                desc: 'Transform card-centric data into operational view',
              },
              {
                title: 'Cross-check discount type, amount, vehicle class',
                desc: 'Verify expected discounts were applied',
              },
              {
                title: 'Review official rules & registration if discrepancies found',
                desc: 'Validate ETC2.0 status, eligible routes, time windows',
              },
            ],
          },
        },
      },
      {
        component: 'OfficialSourceMap',
        labels: {
          ja: {
            title: '割引確認に必要な公式情報源',
            intro: 'カード・車両・割引の照合に使う公式サービス一覧',
            sources: [
              {
                name: 'ETC利用照会サービス',
                role: 'カード別の利用明細・証明書・CSV記録を提供',
                url: 'etc-meisai.jp',
                scope: '記録の公式起点',
              },
              {
                name: 'NEXCO各社割引案内',
                role: '深夜・休日・ETC2.0割引ルールと対象区間を公開',
                url: 'drivepass.jp 他',
                scope: '割引条件の確認',
              },
              {
                name: 'ETC総合情報ポータル',
                role: '道路事業者横断の割引制度・料金検索',
                url: 'go-etc.jp',
                scope: '制度の横断確認',
              },
              {
                name: 'ETCマイレージサービス',
                role: '登録カード・ポイント・還元額の確認',
                url: 'smile-etc.jp',
                scope: '登録状況の照会',
              },
              {
                name: 'セットアップ店・カーディーラー',
                role: 'ETC2.0車載器の登録状況・車種情報を提供',
                url: '—',
                scope: '車載器登録確認',
              },
            ],
          },
          en: {
            title: 'Official Sources for Discount Verification',
            intro: 'Key services to cross-check card, vehicle, and discount data',
            sources: [
              {
                name: 'ETC Usage Portal',
                role: 'Provides per-card statements, certificates, CSV exports',
                url: 'etc-meisai.jp',
                scope: 'Primary record source',
              },
              {
                name: 'NEXCO Discount Guides',
                role: 'Publishes night, weekend, ETC2.0 discount rules & zones',
                url: 'drivepass.jp etc.',
                scope: 'Discount conditions',
              },
              {
                name: 'ETC General Portal',
                role: 'Cross-operator discount schemes & route fare search',
                url: 'go-etc.jp',
                scope: 'Multi-operator info',
              },
              {
                name: 'ETC Mileage Service',
                role: 'Card registration, points, rebate lookup',
                url: 'smile-etc.jp',
                scope: 'Mileage registration',
              },
              {
                name: 'OBU Setup Shops',
                role: 'ETC2.0 device registration & vehicle class data',
                url: '—',
                scope: 'Device verification',
              },
            ],
          },
        },
      },
      {
        component: 'ComparisonMatrix',
        labels: {
          ja: {
            title: '公式記録 vs. 実務管理の視点',
            intro: 'カード別記録をどう車両別・部署別に変換するか',
            columns: [
              '公式記録（カード中心）',
              '実務管理（車両・部署中心）',
            ],
            rows: [
              {
                feature: '記録単位',
                a: 'ETCカード番号ごと',
                b: '車両名・部署ごと',
                kindA: 'neutral',
                kindB: 'neutral',
              },
              {
                feature: 'CSV列構成',
                a: '日時・区間・金額・車種',
                b: '＋車両名・運転者・部署',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '割引確認',
                a: 'カード単位で合計',
                b: '車両・経路ごとに照合',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: '複数車両共有カード',
                a: '区別できない',
                b: '日時・区間で車両特定',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: '月次照合',
                a: '月末まで待つ',
                b: '定期配信で前倒し',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
          en: {
            title: 'Official Records vs. Operational View',
            intro: 'How to transform card-level data into vehicle/department insights',
            columns: [
              'Official (Card-Centric)',
              'Operational (Vehicle/Dept)',
            ],
            rows: [
              {
                feature: 'Record unit',
                a: 'Per ETC card number',
                b: 'Per vehicle name / dept',
                kindA: 'neutral',
                kindB: 'neutral',
              },
              {
                feature: 'CSV columns',
                a: 'Date, route, amount, class',
                b: '+ vehicle, driver, dept',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Discount check',
                a: 'Card-level totals',
                b: 'Vehicle & route cross-check',
                kindA: 'partial',
                kindB: 'yes',
              },
              {
                feature: 'Shared card usage',
                a: 'Cannot distinguish vehicles',
                b: 'Match by time & route',
                kindA: 'no',
                kindB: 'yes',
              },
              {
                feature: 'Monthly review',
                a: 'Wait until month-end',
                b: 'Periodic delivery, early catch',
                kindA: 'no',
                kindB: 'yes',
              },
            ],
          },
        },
      },
      {
        component: 'ChecklistReveal',
        labels: {
          ja: {
            title: '割引未適用を疑ったときの確認チェックリスト',
            intro: '想定した割引が記録に反映されていない場合の点検項目',
            items: [
              {
                text: 'ETC2.0車載器が対象車両に正しくセットアップされているか',
                hint: '登録車種・ナンバー情報が実車と一致しているか確認',
              },
              {
                text: '通行区間がその割引の対象道路・対象区間に含まれるか',
                hint: '公式の割引対象路線一覧と照合',
              },
              {
                text: '通行日時が割引適用時間帯（深夜・休日等）に該当するか',
                hint: '入口・出口の時刻を公式時間帯定義と照合',
              },
              {
                text: 'ETCマイレージやキャンペーンの事前登録が完了しているか',
                hint: 'カード番号・車載器番号の登録状況を確認',
              },
              {
                text: '料金所表示額と最終請求額を比較し後日還元型割引を考慮したか',
                hint: 'ETC2.0割引など後日適用のケースあり',
              },
              {
                text: '車種区分が割引対象車種（普通車・軽自動車等）に該当するか',
                hint: '車載器登録情報と実際の車種を再確認',
              },
            ],
          },
          en: {
            title: 'Discount Missing? Verification Checklist',
            intro: "Items to review when expected discounts don't appear in records",
            items: [
              {
                text: 'Is the ETC2.0 OBU properly registered to the correct vehicle?',
                hint: 'Check vehicle class & plate match setup data',
              },
              {
                text: 'Does the route fall within the discount-eligible roads & zones?',
                hint: 'Cross-reference official eligible route lists',
              },
              {
                text: 'Does trip date/time match discount hours (night, weekend, etc.)?',
                hint: 'Compare entry/exit timestamps to official time windows',
              },
              {
                text: 'Is the card pre-registered for mileage or campaign programs?',
                hint: 'Verify card & OBU numbers in mileage portal',
              },
              {
                text: 'Did you compare tollbooth display vs. final billed amount?',
                hint: 'Some ETC2.0 discounts apply after the fact',
              },
              {
                text: 'Is the vehicle class (standard, light, etc.) discount-eligible?',
                hint: 'Re-check OBU registration & actual vehicle type',
              },
            ],
          },
        },
      },
    ],
  },
];

export const TIER_H_SLUGS = TIER_H_PAGES.map((p) => p.slug);
